import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { useHistory } from "react-router";
import { endPoints } from "../../config/end-points";
import useHttp from "../../hooks/use-http";

import { authActions } from "../../store/auth";
import { campaignAction } from "../../store/campaign-store";
import { cuteToast } from "../UI/cute";
import LeftEditor from "./Left-editor";
import RightEditor from "./Right-editor";
import LeftContentEditor from "./Left-contentEditor";
import "./editor.scss";

export const HoveDiv = () => {
  const history = useHistory();
  const camp_id = useSelector((state) => state.campaign.camp_id);

  const handleShowVideoUpload = (e) => {
    e.preventDefault();
    history.push(`/campaign/${camp_id}/video-gallery`);
  };

  return (
    <a
      href="#0"
      className="changeImageVideo"
      onClick={(e) => handleShowVideoUpload(e)}
    >
      <img
        src={`${process.env.PUBLIC_URL}/assets/images/edit_hv.png`}
        alt="img"
      />{" "}
      Change Background Video
    </a>
  );
};

const EditorDiv = () => {
  const [showLeftEditor, setShowLeftEditor] = useState(false);
  const [showLeftContentEditor, setShowLeftContentEditor] = useState(false);
  const [textLength, setTextLength] = useState(null);
  const [layers_name, setLayers_name] = useState(null);
  const history = useHistory();
  const [showRightEditor, setShowRightEditor] = useState(false);
  const dynamicText = "";
  const video_preview =
    "https://engageleads-gallery.s3.us-west-2.amazonaws.com/VidAmaze/app-images/video_preview_back_1.png";

  const [sliderDummyData, setSliderDummyData] = useState({
    text: "Premium black leather shoes",
    off: "Off",
    get: "GET",
    discount: "80%",
    color: "color",
    shape_layer1: "#f50a0a",
    shape_layer2: "#ddfa00",
    shape_layer3: "#1331c9",
    website: "www.yourwebsite.com",
    BG_txt: "",
    price: "$20",
    hexColor1: "#f5871f",
    hexColor2: "#e1fb0a",
    hexColor3: "#190afb",
    product_img: process.env.PUBLIC_URL + `/assets/images/product1.jpg`,
  });

  useEffect(() => {
    document.title = `Edit Campaign`;
  });

  const [layersData, setLayersData] = useState({});

  const active_slide_name = useSelector(
    (state) => state.campaign.active_slide_name
  );

  const playMovie = (e) => {
    e.target.play();
    // console.log(e);
    e.target.muted = true;
  };

  const stopMovie = (e) => {
    e.target.pause();
    e.target.load();
  };

  const editSlideData = useSelector((state) => state.campaign.editSlideData);
  const dispatch = useDispatch();
  const camp_id = useSelector((state) => state.campaign.camp_id);

  const video_data = useSelector((state) => state.campaign.video_data);

  const total_duration = useSelector((state) => state.campaign.total_duration);

  const single_slide_data = useSelector(
    (state) => state.campaign.single_slide_data
  );

  const { sendRequest: saveVideoData } = useHttp();

  const toggleLeftshow = (layer_name, e, limit) => {
    setTextLength(limit);
    if (layer_name) {
      // layer_name = layer_name + " " + slideIndex;

      if (layersData.length > 0) {
        // eslint-disable-next-line array-callback-return
        // console.log(layersData.length, "Length");
        // console.log(layer_name);

        layersData.map((layer) => {
          if (layer.name === layer_name) {
            // console.log("Helo callinhg");

            // console.log(layer);

            if (layer.text === undefined && !layer.text) {
              layer.text = e.target.innerText;
            }
            return dispatch(
              campaignAction.setSingleLayerData({
                data: layer,
              })
            );
          }

          return true;
        });
        setShowLeftEditor(!showLeftEditor);
      } else {
        alert("Select Slide first");

        return false;
      }
    }
    setShowLeftEditor(!showLeftEditor);
  };

  const toggleLeftContentshow = (slide_layer_name, e, limit) => {
    setLayers_name(slide_layer_name);
    setTextLength(limit);
    setShowLeftContentEditor(!showLeftContentEditor);
  };

  const toggleRightshow = (layer_name, e) => {
    if (layer_name) {
      // console.log(layersData);
      if (layersData.length > 0) {
        layersData.map((layer) => {
          if (layer.name === layer_name) {
            if (layer.text === undefined && !layer.text) {
              layer.text = e.target.innerText;
            }
            return dispatch(
              campaignAction.setSingleLayerData({
                data: layer,
              })
            );
          }

          return true;
        });
        setShowRightEditor(!showRightEditor);
      } else {
        alert("Select Slide first");

        return false;
      }
    }
    setShowRightEditor(!showRightEditor);
  };

  useEffect(() => {
    // console.log(single_slide_data);
    if (single_slide_data.temp_name) {
      const assets = single_slide_data.assets;
      // console.log(assets);
      var layersData1 = assets.map((layer) => {
        let a = {};

        if (layer.type === "image") {
          a.name = layer.layerName;
          a.src = layer?.src;
          a.default_src = layer?.default_src;

          a.type = layer.type;
        } else {
          a.name = layer.layerName;
          a.text = layer?.text;
          a.type = layer.type;
          a.fontFamily = layer?.fontFamily;
        }
        return a;
      });
      // console.log(layersData1);
      setLayersData(layersData1);
      // setSlideIndex(active_slide_index);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [single_slide_data]);

  useEffect(() => {
    if (editSlideData) {
      // console.log("Hello editor");
      setSliderDummyData(editSlideData);
    }
  }, [editSlideData]);

  useEffect(() => {
    setShowLeftContentEditor(false);
    setShowRightEditor(false);
  }, [active_slide_name]);

  /* Save as Draft */

  const responseHandle = (response) => {
    if (response.status === 1) {
      cuteToast({
        type: "success",
        message: "Campaign",
        timer: 5000,
        title: "Successfully Saved",
      });
      dispatch(authActions.setLoaderStatus({ status: false, loader_text: "" }));
    } else {
      history.push("/campaign/" + camp_id + "/audio");
    }
  };
  const handleSaveData = (e, status) => {
    e.preventDefault();

    var previewData = [...video_data];

    if (previewData.length <= 1) {
      cuteToast({
        type: "error",
        message: "Atleast Two Scene's Required To Save",
        timer: 5000,
        title: "",
      });
      return false;
    }
    dispatch(
      authActions.setLoaderStatus({
        status: true,
        loader_text: "Saving video data..",
      })
    );
    // console.log(video_data);

    saveVideoData(
      {
        url: endPoints.saveDraft,
        method: "POST",
        body: {
          camp_id,
          video_data: JSON.stringify(video_data),
          process_flow: status,
          total_duration
        },
      },
      responseHandle
    );
  };

  /*  apply font family and color */

  const applyCss = (layer_name) => {
    let single_slide_clone = [...single_slide_data.assets];
    let css = {};

    // console.log(layer_name);
    // eslint-disable-next-line array-callback-return
    single_slide_clone.map((ele) => {
      if (ele.layerName === layer_name) {
        let fontFamily = ele.fontFamily;
        // console.log(fontFamily);
        css.color = `rgb(${ele.fontColor})`;

        if (fontFamily.includes("Poppins")) {
          css.fontFamily = `'Poppins', sans-serif`;

          if (fontFamily === "Poppins-ExtraBold") {
            css.fontWeight = 800;
          } else if (fontFamily === "Poppins-ExtraLight") {
            css.fontWeight = 200;
          } else if (fontFamily === "Poppins-SemiBold") {
            css.fontWeight = 600;
          } else if (fontFamily === "Poppins-SemiBoldItalic") {
            css.fontWeight = 600;
            css.fontStyle = "italic";
          } else if (fontFamily === "Poppins-Bold") {
            css.fontWeight = 700;
          } else if (fontFamily === "Poppins-Medium") {
            css.fontWeight = 500;
          } else if (fontFamily === "Poppins-Thin") {
            css.fontWeight = 100;
          } else if (fontFamily === "Poppins-Italic") {
            css.fontStyle = "italic";
            css.fontWeight = 400;
          } else {
            css.fontWeight = 400;
          }
        } else if (fontFamily.includes("Roboto")) {
          css.fontFamily = `'Roboto', sans-serif`;
          if (fontFamily === "Roboto-Black") {
            css.fontWeight = 900;
          } else if (fontFamily === "Roboto-Bold") {
            css.fontWeight = 700;
          } else if (fontFamily === "Roboto-BoldItalic") {
            css.fontWeight = 700;
            css.fontStyle = "italic";
          } else if (fontFamily === "Roboto-Italic") {
            css.fontWeight = 400;
            css.fontStyle = "italic";
          } else {
            css.fontWeight = 500;
          }
        } else if (fontFamily.includes("Ubuntu")) {
          css.fontFamily = `'Ubuntu', sans-serif`;

          if (fontFamily === "Ubuntu-Bold") {
            css.fontWeight = 700;
          } else if (fontFamily === "Ubuntu-Medium") {
            css.fontWeight = 500;
          } else if (fontFamily === "Ubuntu-Italic") {
            css.fontWeight = 400;
            css.fontStyle = "italic";
          }
        } else if (fontFamily.includes("Montserrat")) {
          css.fontFamily = `'Montserrat', sans-serif`;

          if (fontFamily === "Montserrat-Italic") {
            css.fontWeight = 400;
            css.fontStyle = "italic";
          } else if (fontFamily === "Montserrat-Medium") {
            css.fontWeight = 500;
          } else if (fontFamily === "Montserrat-SemiBold") {
            css.fontWeight = 600;
          } else if (fontFamily === "Montserrat-SemiBoldItalic") {
            css.fontWeight = 600;
            css.fontStyle = "italic";
          } else if (fontFamily === "Montserrat-Thin") {
            css.fontWeight = 100;
          } else if (fontFamily === "Montserrat-BoldItalic") {
            css.fontWeight = 700;
            css.fontStyle = "italic";
          } else if (fontFamily === "Montserrat-Bold") {
            css.fontWeight = 700;
          } else {
            css.fontWeight = 400;
          }
        } else if (fontFamily === "Lobster") {
          css.fontFamily = `'Lobster', cursive`;
        } else if (fontFamily.includes("NexaBold")) {
          css.fontFamily = "NexaBold";

          // if (fontFamily === "Nexa-Bold") {
          //   css.fontWeight = 700;
          // } else if (fontFamily === "Nexa-light") {
          //   css.fontWeight = 300;
          // } else {
          //   css.fontWeight = 400;
          // }
        } else if (fontFamily.includes("Play Fair")) {
          css.fontFamily = `'Playfair Display', serif`;

          if (fontFamily === "Play Fair-ExtraBold") {
            css.fontWeight = 800;
          } else if (fontFamily === "Play Fair-SemiBold") {
            css.fontWeight = 600;
          } else if (fontFamily === "Play Fair-Medium") {
            css.fontWeight = 500;
          } else {
            css.fontWeight = 400;
          }
        } else if (fontFamily === "Amanda Signature") {
          css.fontFamily = "amandasignature";
        } else if (fontFamily === "Tw Cen MT") {
          css.fontFamily = "TCB";
        } else if (fontFamily === "Berkshire Swash") {
          css.fontFamily = `'Berkshire Swash', cursive`;
        } else if (fontFamily === "BebasNeueBold") {
          css.fontFamily = "BebasNeueBold";
        } else if (fontFamily === "BebasNeueBook") {
          css.fontFamily = "BebasNeueBook";
        }
      }
      // return true;
    });
    // console.log(css);
    return css;
  };

  const previewvideo = (bg_video) => {
    let css = {};
    let single_slide_clone = [...single_slide_data.assets];
    // eslint-disable-next-line array-callback-return
    single_slide_clone.map((ele) => {
      if (ele.layerName === bg_video) {
        if (ele.src !== ele.default_src) {
          css["backgroundImage"] = `url("${video_preview}")`;
        }
      }
    });

    return css;
  };

  const applyBackGround = (
    property1,
    layer_name = "bg_color",
    default_value = ""
  ) => {
    let css = {};
    let single_slide_clone = [...single_slide_data.assets];

    // eslint-disable-next-line array-callback-return
    single_slide_clone.map((ele) => {
      if (ele.layerName === layer_name) {
        if (property1 === "backgroundColor") {
          css.backgroundColor = ele.text.includes("#")
            ? "#" + ele.text.split("#")[1]
            : "#" + ele.text;
        } else if (property1 === "borderLeft") {
          css.borderLeft = ele.text.includes("#")
            ? "#" + ele.text.split("#")[1] + default_value
            : "#" + ele.text + default_value;
        } else if (property1 === "borderRight") {
          css.borderRight = ele.text.includes("#")
            ? "#" + ele.text.split("#")[1] + default_value
            : "#" + ele.text + default_value;
        }
      }
    });
    // console.log(css);
    return css;
  };

  return (
    <>
      <div className="editor_section row">
        {/* <h4 className="pb-3">
        Editor section
        <small>
          <strong className="text-danger">Note : </strong> Edior section not
          represent final video view
        </small>
      </h4> */}
        {active_slide_name && (
          <div className="rw text-end">
            <a
              href="#0"
              onClick={(e) => {
                handleSaveData(e, 1);
              }}
              className="btn me-3"
            >
              Save & Draft
            </a>
            <a
              href="#0"
              className="btn"
              onClick={(e) => {
                handleSaveData(e, 2);
              }}
            >
              Save & Continue
            </a>
          </div>
        )}
        <div className="es_mid mb-4 mt-3">
          <div className="row">
            <LeftEditor
              show={showLeftEditor}
              toggleLeftshow={toggleLeftshow}
              length={textLength}
            />

            <LeftContentEditor
              show={showLeftContentEditor}
              toggleLeftContentshow={toggleLeftContentshow}
              layers_name={layers_name}
              length={textLength}
            />

            <RightEditor
              show={showRightEditor}
              toggleRightshow={toggleRightshow}
            />

            {active_slide_name === "slide_1" && (
              <div
                className="hoverDiv slide_vid_1 wdh_fix"
                style={{
                  backgroundImage: `url("${sliderDummyData.bg_image}")`,
                }}
              >
                <a
                  href="#0"
                  className="changeImageVideo"
                  onClick={(e) => {
                    toggleRightshow("bg_image", e);
                  }}
                >
                  <img
                    src={`${process.env.PUBLIC_URL}/assets/images/edit_hv.png`}
                    alt="img"
                  />{" "}
                  Change Background Image
                </a>
                <h1
                  className="border m-0 text-uppercase cursor"
                  onClick={(e) => {
                    toggleLeftContentshow("hello", e, "10");
                  }}
                  style={applyCss("hello")}
                >
                  {sliderDummyData.hello}
                </h1>
                <h1 className="dynamic_text">{dynamicText}</h1>
              </div>
            )}

            {active_slide_name === "slide_2" && (
              <div
                className="hoverDiv slide_vid_2 wdh_fix"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div className="row min_h_484">
                  <div className="col-md-6">
                    <div className="slide_left d-flex  justify-content-center p-4 h-100">
                      <div className="rw mt-auto">
                        <div
                          className="border s_content"
                          onClick={(e) => {
                            toggleLeftContentshow(
                              "home A||home B||home C",
                              e,
                              "11||16||10"
                            );
                          }}
                        >
                          <div
                            className="line1 cursor"
                            style={applyCss("home A")}
                          >
                            {sliderDummyData.home_a}
                          </div>
                          <div
                            className="line2 cursor"
                            style={applyCss("home B")}
                          >
                            {sliderDummyData.home_b}
                          </div>
                          <div className="line3" style={applyCss("home C")}>
                            <em>{sliderDummyData.home_c}</em>
                          </div>
                        </div>

                        <div className="border s_content call d-flex align-items-center">
                          <i className="me-2">
                            <img
                              src="https://d37q3r06begyqi.cloudfront.net/VidAmaze/app-images/slides_images/phone.png"
                              className="img-fluid"
                              alt="img"
                            />
                          </i>{" "}
                          <span
                            className=" cursor"
                            onClick={(e) => {
                              toggleLeftContentshow("number", e, "15");
                            }}
                            style={applyCss("number")}
                          >
                            {sliderDummyData.number}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-6 p-0">
                    <div className="rgt_bx h-100 d-flex align-items-center justify-content-center p-5 d-none">
                      <img
                        src="https://d37q3r06begyqi.cloudfront.net/VidAmaze/app-images/slides_images/lock.jpg"
                        className="img-fluid"
                        alt="img"
                      />
                    </div>
                  </div>
                </div>
              </div>
            )}
            {active_slide_name === "slide_3" && (
              <div
                className="hoverDiv slide_vid_3 wdh_fix"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div className="row min_h_484">
                  <div className="col-md-6">
                    <div className="slide_left d-flex align-items-center  justify-content-center p-4 h-100">
                      <div
                        className="border s_content"
                        onClick={(e) => {
                          toggleLeftContentshow(
                            "problem A||bg_color||problem B||problem C",
                            e,
                            "8||0||10||12"
                          );
                        }}
                      >
                        <div
                          className="line1 cursor"
                          style={applyBackGround("backgroundColor", "bg_color")}
                        >
                          <span style={applyCss("problem A")}>
                            {sliderDummyData.problem_a}
                          </span>
                        </div>
                        <div
                          className="line2 cursor"
                          style={applyCss("problem B")}
                        >
                          {sliderDummyData.problem_b}
                        </div>
                        <div
                          className="line3 cursor"
                          style={applyCss("problem C")}
                        >
                          {sliderDummyData.problem_c}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-6 p-0">
                    <div className="rgt_bx h-100 d-flex align-items-center justify-content-center p-5 d-none">
                      <img
                        src="https://d37q3r06begyqi.cloudfront.net/VidAmaze/app-images/slides_images/lock2.jpg"
                        className="img-fluid"
                        alt="img"
                      />
                    </div>
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_4" && (
              <div
                className="hoverDiv slide_vid_4 wdh_fix"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div className="row min_h_484">
                  <div className="col-md-6">
                    <div className="slide_left d-flex align-items-center  justify-content-center p-4 h-100">
                      <div
                        className="border s_content"
                        onClick={(e) => {
                          toggleLeftContentshow(
                            "trust A||trust B||trust C",
                            e,
                            "21||20||18"
                          );
                        }}
                      >
                        <div
                          className="line1 cursor"
                          style={applyCss("trust A")}
                        >
                          {sliderDummyData.trust_a}
                        </div>
                        <div
                          className="line2 cursor"
                          style={applyCss("trust B")}
                        >
                          {sliderDummyData.trust_b}
                        </div>
                        <div
                          className="line3 cursor"
                          style={applyCss("trust C")}
                        >
                          {sliderDummyData.trust_c}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-6 p-0">
                    <div className="rgt_bx h-100 d-flex align-items-center justify-content-center p-5 d-none">
                      <img
                        src="https://d37q3r06begyqi.cloudfront.net/VidAmaze/app-images/slides_images/lock2.jpg"
                        className="img-fluid"
                        alt="img"
                      />
                    </div>
                  </div>
                </div>
              </div>
            )}
            {active_slide_name === "slide_5" && (
              <div
                className="hoverDiv slide_vid_5 d-flex align-items-center justify-content-center wdh_fix"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div
                  className="center border"
                  onClick={(e) => {
                    toggleLeftContentshow(
                      "resolve A||resolve B||resolve C||resolve D||resolve E||resolve F",
                      e,
                      "18||18||2||7||12||11"
                    );
                  }}
                >
                  <div className="f_r_s5 d-flex align-items-end justify-content-between">
                    <div className="cl_1">
                      <p
                        className="txt_1 m-0 cursor"
                        style={applyCss("resolve A")}
                      >
                        {sliderDummyData.resolve_a}
                      </p>
                      <p
                        className="txt_2 m-0 cursor"
                        style={applyCss("resolve B")}
                      >
                        {sliderDummyData.resolve_b}
                      </p>
                    </div>
                    <div className="cl_2 cursor">
                      <span style={applyCss("resolve C")}>
                        {sliderDummyData.resolve_c}
                      </span>
                      <br />
                      <span style={applyCss("resolve F")}>
                        {sliderDummyData.resolve_f}
                      </span>
                    </div>
                  </div>
                  <div className="s_rw_s5">
                    <div className="sr5_t_a cursor">
                      <span style={applyCss("resolve D")}>
                        {sliderDummyData.resolve_d}
                      </span>
                      <br />
                      <span style={applyCss("resolve E")}>
                        {sliderDummyData.resolve_e}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_6" && (
              <div
                className="hoverDiv slide_vid_6 d-flex p-4 align-items-center justify-content-center wdh_fix"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div className="w-100">
                  <div className="row align-items-center">
                    <div className="col-md-4 order-md-2 text-center">
                      <img
                        src="https://d37q3r06begyqi.cloudfront.net/VidAmaze/app-images/slides_images/solutions.jpg"
                        className="img-fluid d-none"
                        alt="img"
                      />
                    </div>

                    <div className="col-md-8 order-md-1">
                      <figcaption
                        className="text-center border"
                        onClick={(e) => {
                          toggleLeftContentshow(
                            "solutions A||solutions B||solutions C",
                            e,
                            "10||22||10"
                          );
                        }}
                      >
                        <div
                          className="text_line1 cursor"
                          style={applyCss("solutions A")}
                        >
                          {sliderDummyData.solution_a}
                        </div>
                        <div
                          className="text_line2 cursor"
                          style={applyCss("solutions B")}
                        >
                          {sliderDummyData.solution_b}
                        </div>
                        <div
                          className="text_line3 cursor"
                          style={applyCss("solutions C")}
                        >
                          {sliderDummyData.solution_c}
                        </div>
                      </figcaption>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_7" && (
              <div
                className="hoverDiv slide_vid_7 wdh_fix"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div className="row min_h_484">
                  <div className="col-md-6">
                    <div className="slide_left d-flex align-items-center  justify-content-center p-4 h-100">
                      <div className="border">
                        <div
                          className=" s_content"
                          onClick={(e) => {
                            toggleLeftContentshow(
                              "contact A||contact B||bg_color",
                              e,
                              "10||24||0"
                            );
                          }}
                          style={applyBackGround(
                            "borderLeft",
                            "bg_color",
                            " 10px solid"
                          )}
                        >
                          <h2
                            className=" m-0 cursor"
                            style={applyCss("contact A")}
                          >
                            {sliderDummyData.contact_a}
                          </h2>
                          <h3
                            className="m-0 cursor "
                            style={applyCss("contact B")}
                          >
                            {sliderDummyData.contact_b}
                          </h3>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-6 p-0">
                    <div className="rgt_bx h-100 d-flex align-items-center justify-content-center p-5">
                      <div className="c_s7">
                        <div className="border secure_logo  mb-4 pb-3">
                          <img
                            src={sliderDummyData.logo}
                            className="img-fluid"
                            alt="img"
                            onClick={(e) => {
                              toggleRightshow("logo", e);
                            }}
                          />
                        </div>
                        <div className="border call d-flex align-items-center mb-4 pb-2 ps-2">
                          <i className="me-2">
                            <img
                              src="https://d37q3r06begyqi.cloudfront.net/VidAmaze/app-images/slides_images/phone.png"
                              alt="img"
                            />
                          </i>
                          <span
                            className="cursor"
                            onClick={(e) => {
                              toggleLeftContentshow("number", e, "15");
                            }}
                            style={applyCss("number")}
                          >
                            {sliderDummyData.number}
                          </span>
                        </div>
                        <div className="border web d-flex align-items-center ps-2">
                          <i className="me-2">
                            <img
                              src="https://d37q3r06begyqi.cloudfront.net/VidAmaze/app-images/slides_images/web.png"
                              alt="img"
                            />
                          </i>
                          <span
                            className="cursor"
                            onClick={(e) => {
                              toggleLeftContentshow("website", e, "35");
                            }}
                            style={applyCss("website")}
                          >
                            {sliderDummyData.website}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_8" && (
              <div
                className="slide_vid_8 wdh_fix hoverDiv position-relative"
                style={{
                  backgroundImage: `url("${sliderDummyData.bg_image}")`,
                }}
              >
                <a
                  href="#0"
                  className="changeImageVideo"
                  onClick={(e) => {
                    toggleRightshow("bg_image", e);
                  }}
                >
                  <img
                    src={`${process.env.PUBLIC_URL}/assets/images/edit_hv.png`}
                    alt="img"
                  />{" "}
                  Change Background Image
                </a>
                <h1
                  className="border m-0 text-uppercase cursor"
                  onClick={(e) => {
                    toggleLeftContentshow("hey", e, "10");
                  }}
                  style={applyCss("hey")}
                >
                  {sliderDummyData.hey}
                </h1>
                <h1 className="dynamic_text">{dynamicText}</h1>
              </div>
            )}

            {active_slide_name === "slide_9" && (
              <div
                className="position-relative hoverDiv slide_vid_9 d-flex align-items-center justify-content-center text-center wdh_fix"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div
                  className="border descrip"
                  onClick={(e) => {
                    toggleLeftContentshow(
                      "pamper A||pamper B||pamper C",
                      e,
                      "15||21||19"
                    );
                  }}
                >
                  <div className="line1 cursor" style={applyCss("pamper A")}>
                    {sliderDummyData.pamper_a}
                  </div>
                  <div className="line2 cursor" style={applyCss("pamper B")}>
                    {sliderDummyData.pamper_b}
                  </div>
                  <div className="line3 cursor" style={applyCss("pamper C")}>
                    {sliderDummyData.pamper_c}
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_10" && (
              <div
                className="hoverDiv position-relative slide_vid_10 d-flex align-items-end p-3 justify-content-center text-center wdh_fix"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div className="descrip mb-5 pb-2">
                  <div
                    className="top_rw mb-5 d-flex align-items-center justify-content-between border"
                    onClick={(e) => {
                      toggleLeftContentshow(
                        "service A||service C||service B",
                        e,
                        "9||11||8"
                      );
                    }}
                  >
                    <div className="cl_1">
                      <p className="m-0 cursor" style={applyCss("service A")}>
                        {sliderDummyData.service_a}
                      </p>
                      <p className="m-0 cursor" style={applyCss("service C")}>
                        {sliderDummyData.service_c}
                      </p>
                    </div>
                    <div className="cl_2 cursor" style={applyCss("service B")}>
                      {sliderDummyData.service_b}
                    </div>
                  </div>
                  <div
                    className="call border"
                    onClick={(e) => {
                      toggleLeftContentshow("number||bg_color", e, "15||0");
                    }}
                    style={applyBackGround("backgroundColor", "bg_color")}
                  >
                    <i className="fa fa-phone"></i>
                    <span className="number cursor" style={applyCss("number")}>
                      {sliderDummyData.number}
                    </span>
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_11" && (
              <div
                className="hoverDiv position-relative slide_vid_11 d-flex align-items-center p-3 justify-content-center text-center wdh_fix"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />

                <div
                  className="descrip text-center border "
                  onClick={(e) => {
                    toggleLeftContentshow("plan A||plan B", e, "18||16");
                  }}
                >
                  <h3 className="m-0 cursor" style={applyCss("plan A")}>
                    {sliderDummyData.plan_a}
                  </h3>
                  <h4 className="m-0 cursor" style={applyCss("plan B")}>
                    {sliderDummyData.plan_b}
                  </h4>
                </div>
              </div>
            )}

            {active_slide_name === "slide_12" && (
              <div
                className="hoverDiv position-relative slide_vid_12 p-1 d-flex align-items-center justify-content-center text-center wdh_fix"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div
                  className="descrip border"
                  onClick={(e) => {
                    toggleLeftContentshow(
                      "customer A||customer B||customer C",
                      e,
                      "13||21||18"
                    );
                  }}
                >
                  <div className="line1 cursor" style={applyCss("customer A")}>
                    {sliderDummyData.customer_a}
                  </div>
                  <div className="line2 cursor" style={applyCss("customer B")}>
                    {sliderDummyData.customer_b}
                  </div>
                  <div className="line3 cursor" style={applyCss("customer C")}>
                    {sliderDummyData.customer_c}
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_13" && (
              <div
                className="hoverDiv position-relative slide_vid_13 p-1 d-flex align-items-center justify-content-center text-center wdh_fix"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div
                  className="descrip border"
                  onClick={(e) => {
                    toggleLeftContentshow("feel A||feel B", e, "18||26");
                  }}
                >
                  <div className="line1 cursor" style={applyCss("feel A")}>
                    {sliderDummyData.feel_a}
                  </div>
                  <div className="line2 cursor" style={applyCss("feel B")}>
                    {sliderDummyData.feel_b}
                  </div>
                </div>
              </div>
            )}
            {active_slide_name === "slide_14" && (
              <div
                className="hoverDiv position-relative slide_vid_14 d-flex align-items-center p-3 justify-content-center text-center wdh_fix"
                style={{
                  backgroundImage: `url("${sliderDummyData.bg_image}")`,
                }}
              >
                <a
                  href="#0"
                  className="changeImageVideo"
                  onClick={(e) => {
                    toggleRightshow("bg_image", e);
                  }}
                >
                  <img
                    src={`${process.env.PUBLIC_URL}/assets/images/edit_hv.png`}
                    alt="img"
                  />{" "}
                  Change Background Image
                </a>

                <div className="descrip ">
                  <div
                    className="spa_logo text-center mb-4 border"
                    onClick={(e) => {
                      toggleRightshow("logo", e);
                    }}
                  >
                    <img
                      src={sliderDummyData.logo}
                      className="img-fluid"
                      alt="img"
                    />
                  </div>
                  <div
                    className="call mb-3 border"
                    onClick={(e) => {
                      toggleLeftContentshow("number||bg_color", e, "15||0");
                    }}
                    style={applyBackGround("backgroundColor", "bg_color")}
                  >
                    <i className="fa fa-phone"></i>
                    <span className="number cursor" style={applyCss("number")}>
                      {sliderDummyData.number}
                    </span>
                  </div>
                  <div
                    className="web border"
                    onClick={(e) => {
                      toggleLeftContentshow("website", e, "30");
                    }}
                  >
                    <i>
                      <img
                        src="https://d37q3r06begyqi.cloudfront.net/VidAmaze/app-images/slides_images/web2.png"
                        className="img-fluid"
                        alt="img"
                      />
                    </i>
                    <span className="cursor" style={applyCss("website")}>
                      {sliderDummyData.website}
                    </span>
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_15" && (
              <div
                className="hoverDiv slide_vid_15 d-flex align-items-center p-3 justify-content-center text-center wdh_fix"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div
                  className="descrip border"
                  onClick={(e) => {
                    toggleLeftContentshow(
                      "business A||business B||business C",
                      e,
                      "14||17||16"
                    );
                  }}
                >
                  <div className="line1 cursor" style={applyCss("business A")}>
                    {sliderDummyData.business_a}
                  </div>
                  <div className="line2 cursor" style={applyCss("business B")}>
                    {sliderDummyData.business_b}
                  </div>
                  <div className="line3 cursor" style={applyCss("business C")}>
                    {sliderDummyData.business_c}
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_16" && (
              <div
                className="hoverDiv slide_vid_16 d-flex align-items-center p-3 justify-content-center text-center wdh_fix"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div
                  className="descrip border"
                  onClick={(e) => {
                    toggleLeftContentshow("expert A||expert B", e, "13||15");
                  }}
                >
                  <div className="line1 cursor" style={applyCss("expert A")}>
                    {sliderDummyData.expert_a}
                  </div>
                  <div className="line2 cursor" style={applyCss("expert B")}>
                    {sliderDummyData.expert_b}
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_17" && (
              <div
                className="hoverDiv slide_vid_17 p-3 wdh_fix"
                style={{
                  backgroundImage: `url("${sliderDummyData.bg_image}")`,
                }}
              >
                <a
                  href="#0"
                  className="changeImageVideo"
                  onClick={(e) => {
                    toggleRightshow("bg_image", e);
                  }}
                >
                  <img
                    src={`${process.env.PUBLIC_URL}/assets/images/edit_hv.png`}
                    alt="img"
                  />{" "}
                  Change Background Image
                </a>
                <h1
                  className="m-0 text-uppercase cursor border"
                  onClick={(e) => {
                    toggleLeftContentshow("hello", e, "10");
                  }}
                  style={applyCss("hello")}
                >
                  {sliderDummyData.hello}
                </h1>
                <h1 className="dynamic_text">{dynamicText}</h1>
              </div>
            )}

            {active_slide_name === "slide_18" && (
              <div
                className="hoverDiv slide_vid_18 p-1 d-flex align-items-center justify-content-center text-center wdh_fix"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div
                  className="descrip text-start border"
                  onClick={(e) => {
                    toggleLeftContentshow(
                      "serve A||serve B||serve C",
                      e,
                      "7||10||10"
                    );
                  }}
                >
                  <div className="line1 cursor" style={applyCss("serve A")}>
                    {sliderDummyData.serve_a}
                  </div>
                  <div className="line2 cursor" style={applyCss("serve B")}>
                    {sliderDummyData.serve_b}
                  </div>
                  <div className="line3 cursor" style={applyCss("serve C")}>
                    {sliderDummyData.serve_c}
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_19" && (
              <div
                className="hoverDiv slide_vid_19 p-4 d-flex align-items-center  wdh_fix"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div className="rw">
                  <div className="row align-items-center">
                    <div className="col-md-6">
                      <div
                        className="descrip border"
                        onClick={(e) => {
                          toggleLeftContentshow(
                            "certified A||certified B||certified C",
                            e,
                            "6||9||13"
                          );
                        }}
                      >
                        <div
                          className="line1 cursor"
                          style={applyCss("certified A")}
                        >
                          {sliderDummyData.certified_a}
                        </div>
                        <div
                          className="line2 cursor"
                          style={applyCss("certified B")}
                        >
                          {sliderDummyData.certified_b}
                        </div>
                        <div
                          className="line3 cursor"
                          style={applyCss("certified C")}
                        >
                          {sliderDummyData.certified_c}
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <img
                        src="https://d37q3r06begyqi.cloudfront.net/VidAmaze/app-images/slides_images/certified.jpg"
                        className="img-fluid d-none"
                        alt="img"
                      />
                    </div>
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_20" && (
              <div
                className="hoverDiv slide_vid_20 p-4 d-flex align-items-center  wdh_fix"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div className="rw">
                  <div className="row ">
                    <div className="col-md-6">
                      <div className="border">
                        <div
                          className="descrip mt-5  "
                          onClick={(e) => {
                            toggleLeftContentshow(
                              "experienced A||experienced B||bg_color",
                              e,
                              "15||11||0"
                            );
                          }}
                          style={applyBackGround(
                            "borderLeft",
                            "bg_color",
                            " 8px solid"
                          )}
                        >
                          <div
                            className="line1 cursor"
                            style={applyCss("experienced A")}
                          >
                            {sliderDummyData.experienced_a}
                          </div>
                          <div
                            className="line2 cursor"
                            style={applyCss("experienced B")}
                          >
                            {sliderDummyData.experienced_b}
                          </div>
                        </div>
                      </div>

                      <div
                        className="call mt-5 pt-4 border"
                        onClick={(e) => {
                          toggleLeftContentshow(
                            "number||bg_color_1",
                            e,
                            "14||0"
                          );
                        }}
                      >
                        <i className="me-2">
                          <img
                            src="https://d37q3r06begyqi.cloudfront.net/VidAmaze/app-images/slides_images/phone2.png"
                            className="img-fluid"
                            alt="img"
                          />
                        </i>
                        <span
                          style={applyBackGround(
                            "backgroundColor",
                            "bg_color_1"
                          )}
                          className="number"
                        >
                          <span style={applyCss("number")}>
                            {sliderDummyData.number}
                          </span>
                        </span>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <img
                        src="https://d37q3r06begyqi.cloudfront.net/VidAmaze/app-images/slides_images/account.jpg"
                        className="img-fluid d-none"
                        alt="img"
                      />
                    </div>
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_21" && (
              <div
                className="hoverDiv slide_vid_21 p-4 d-flex align-items-center justify-content-center  wdh_fix"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div
                  className="rw d-flex align-items-center border"
                  onClick={(e) => {
                    toggleLeftContentshow(
                      "guidance A||guidance B||guidance C",
                      e,
                      "7||17||18"
                    );
                  }}
                >
                  <div className="cl_1">
                    <div
                      className="txt_1 cursor"
                      style={applyCss("guidance A")}
                    >
                      {sliderDummyData.guidance_a}
                    </div>
                  </div>
                  <div className="cl_2">
                    <div
                      className="txt_2 cursor"
                      style={applyCss("guidance B")}
                    >
                      {sliderDummyData.guidance_b}
                    </div>
                    <div
                      className="txt_3 cursor"
                      style={applyCss("guidance C")}
                    >
                      {sliderDummyData.guidance_c}
                    </div>
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_22" && (
              <div
                className="hoverDiv slide_vid_22 p-4 d-flex align-items-center justify-content-center  wdh_fix"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />

                <div
                  className="rw text-center border"
                  onClick={(e) => {
                    toggleLeftContentshow("help A||help B", e, "8||16");
                  }}
                >
                  <div className="line1 cursor" style={applyCss("help A")}>
                    {sliderDummyData.help_a}
                  </div>
                  <div className="line2 cursor" style={applyCss("help B")}>
                    {sliderDummyData.help_b}
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_23" && (
              <div
                className="hoverDiv slide_vid_23 p-4 d-flex align-items-center justify-content-center  wdh_fix"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div
                  className="rw text-center border"
                  onClick={(e) => {
                    toggleLeftContentshow(
                      "assessment A||assessment B||bg_color||assessment C",
                      e,
                      "16||3||0||21"
                    );
                  }}
                >
                  <div className="line1 ">
                    <span
                      className="span1 cursor"
                      style={applyCss("assessment A")}
                    >
                      {sliderDummyData.assessment_a}
                    </span>{" "}
                    <span className="cursor" style={applyCss("assessment B")}>
                      {sliderDummyData.assessment_b}
                    </span>
                  </div>
                  <div
                    className="line2 cursor"
                    style={applyCss("assessment C")}
                  >
                    {sliderDummyData.assessment_c}
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_24" && (
              <div
                className="hoverDiv slide_vid_24 p-4 d-flex align-items-center justify-content-center  wdh_fix"
                style={{
                  backgroundImage: `url("${sliderDummyData.bg_image}")`,
                }}
              >
                <a
                  href="#0"
                  className="changeImageVideo"
                  onClick={(e) => {
                    toggleRightshow("bg_image", e);
                  }}
                >
                  <img
                    src={`${process.env.PUBLIC_URL}/assets/images/edit_hv.png`}
                    alt="img"
                  />{" "}
                  Change Background Image
                </a>
                <div className="rw text-center">
                  <div className="accountant_logo mb-4 pb-3 border">
                    <img
                      src={sliderDummyData.logo}
                      className="img-fluid"
                      alt="img"
                      onClick={(e) => {
                        toggleRightshow("logo", e);
                      }}
                    />
                  </div>
                  <div
                    className="call border"
                    onClick={(e) => {
                      toggleLeftContentshow("number||bg_color", e, "15||0");
                    }}
                  >
                    <i className="me-2">
                      <img
                        src="https://d37q3r06begyqi.cloudfront.net/VidAmaze/app-images/slides_images/phone2.png"
                        className="img-fluid"
                        alt="img"
                      />
                    </i>
                    <span
                      className="number cursor"
                      style={applyBackGround("backgroundColor", "bg_color")}
                    >
                      <span style={applyCss("number")}>
                        {sliderDummyData.number}
                      </span>
                    </span>
                  </div>

                  <div
                    className="web mt-4 pt-3 border"
                    onClick={(e) => {
                      toggleLeftContentshow("web_url", e, "30");
                    }}
                  >
                    <i className="me-3">
                      <img
                        src="https://d37q3r06begyqi.cloudfront.net/VidAmaze/app-images/slides_images/web3.png"
                        alt="img"
                      />
                    </i>
                    <span className="cursor" style={applyCss("web_url")}>
                      {sliderDummyData.website}
                    </span>
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_25" && (
              <div
                className="hoverDiv slide_vid_25 wdh_fix"
                style={{
                  backgroundImage: `url("${sliderDummyData.bg_image}")`,
                }}
              >
                <a
                  href="#0"
                  className="changeImageVideo"
                  onClick={(e) => {
                    toggleRightshow("bg_image", e);
                  }}
                >
                  <img
                    src={`${process.env.PUBLIC_URL}/assets/images/edit_hv.png`}
                    alt="img"
                  />{" "}
                  Change Background Image
                </a>
                <h1
                  className="m-0 cursor border"
                  onClick={(e) => {
                    toggleLeftContentshow("hey", e, "10");
                  }}
                  style={applyCss("hey")}
                >
                  {sliderDummyData.hey}
                </h1>
                <h1 className="dynamic_text">{dynamicText}</h1>
              </div>
            )}

            {active_slide_name === "slide_26" && (
              <div
                className="hoverDiv slide_vid_26 wdh_fix pt-4"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div className="mid">
                  <div
                    className="title_slide mb-4 pb-3 text-center border"
                    onClick={(e) => {
                      toggleLeftContentshow("window A||window B", e, "20||15");
                    }}
                  >
                    <h2 className="m-0 cursor" style={applyCss("window A")}>
                      {sliderDummyData.window_a}
                    </h2>
                    <h3 className="m-0 cursor" style={applyCss("window B")}>
                      {sliderDummyData.window_b}
                    </h3>
                  </div>
                  <div className="cleanup_thmnl d-none">
                    <img
                      src="https://d37q3r06begyqi.cloudfront.net/VidAmaze/app-images/slides_images/cleanup.jpg"
                      className="img-fluid"
                      alt="img"
                    />
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_27" && (
              <div
                className="hoverDiv slide_vid_27 d-flex align-items-center justify-content-center wdh_fix "
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div
                  className="mid border"
                  onClick={(e) => {
                    toggleLeftContentshow(
                      "demand A||demand B||demand C",
                      e,
                      "9||6||17"
                    );
                  }}
                >
                  <div className="line1 cursor" style={applyCss("demand A")}>
                    {sliderDummyData.demand_a}
                  </div>
                  <div className="line2 cursor" style={applyCss("demand B")}>
                    {sliderDummyData.demand_b}
                  </div>
                  <div className="line3 cursor" style={applyCss("demand C")}>
                    {sliderDummyData.demand_c}
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_28" && (
              <div
                className="hoverDiv slide_vid_28 p-3 d-flex align-items-center  justify-content-center wdh_fix"
                style={{
                  backgroundImage: `url("${sliderDummyData.bg_image}")`,
                }}
              >
                <a
                  href="#0"
                  className="changeImageVideo"
                  onClick={(e) => {
                    toggleRightshow("bg_image", e);
                  }}
                >
                  <img
                    src={`${process.env.PUBLIC_URL}/assets/images/edit_hv.png`}
                    alt="img"
                  />{" "}
                  Change Background Image
                </a>
                <div
                  className="mid w-100 text-center border"
                  onClick={(e) => {
                    toggleLeftContentshow("meet A||meet B", e, "17||22");
                  }}
                >
                  <h2 className="m-0 cursor" style={applyCss("meet A")}>
                    {sliderDummyData.meet_a}
                  </h2>
                  <h3 className="m-0 cursor" style={applyCss("meet B")}>
                    {sliderDummyData.meet_b}
                  </h3>
                </div>
              </div>
            )}

            {active_slide_name === "slide_29" && (
              <div
                className="hoverDiv slide_vid_29 p-3 d-flex align-items-center  justify-content-center wdh_fix"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div
                  className="mid w-100 text-center border"
                  onClick={(e) => {
                    toggleLeftContentshow(
                      "spring A||spring B||spring C||spring D",
                      e,
                      "7||7||5||15"
                    );
                  }}
                >
                  <small className=" cursor" style={applyCss("spring A")}>
                    {sliderDummyData.spring_a}
                  </small>
                  <h3 className="m-0">
                    <span className=" cursor" style={applyCss("spring B")}>
                      {sliderDummyData.spring_b}
                    </span>
                    &nbsp;
                    <span className=" cursor" style={applyCss("spring C")}>
                      {sliderDummyData.spring_c}
                    </span>
                  </h3>
                  <h2 className="m-0 cursor" style={applyCss("spring D")}>
                    {sliderDummyData.spring_d}
                  </h2>
                </div>
              </div>
            )}

            {active_slide_name === "slide_30" && (
              <div
                className="hoverDiv slide_vid_30 p-3 d-flex align-items-center  justify-content-center wdh_fix"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div
                  className="mid border"
                  onClick={(e) => {
                    toggleLeftContentshow("holiday A||holiday B", e, "16||12");
                  }}
                >
                  <h3 className="m-0 cursor" style={applyCss("holiday A")}>
                    {sliderDummyData.holiday_a}
                  </h3>
                  <h2 className="m-0 cursor" style={applyCss("holiday B")}>
                    {sliderDummyData.holiday_b}
                  </h2>
                </div>
              </div>
            )}

            {active_slide_name === "slide_31" && (
              <div
                className="hoverDiv slide_vid_31 p-3 d-flex align-items-center  justify-content-center wdh_fix"
                style={{
                  backgroundImage: `url("${sliderDummyData.bg_image}")`,
                }}
              >
                <a
                  href="#0"
                  className="changeImageVideo"
                  onClick={(e) => {
                    toggleRightshow("bg_image", e);
                  }}
                >
                  <img
                    src={`${process.env.PUBLIC_URL}/assets/images/edit_hv.png`}
                    alt="img"
                  />{" "}
                  Change Background Image
                </a>
                <div
                  className="mid w-100 text-center border"
                  onClick={(e) => {
                    toggleLeftContentshow("hassels A||hassels B", e, "15||16");
                  }}
                >
                  <h2 className="m-0 cursor" style={applyCss("hassels A")}>
                    {sliderDummyData.hassels_a}
                  </h2>
                  <h3 className="m-0 cursor" style={applyCss("hassels B")}>
                    {sliderDummyData.hassels_b}
                  </h3>
                </div>
              </div>
            )}

            {active_slide_name === "slide_32" && (
              <div
                className="hoverDiv slide_vid_32 p-3 d-flex align-items-center  justify-content-center wdh_fix"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div
                  className="mid border"
                  onClick={(e) => {
                    toggleLeftContentshow(
                      "ladder A||ladder B||ladder C",
                      e,
                      "10||9||12"
                    );
                  }}
                >
                  <p className="m-0 text-center">
                    <small>
                      <em className=" cursor" style={applyCss("ladder A")}>
                        {sliderDummyData.ladder_a}
                      </em>
                    </small>
                  </p>
                  <h3
                    className="m-0 cursor text-center"
                    style={applyCss("ladder B")}
                  >
                    {sliderDummyData.ladder_b}
                  </h3>
                  <h2
                    className="m-0 text-center cursor"
                    style={applyCss("ladder C")}
                  >
                    {sliderDummyData.ladder_c}
                  </h2>
                </div>
              </div>
            )}

            {active_slide_name === "slide_33" && (
              <div
                className="hoverDiv slide_vid_33 p-3 d-flex align-items-center  justify-content-center wdh_fix"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />

                <div
                  className="mid border"
                  onClick={(e) => {
                    toggleLeftContentshow(
                      "reach A||reach B||reach C",
                      e,
                      "9||10||17"
                    );
                  }}
                >
                  <p className="m-0 text-center">
                    <small className=" cursor" style={applyCss("reach A")}>
                      {sliderDummyData.reach_a}
                    </small>
                  </p>
                  <h3
                    className="m-0 cursor text-center"
                    style={applyCss("reach B")}
                  >
                    {sliderDummyData.reach_b}
                  </h3>
                  <h2
                    className="m-0 text-center cursor"
                    style={applyCss("reach C")}
                  >
                    {sliderDummyData.reach_c}
                  </h2>
                </div>
              </div>
            )}

            {active_slide_name === "slide_34" && (
              <div
                className="hoverDiv slide_vid_34 p-3 d-flex align-items-center  justify-content-center wdh_fix"
                style={{
                  backgroundImage: `url("${sliderDummyData.bg_image}")`,
                }}
              >
                <a
                  href="#0"
                  className="changeImageVideo"
                  onClick={(e) => {
                    toggleRightshow("bg_image", e);
                  }}
                >
                  <img
                    src={`${process.env.PUBLIC_URL}/assets/images/edit_hv.png`}
                    alt="img"
                  />{" "}
                  Change Background Image
                </a>
                <div className="mid">
                  <div className="window_clean_logo text-center mb-5 border">
                    <img
                      src={sliderDummyData.logo}
                      className="img-fluid"
                      alt="img"
                      onClick={(e) => {
                        toggleRightshow("logo", e);
                      }}
                    />
                  </div>
                  <div
                    className="title_rw text-center mb-5 border"
                    onClick={(e) => {
                      toggleLeftContentshow("worry A||worry B", e, "11||14");
                    }}
                  >
                    <h4 className="m-0 cursor" style={applyCss("worry A")}>
                      {sliderDummyData.worry_a}
                    </h4>
                    <h5 className="m-0 cursor" style={applyCss("worry B")}>
                      {sliderDummyData.worry_b}
                    </h5>
                  </div>

                  <div className="btm_rw d-flex justify-content-between">
                    <a href="#0" className="border">
                      <i>
                        <img
                          src="https://d37q3r06begyqi.cloudfront.net/VidAmaze/app-images/slides_images/call_ic_1.png"
                          className="img-fluid"
                          alt="img"
                        />
                      </i>
                      <span
                        className="cursor"
                        onClick={(e) => {
                          toggleLeftContentshow("number", e, "15");
                        }}
                        style={applyCss("number")}
                      >
                        {sliderDummyData.number}
                      </span>
                    </a>
                    <a href="#0" className="border">
                      <i>
                        <img
                          src="https://d37q3r06begyqi.cloudfront.net/VidAmaze/app-images/slides_images/web4.png"
                          className="img-fluid"
                          alt="img"
                        />
                      </i>
                      <span
                        className="cursor"
                        onClick={(e) => {
                          toggleLeftContentshow("website", e, "35");
                        }}
                        style={applyCss("website")}
                      >
                        {sliderDummyData.website}
                      </span>
                    </a>
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_35" && (
              <div
                className="hoverDiv slide_vid_35 p-3 d-flex align-items-center  justify-content-center wdh_fix"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div
                  className="mid d-flex justify-content-between align-items-center border"
                  onClick={(e) => {
                    toggleLeftContentshow(
                      "plumbing A||plumbing B||plumbing C||plumbing D||plumbing E||plumbing F||plumbing G||bg_color",
                      e,
                      "13||16||18||10||8||8||16||0"
                    );
                  }}
                >
                  <div
                    className="cl_1 text-end"
                    style={applyBackGround(
                      "borderRight",
                      "bg_color",
                      " 6px solid"
                    )}
                  >
                    <div
                      className="line1 cursor"
                      style={applyCss("plumbing A")}
                    >
                      {sliderDummyData.plumbing_a}
                    </div>
                    <div
                      className="line2 cursor"
                      style={applyCss("plumbing B")}
                    >
                      {sliderDummyData.plumbing_b}
                    </div>
                  </div>
                  <div className="cl_2">
                    <div
                      className="line3 cursor"
                      style={applyCss("plumbing C")}
                    >
                      {sliderDummyData.plumbing_c}
                    </div>
                    <div
                      className="line4 cursor"
                      style={applyCss("plumbing D")}
                    >
                      {sliderDummyData.plumbing_d}
                    </div>
                    <div
                      className="line5 cursor"
                      style={applyCss("plumbing E")}
                    >
                      {sliderDummyData.plumbing_e}
                    </div>
                    <div
                      className="line6 cursor"
                      style={applyCss("plumbing F")}
                    >
                      {sliderDummyData.plumbing_f}
                    </div>
                    <div
                      className="line7 cursor"
                      style={applyCss("plumbing G")}
                    >
                      {sliderDummyData.plumbing_g}
                    </div>
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_36" && (
              <div
                className="hoverDiv slide_vid_36 wdh_fix"
                style={{
                  backgroundImage: `url("${sliderDummyData.bg_image}")`,
                }}
              >
                <a
                  href="#0"
                  className="changeImageVideo"
                  onClick={(e) => {
                    toggleRightshow("bg_image", e);
                  }}
                >
                  <img
                    src={`${process.env.PUBLIC_URL}/assets/images/edit_hv.png`}
                    alt="img"
                  />{" "}
                  Change Background Image
                </a>
                <h1
                  className="m-0 text-uppercase cursor border"
                  onClick={(e) => {
                    toggleLeftContentshow("hey", e, "10");
                  }}
                  style={applyCss("hey")}
                >
                  {sliderDummyData.hey}
                </h1>
                <h1 className="dynamic_text">{dynamicText}</h1>
              </div>
            )}

            {active_slide_name === "slide_37" && (
              <div
                className="hoverDiv slide_vid_37 p-3 d-flex align-items-center  justify-content-center wdh_fix"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div
                  className="mid  border"
                  onClick={(e) => {
                    toggleLeftContentshow(
                      "solution A||solution B||solution C||solution D",
                      e,
                      "5||8||7||17"
                    );
                  }}
                >
                  <div className="rw1 d-flex align-items-end justify-content-center">
                    <div className="cl_1 text-end">
                      <div
                        className="line1 cursor"
                        style={applyCss("solution A")}
                      >
                        {sliderDummyData.solution_a}
                      </div>
                      <div
                        className="line2 cursor"
                        style={applyCss("solution B")}
                      >
                        {sliderDummyData.solution_b}
                      </div>
                    </div>
                    <div className="cl_2">
                      <div
                        className="line3 cursor"
                        style={applyCss("solution C")}
                      >
                        {sliderDummyData.solution_c}
                      </div>
                    </div>
                  </div>
                  <div className="rw2">
                    <div
                      className="line4 cursor"
                      style={applyCss("solution D")}
                    >
                      {sliderDummyData.solution_d}
                    </div>
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_38" && (
              <div
                className="hoverDiv slide_vid_38 p-3 d-flex align-items-center  justify-content-center wdh_fix"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div className="mid">
                  <div
                    className="rw1 d-flex align-items-end justify-content-center border"
                    onClick={(e) => {
                      toggleLeftContentshow(
                        "quality A||quality B||quality C",
                        e,
                        "10||4|||7"
                      );
                    }}
                  >
                    <div className="cl_1 text-end">
                      <div
                        className="line1 cursor"
                        style={applyCss("quality A")}
                      >
                        {sliderDummyData.quality_a}
                      </div>
                      <div
                        className="line2 cursor"
                        style={applyCss("quality B")}
                      >
                        {sliderDummyData.quality_b}
                      </div>
                    </div>
                    <div className="cl_2">
                      <div
                        className="line3 cursor"
                        style={applyCss("quality C")}
                      >
                        {sliderDummyData.quality_c}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_39" && (
              <div
                className="hoverDiv slide_vid_39 p-3 d-flex align-items-center  justify-content-center wdh_fix"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />

                <div
                  className="mid pt-5 mt-3 border"
                  onClick={(e) => {
                    toggleLeftContentshow(
                      "money A||money B||money C||money D",
                      e,
                      "5||6||9||9"
                    );
                  }}
                >
                  <div className="line1 cursor" style={applyCss("money A")}>
                    {sliderDummyData.money_a}
                  </div>
                  <div className="line2">
                    <span className="  cursor" style={applyCss("money B")}>
                      {sliderDummyData.money_b}
                    </span>{" "}
                    <span className=" cursor" style={applyCss("money C")}>
                      {sliderDummyData.money_c}
                    </span>
                  </div>
                  <div className="line3 cursor" style={applyCss("money D")}>
                    {sliderDummyData.money_d}
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_40" && (
              <div
                className="hoverDiv slide_vid_40 p-3 d-flex align-items-center  justify-content-center wdh_fix "
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div className="mid">
                  <div className="border">
                    <div
                      className="rw_1 "
                      onClick={(e) => {
                        toggleLeftContentshow(
                          "needs A||needs B||bg_color",
                          e,
                          "16||14||0"
                        );
                      }}
                      style={applyBackGround(
                        "borderLeft",
                        "bg_color",
                        " 6px solid"
                      )}
                    >
                      <div className="line1 cursor" style={applyCss("needs A")}>
                        {sliderDummyData.needs_a}
                      </div>
                      <div className="line2 cursor" style={applyCss("needs B")}>
                        {sliderDummyData.needs_b}
                      </div>
                    </div>
                  </div>
                  <div className="rw_2 border mt-1">
                    <i>
                      <img
                        src="https://d37q3r06begyqi.cloudfront.net/VidAmaze/app-images/slides_images/phone3.png"
                        alt="img"
                      />
                    </i>
                    <span
                      className=" cursor"
                      onClick={(e) => {
                        toggleLeftContentshow("number", e, "15");
                      }}
                      style={applyCss("number")}
                    >
                      {sliderDummyData.number}
                    </span>
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_41" && (
              <div
                className="hoverDiv slide_vid_41 p-3 d-flex align-items-center  justify-content-center wdh_fix"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div
                  className="mid border"
                  onClick={(e) => {
                    toggleLeftContentshow(
                      "problem A||problem B||problem C||bg_color",
                      e,
                      "10||17||18||0"
                    );
                  }}
                >
                  <div className="line1 cursor" style={applyCss("problem A")}>
                    {sliderDummyData.problem_a}
                  </div>
                  <div className="line2 cursor" style={applyCss("problem B")}>
                    {sliderDummyData.problem_b}
                  </div>
                  <div
                    className="line3 cursor"
                    style={applyBackGround("backgroundColor", "bg_color")}
                  >
                    <span style={applyCss("problem C")}>
                      {sliderDummyData.problem_c}
                    </span>
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_42" && (
              <div
                className="hoverDiv slide_vid_42 p-3 d-flex align-items-center  justify-content-center wdh_fix"
                style={{
                  backgroundImage: `url("${sliderDummyData.bg_image}")`,
                }}
              >
                <a
                  href="#0"
                  className="changeImageVideo"
                  onClick={(e) => {
                    toggleRightshow("bg_image", e);
                  }}
                >
                  <img
                    src={`${process.env.PUBLIC_URL}/assets/images/edit_hv.png`}
                    alt="img"
                  />{" "}
                  Change Background Image
                </a>
                <div className="mid ">
                  <div className="line1 border">
                    <img
                      src={sliderDummyData.logo}
                      className="img-fluid"
                      alt="img"
                      onClick={(e) => {
                        toggleRightshow("logo", e);
                      }}
                    />
                  </div>
                  <div className="line2 pt-4 pb-4 border mt-1 mb-1">
                    <i>
                      <img
                        src="https://d37q3r06begyqi.cloudfront.net/VidAmaze/app-images/slides_images/phone3.png"
                        alt="img"
                      />
                    </i>
                    <span
                      className=" cursor"
                      onClick={(e) => {
                        toggleLeftContentshow("number", e, "15");
                      }}
                      style={applyCss("number")}
                    >
                      {sliderDummyData.number}
                    </span>
                  </div>
                  <div className="line3 border">
                    <i>
                      <img
                        src="https://d37q3r06begyqi.cloudfront.net/VidAmaze/app-images/slides_images/web2.png"
                        alt="img"
                      />
                    </i>{" "}
                    <span
                      className=" cursor"
                      onClick={(e) => {
                        toggleLeftContentshow("website", e, "30");
                      }}
                      style={applyCss("website")}
                    >
                      {" "}
                      {sliderDummyData.website}
                    </span>
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_43_0" && (
              <div
                className="hoverDiv slide_vid_1 slide_vid_43_0 wdh_fix"
                style={{
                  backgroundImage: `url("${sliderDummyData.bg_image}")`,
                }}
              >
                <a
                  href="#0"
                  className="changeImageVideo"
                  onClick={(e) => {
                    toggleRightshow("bg_image", e);
                  }}
                >
                  <img
                    src={`${process.env.PUBLIC_URL}/assets/images/edit_hv.png`}
                    alt="img"
                  />{" "}
                  Change Background Image
                </a>
                <h1
                  className="m-0 text-uppercase cursor border"
                  onClick={(e) => {
                    toggleLeftContentshow("hey", e, "10");
                  }}
                  style={applyCss("hey")}
                >
                  {sliderDummyData.hey}
                </h1>
                <h1 className="dynamic_text">{dynamicText}</h1>
              </div>
            )}

            {active_slide_name === "slide_43" && (
              <div
                className="hoverDiv slide_vid_43 p-3 d-flex align-items-center  justify-content-center wdh_fix"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div className="mid d-flex align-items-center">
                  <div className="row">
                    <div className="col-md-4 d-none">
                      <figure className="mb-0">
                        <img
                          src="https://d37q3r06begyqi.cloudfront.net/VidAmaze/app-images/slides_images/camera.png"
                          className="img-fluid d-none"
                          alt="img"
                        />
                      </figure>
                    </div>
                    <div className="col-md-12" style={{ marginLeft: "113px" }}>
                      <div className="border">
                        <figcaption
                          onClick={(e) => {
                            toggleLeftContentshow(
                              "professional A||professional B||bg_color",
                              e,
                              "12||26||0"
                            );
                          }}
                          style={applyBackGround(
                            "borderLeft",
                            "bg_color",
                            " 5px solid"
                          )}
                        >
                          <div
                            className="line1 cursor"
                            style={applyCss("professional A")}
                          >
                            {sliderDummyData.professional_a}
                          </div>
                          <div
                            className="line2 cursor"
                            style={applyCss("professional B")}
                          >
                            {sliderDummyData.professional_b}
                          </div>
                        </figcaption>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_44" && (
              <div
                className="hoverDiv slide_vid_44 p-3 d-flex align-items-center  justify-content-center wdh_fix"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div
                  className="mid d-flex border"
                  onClick={(e) => {
                    toggleLeftContentshow(
                      "moments A||moments B||moments C||moments D||moments E",
                      e,
                      "9||11||15||7||25"
                    );
                  }}
                >
                  <div className="cl_a text-end pe-2">
                    <div
                      className="line_1 cursor"
                      style={applyCss("moments A")}
                    >
                      {sliderDummyData.moments_a}
                    </div>
                    <div
                      className="line_2 cursor"
                      style={applyCss("moments B")}
                    >
                      {sliderDummyData.moments_b}
                    </div>
                  </div>
                  <div className="cl_b">
                    <div
                      className="line_3 cursor"
                      style={applyCss("moments C")}
                    >
                      {sliderDummyData.moments_c}
                    </div>
                    <div
                      className="line_4 cursor"
                      style={applyCss("moments D")}
                    >
                      {sliderDummyData.moments_d}
                    </div>
                    <div
                      className="line_5 cursor"
                      style={applyCss("moments E")}
                    >
                      {sliderDummyData.moments_e}
                    </div>
                  </div>
                </div>
              </div>
            )}
            {active_slide_name === "slide_45" && (
              <div
                className="hoverDiv slide_vid_45 p-3 d-flex align-items-center  justify-content-center wdh_fix"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div
                  className="mid text-center border"
                  onClick={(e) => {
                    toggleLeftContentshow(
                      "trained A||trained B||trained C",
                      e,
                      "18||16||17"
                    );
                  }}
                >
                  <div className="line1 cursor" style={applyCss("trained A")}>
                    {sliderDummyData.trained_a}
                  </div>
                  <div className="line2 cursor" style={applyCss("trained B")}>
                    {sliderDummyData.trained_b}
                  </div>
                  <div className="line3 cursor" style={applyCss("trained C")}>
                    {sliderDummyData.trained_c}
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_46" && (
              <div
                className="hoverDiv slide_vid_46 p-3 d-flex align-items-center  justify-content-center wdh_fix"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div
                  className="mid d-flex align-items-center border"
                  onClick={(e) => {
                    toggleLeftContentshow(
                      "master A||master B||master C||master D||bg_color",
                      e,
                      "6||11||11||14||0"
                    );
                  }}
                >
                  <div className="cl_1">
                    <div className="line1 cursor" style={applyCss("master A")}>
                      {sliderDummyData.master_a}
                    </div>
                  </div>

                  <div
                    className="cl_2"
                    style={applyBackGround(
                      "borderLeft",
                      "bg_color",
                      " 4px solid"
                    )}
                  >
                    <div className="line2">
                      <em className=" cursor" style={applyCss("master B")}>
                        {sliderDummyData.master_b}
                      </em>
                    </div>
                    <div className="line3 cursor" style={applyCss("master C")}>
                      {sliderDummyData.master_c}
                    </div>
                    <div className="line4 cursor" style={applyCss("master D")}>
                      {sliderDummyData.master_d}
                    </div>
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_47" && (
              <div
                className="hoverDiv slide_vid_47 p-3 d-flex align-items-center  justify-content-center wdh_fix"
                style={{
                  backgroundImage: `url("${sliderDummyData.bg_image}")`,
                }}
              >
                <a
                  href="#0"
                  className="changeImageVideo"
                  onClick={(e) => {
                    toggleRightshow("bg_image", e);
                  }}
                >
                  <img
                    src={`${process.env.PUBLIC_URL}/assets/images/edit_hv.png`}
                    alt="img"
                  />{" "}
                  Change Background Image
                </a>
                <div className="mid text-center">
                  <div className="ph_logo  border">
                    <img
                      src={sliderDummyData.logo}
                      className="img-fluid"
                      alt="img"
                      onClick={(e) => {
                        toggleRightshow("logo", e);
                      }}
                    />
                  </div>
                  <div
                    className="border mt-1"
                    onClick={(e) => {
                      toggleLeftContentshow(
                        "need A||need B||need C",
                        e,
                        "12||15||18"
                      );
                    }}
                  >
                    <div className="line_1 cursor" style={applyCss("need A")}>
                      {sliderDummyData.need_a}
                    </div>
                    <div className="line_2 cursor" style={applyCss("need B")}>
                      {sliderDummyData.need_b}
                    </div>
                    <div className="line_3 cursor" style={applyCss("need C")}>
                      {sliderDummyData.need_c}
                    </div>
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_48" && (
              <div
                className="hoverDiv slide_vid_48 p-3 d-flex align-items-center  justify-content-center wdh_fix"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div className="mid text-center">
                  <div
                    className="border mb-2"
                    onClick={(e) => {
                      toggleLeftContentshow(
                        "work A||work B||bg_color||work C",
                        e,
                        "8||5||0||31"
                      );
                    }}
                  >
                    <div className="line1">
                      <span className=" cursor" style={applyCss("work A")}>
                        {sliderDummyData.work_a}
                      </span>
                      <span
                        className=" cursor"
                        style={applyBackGround("backgroundColor", "bg_color")}
                      >
                        <span style={applyCss("work B")}>
                          {sliderDummyData.work_b}
                        </span>
                      </span>
                    </div>
                    <div className="line2 cursor" style={applyCss("work C")}>
                      {sliderDummyData.work_c}
                    </div>
                  </div>

                  <div className="line3 border">
                    <i>
                      <img
                        src="https://d37q3r06begyqi.cloudfront.net/VidAmaze/app-images/slides_images/phone4.png"
                        alt="img"
                      />
                    </i>{" "}
                    <span
                      className=" cursor"
                      onClick={(e) => {
                        toggleLeftContentshow("number", e, "15");
                      }}
                      style={applyCss("number")}
                    >
                      {sliderDummyData.number}
                    </span>
                  </div>
                  <div className="line4 border mt-1">
                    <i>
                      <img
                        src="https://d37q3r06begyqi.cloudfront.net/VidAmaze/app-images/slides_images/web2.png"
                        alt="img"
                      />
                    </i>{" "}
                    <span
                      className=" cursor"
                      onClick={(e) => {
                        toggleLeftContentshow("website", e, "30");
                      }}
                      style={applyCss("website")}
                    >
                      {sliderDummyData.website}
                    </span>
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_49" && (
              <div
                className="hoverDiv slide_vid_49 wdh_fix p-4 d-flex align-items-center"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div
                  className="mid w-100 ps-4 border"
                  onClick={(e) => {
                    toggleLeftContentshow(
                      "problem A||problem B||problem C",
                      e,
                      "17||25||24"
                    );
                  }}
                >
                  <div className="line1 cursor" style={applyCss("problem A")}>
                    {sliderDummyData.problem_a}
                  </div>
                  <div className="line2 cursor" style={applyCss("problem B")}>
                    {sliderDummyData.problem_b}
                  </div>
                  <div className="line3 cursor" style={applyCss("problem C")}>
                    {sliderDummyData.problem_c}
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_50" && (
              <div
                className="hoverDiv slide_vid_50 wdh_fix p-4 d-flex justify-content-center align-items-center"
                style={{
                  backgroundImage: `url("${sliderDummyData.bg_image}")`,
                }}
              >
                <a
                  href="#0"
                  className="changeImageVideo"
                  onClick={(e) => {
                    toggleRightshow("bg_image", e);
                  }}
                >
                  <img
                    src={`${process.env.PUBLIC_URL}/assets/images/edit_hv.png`}
                    alt="img"
                  />{" "}
                  Change Background Image
                </a>
                <div className="mid text-center">
                  <div
                    className="line1 cursor border"
                    onClick={(e) => {
                      toggleLeftContentshow("suffer A", e, "14");
                    }}
                    style={applyCss("suffer A")}
                  >
                    {sliderDummyData.suffer_a}
                  </div>
                  <div className="line2 dynamic_text">{dynamicText}</div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_51" && (
              <div
                className="hoverDiv slide_vid_51 wdh_fix p-4 d-flex justify-content-center align-items-center"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div className="mid d-flex align-items-center">
                  <div
                    className="cl_1 border"
                    onClick={(e) => {
                      toggleLeftContentshow("result A||result B", e, "6||16");
                    }}
                  >
                    <div className="line1 cursor" style={applyCss("result A")}>
                      {sliderDummyData.result_a}
                    </div>
                    <div className="line2 cursor" style={applyCss("result B")}>
                      {sliderDummyData.result_b}
                    </div>
                  </div>

                  <div className="cl_2 border m-1 lh-1">
                    <div
                      className="line3 cursor"
                      onClick={(e) => {
                        toggleLeftContentshow("result C", e, "19");
                      }}
                      style={applyCss("result C")}
                    >
                      {sliderDummyData.result_c}
                    </div>
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_52" && (
              <div
                className="hoverDiv slide_vid_52 wdh_fix p-4 d-flex justify-content-center align-items-center"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div
                  className="mid text-center border"
                  onClick={(e) => {
                    toggleLeftContentshow(
                      "qualified A||qualified B||qualified C",
                      e,
                      "26||23||20"
                    );
                  }}
                >
                  <div className="line1 cursor" style={applyCss("qualified A")}>
                    {sliderDummyData.qualified_a}
                  </div>
                  <div className="line2 cursor" style={applyCss("qualified B")}>
                    {sliderDummyData.qualified_b}
                  </div>
                  <div className="line3 cursor" style={applyCss("qualified C")}>
                    {sliderDummyData.qualified_c}
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_53" && (
              <div
                className="hoverDiv slide_vid_53 wdh_fix p-4 d-flex justify-content-center align-items-center"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div
                  className="mid text-center pt-5 border"
                  onClick={(e) => {
                    toggleLeftContentshow("improve A||improve B", e, "11||13");
                  }}
                >
                  <div className="line1 cursor" style={applyCss("improve A")}>
                    {sliderDummyData.improve_a}
                  </div>
                  <div className="line2 cursor" style={applyCss("improve B")}>
                    {sliderDummyData.improve_b}
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_54" && (
              <div
                className="hoverDiv slide_vid_54 wdh_fix p-4 d-flex justify-content-center align-items-center"
                style={{
                  backgroundImage: `url("${sliderDummyData.bg_image}")`,
                }}
              >
                <a
                  href="#0"
                  className="changeImageVideo"
                  onClick={(e) => {
                    toggleRightshow("bg_image", e);
                  }}
                >
                  <img
                    src={`${process.env.PUBLIC_URL}/assets/images/edit_hv.png`}
                    alt="img"
                  />{" "}
                  Change Background Image
                </a>
                <div className="mid">
                  <div className="logo border">
                    <img
                      src={sliderDummyData.logo}
                      className="img-fluid"
                      alt="img"
                      onClick={(e) => {
                        toggleRightshow("logo", e);
                      }}
                    />
                  </div>
                  <h1
                    className="mt-1 text-center pt-4 border"
                    onClick={(e) => {
                      toggleLeftContentshow(
                        "consultation A||consultation B",
                        e,
                        "16||17"
                      );
                    }}
                  >
                    <span
                      className="d-block title_txt_1 cursor"
                      style={applyCss("consultation A")}
                    >
                      {sliderDummyData.consultation_a}
                    </span>
                    <span
                      className="d-block title_txt_2 cursor"
                      style={applyCss("consultation B")}
                    >
                      {sliderDummyData.consultation_b}
                    </span>
                  </h1>
                  <div className="call pt-4 pb-3 border">
                    <i className="me-3">
                      <img
                        src="https://d37q3r06begyqi.cloudfront.net/VidAmaze/app-images/slides_images/phone5.png"
                        alt="img"
                      />
                    </i>
                    <span
                      className=" cursor"
                      onClick={(e) => {
                        toggleLeftContentshow("number", e, "15");
                      }}
                      style={applyCss("number")}
                    >
                      {sliderDummyData.number}
                    </span>
                  </div>
                  <div className="web border mt-1">
                    <i className="me-3">
                      <img
                        src="https://d37q3r06begyqi.cloudfront.net/VidAmaze/app-images/slides_images/web5.png"
                        alt="img"
                      />
                    </i>
                    <span
                      className=" cursor"
                      onClick={(e) => {
                        toggleLeftContentshow("website", e, "30");
                      }}
                      style={applyCss("website")}
                    >
                      {sliderDummyData.website}
                    </span>
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_55" && (
              <div
                className="hoverDiv slide_vid_55 d-flex align-items-center justify-content-center wdh_fix flex-column"
                style={{
                  backgroundImage: `url("${sliderDummyData.bg_image}")`,
                }}
              >
                <a
                  href="#0"
                  className="changeImageVideo"
                  onClick={(e) => {
                    toggleRightshow("bg_image", e);
                  }}
                >
                  <img
                    src={`${process.env.PUBLIC_URL}/assets/images/edit_hv.png`}
                    alt="img"
                  />{" "}
                  Change Background Image
                </a>
                <h1
                  className="m-0 cursor border"
                  onClick={(e) => {
                    toggleLeftContentshow("hey", e, "10");
                  }}
                  style={applyCss("hey")}
                >
                  {sliderDummyData.hey}
                </h1>
                <h1 className="dynamic_text">{dynamicText}</h1>
              </div>
            )}

            {active_slide_name === "slide_56" && (
              <div
                className="hoverDiv slide_vid_56 d-flex p-4 ps-5 pe-5 align-items-center  wdh_fix"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div className="w-100">
                  <div className="row">
                    <div className="col-5">
                      <img
                        src="https://d37q3r06begyqi.cloudfront.net/VidAmaze/app-images/slides_images/carpet_clean.jpg"
                        className="img-fluid d-none"
                        alt="img"
                      />
                    </div>
                    <div className="col-7">
                      <div className="carpet_logo mt-4 mb-5 ms-3 border">
                        <img
                          src={sliderDummyData.logo}
                          className="img-fluid"
                          alt="img"
                          onClick={(e) => {
                            toggleRightshow("logo", e);
                          }}
                        />
                      </div>
                      <figcaption
                        className="border"
                        onClick={(e) => {
                          toggleLeftContentshow(
                            "service A||service B||service C",
                            e,
                            "11||15||18"
                          );
                        }}
                      >
                        <div
                          className="line1 cursor"
                          style={applyCss("service A")}
                        >
                          {sliderDummyData.service_a}
                        </div>
                        <div
                          className="line2  cursor"
                          style={applyCss("service B")}
                        >
                          {sliderDummyData.service_b}
                        </div>
                        <div
                          className="line3 cursor"
                          style={applyCss("service C")}
                        >
                          {sliderDummyData.service_c}
                        </div>
                      </figcaption>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_57" && (
              <div
                className="hoverDiv slide_vid_57 p-4 justify-content-center d-flex   wdh_fix"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />

                <div className=" w-100">
                  <div
                    className="rw1 d-flex align-items-center justify-content-center border"
                    onClick={(e) => {
                      toggleLeftContentshow(
                        "floor A||floor B||floor C||floor D||floor E",
                        e,
                        "7||12||8||11||16"
                      );
                    }}
                  >
                    <div className="cl_1 text-end ">
                      <div className="line1 cursor" style={applyCss("floor A")}>
                        {sliderDummyData.floor_a}
                      </div>
                      <div className="line2 cursor" style={applyCss("floor C")}>
                        {sliderDummyData.floor_c}
                      </div>
                      <div className="line3 cursor" style={applyCss("floor D")}>
                        {sliderDummyData.floor_d}
                      </div>
                    </div>
                    <div className="cl_2 ps-2 ">
                      <div className="line4 cursor" style={applyCss("floor B")}>
                        {sliderDummyData.floor_b}
                      </div>
                      <div className="line5 cursor" style={applyCss("floor E")}>
                        {sliderDummyData.floor_e}
                      </div>
                    </div>
                  </div>

                  <div className="rw2 text-center pt-4">
                    <img
                      src="https://d37q3r06begyqi.cloudfront.net/VidAmaze/app-images/slides_images/carpet_clean2.jpg"
                      className="img-fluid d-none"
                      alt="img"
                    />
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_58" && (
              <div
                className="hoverDiv slide_vid_58 p-4 justify-content-center d-flex   wdh_fix"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div className=" w-100">
                  <div
                    className="rw1 text-center border"
                    onClick={(e) => {
                      toggleLeftContentshow("further A||further B", e, "4||10");
                    }}
                  >
                    <div
                      className="line_1 cursor"
                      style={applyCss("further A")}
                    >
                      {sliderDummyData.further_a}
                    </div>
                    <div
                      className="line_2 cursor"
                      style={applyCss("further B")}
                    >
                      {sliderDummyData.further_b}
                    </div>
                  </div>

                  <div className="rw2 text-center pt-4">
                    <img
                      src="https://d37q3r06begyqi.cloudfront.net/VidAmaze/app-images/slides_images/carpet_clean2.jpg"
                      className="img-fluid d-none"
                      alt="img"
                    />
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_59" && (
              <div
                className="hoverDiv slide_vid_59 p-4 justify-content-center d-flex align-items-center  wdh_fix"
                style={{
                  backgroundImage: `url("${sliderDummyData.bg_image}")`,
                }}
              >
                <a
                  href="#0"
                  className="changeImageVideo"
                  onClick={(e) => {
                    toggleRightshow("bg_image", e);
                  }}
                >
                  <img
                    src={`${process.env.PUBLIC_URL}/assets/images/edit_hv.png`}
                    alt="img"
                  />{" "}
                  Change Background Image
                </a>
                <div className="m_rw">
                  <div className="row align-items-center">
                    <div className="col-6 text-center pe-4">
                      <p
                        className="experiance cursor border"
                        onClick={(e) => {
                          toggleLeftContentshow("customer A", e, "7");
                        }}
                        style={applyCss("customer A")}
                      >
                        {sliderDummyData.customer_a}
                      </p>

                      <p
                        className="experiance_b  cursor border"
                        onClick={(e) => {
                          toggleLeftContentshow("customer B", e, "13");
                        }}
                        style={applyCss("customer B")}
                      >
                        {sliderDummyData.customer_b}
                      </p>
                      <img
                        src="https://d37q3r06begyqi.cloudfront.net/VidAmaze/app-images/slides_images/experience_3.jpg"
                        className="img-fluid"
                        alt="img"
                      />
                    </div>

                    <div className="col-6 ps-4 text-center">
                      <div className="count d-inline-block cursor ">
                        <span
                          className="border"
                          onClick={(e) => {
                            toggleLeftContentshow("customer C", e, "5");
                          }}
                          style={applyCss("customer C")}
                        >
                          {sliderDummyData.customer_c}
                        </span>
                      </div>
                      <h6
                        className="m-0 cursor border"
                        onClick={(e) => {
                          toggleLeftContentshow("customer D", e, "19");
                        }}
                        style={applyCss("customer D")}
                      >
                        {sliderDummyData.customer_d}
                      </h6>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_60" && (
              <div
                className="hoverDiv slide_vid_60 p-4 justify-content-center d-flex align-items-center  wdh_fix"
                style={{
                  backgroundImage: `url("${sliderDummyData.bg_image}")`,
                }}
              >
                <a
                  href="#0"
                  className="changeImageVideo"
                  onClick={(e) => {
                    toggleRightshow("bg_image", e);
                  }}
                >
                  <img
                    src={`${process.env.PUBLIC_URL}/assets/images/edit_hv.png`}
                    alt="img"
                  />{" "}
                  Change Background Image
                </a>
                <div
                  className="m_rw text-center border"
                  onClick={(e) => {
                    toggleLeftContentshow(
                      "provide A||provide B||provide C",
                      e,
                      "7||10||10"
                    );
                  }}
                >
                  <div className="line1 cursor" style={applyCss("provide A")}>
                    {sliderDummyData.provide_a}
                  </div>
                  <div className="line2 cursor" style={applyCss("provide B")}>
                    {sliderDummyData.provide_b}
                  </div>
                  <div className="line3 cursor" style={applyCss("provide C")}>
                    {sliderDummyData.provide_c}
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_61" && (
              <div
                className="hoverDiv slide_vid_61 p-4 justify-content-center d-flex align-items-center  wdh_fix"
                style={{
                  backgroundImage: `url("${sliderDummyData.bg_image}")`,
                }}
              >
                <a
                  href="#0"
                  className="changeImageVideo"
                  onClick={(e) => {
                    toggleRightshow("bg_image", e);
                  }}
                >
                  <img
                    src={`${process.env.PUBLIC_URL}/assets/images/edit_hv.png`}
                    alt="img"
                  />{" "}
                  Change Background Image
                </a>
                <div
                  className="m_rw text-center border"
                  onClick={(e) => {
                    toggleLeftContentshow(
                      "service A||service B||service C",
                      e,
                      "8||15||17"
                    );
                  }}
                >
                  <div className="line1  cursor" style={applyCss("service A")}>
                    {sliderDummyData.service_a}
                  </div>
                  <div className="line2 cursor" style={applyCss("service B")}>
                    {sliderDummyData.service_b}
                  </div>
                  <div className="line3 cursor" style={applyCss("service C")}>
                    {sliderDummyData.service_c}
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_62" && (
              <div
                className="hoverDiv slide_vid_62 p-4 justify-content-center d-flex align-items-center  wdh_fix"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div className="m_rw d-flex justify-content-between">
                  <div
                    className="cl_sm_1 text-end border"
                    onClick={(e) => {
                      toggleLeftContentshow(
                        "work D||work E||work F",
                        e,
                        "13||8||11"
                      );
                    }}
                  >
                    <div className="line_r_1 cursor" style={applyCss("work D")}>
                      {sliderDummyData.work_d}
                    </div>
                    <div
                      className="line_r_2 cursor"
                      dangerouslySetInnerHTML={{
                        __html: sliderDummyData.work_e,
                      }}
                      style={applyCss("work E")}
                    ></div>
                    <div className="line_r_1 cursor" style={applyCss("work F")}>
                      {sliderDummyData.work_f}
                    </div>
                  </div>

                  <div
                    className="cl_sm_2 border"
                    onClick={(e) => {
                      toggleLeftContentshow(
                        "work A||work B||work C",
                        e,
                        "8||4||4"
                      );
                    }}
                  >
                    <div className="line_r_4 cursor" style={applyCss("work A")}>
                      {sliderDummyData.work_a}
                    </div>
                    <div
                      className="line_r_5 text-end cursor"
                      style={applyCss("work B")}
                    >
                      {sliderDummyData.work_b}
                    </div>
                    <div
                      className="line_r_6 text-end  cursor"
                      style={applyCss("work C")}
                    >
                      {sliderDummyData.work_c}
                    </div>
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_63" && (
              <div
                className="hoverDiv slide_vid_63 wdh_fix p-4 d-flex justify-content-center align-items-center"
                style={{
                  backgroundImage: `url("${sliderDummyData.bg_image}")`,
                }}
              >
                <a
                  href="#0"
                  className="changeImageVideo"
                  onClick={(e) => {
                    toggleRightshow("bg_image", e);
                  }}
                >
                  <img
                    src={`${process.env.PUBLIC_URL}/assets/images/edit_hv.png`}
                    alt="img"
                  />{" "}
                  Change Background Image
                </a>
                <div className="mid">
                  <div className="logo text-center mb-3 border">
                    <img
                      src={sliderDummyData.logo}
                      className="img-fluid"
                      alt="img"
                      onClick={(e) => {
                        toggleRightshow("logo", e);
                      }}
                    />
                  </div>
                  <div className="call pt-4 pb-3 border">
                    <i className="me-3">
                      <img
                        src="https://d37q3r06begyqi.cloudfront.net/VidAmaze/app-images/slides_images/phone6.png"
                        alt="img"
                      />
                    </i>
                    <span
                      className="tel_number cursor"
                      onClick={(e) => {
                        toggleLeftContentshow("number||bg_color", e, "15||0");
                      }}
                      style={applyBackGround("backgroundColor", "bg_color")}
                    >
                      <span style={applyCss("number")}>
                        {sliderDummyData.number}
                      </span>
                    </span>
                  </div>
                  <div className="web border mt-1">
                    <i className="me-3">
                      <img
                        src="https://d37q3r06begyqi.cloudfront.net/VidAmaze/app-images/slides_images/web6.png"
                        alt="img"
                      />
                    </i>
                    <span
                      className="cursor"
                      onClick={(e) => {
                        toggleLeftContentshow("website_url", e, "30");
                      }}
                      style={applyCss("website_url")}
                    >
                      {sliderDummyData.website}
                    </span>
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_78" && (
              <div
                className="hoverDiv landscaping_vid_78 wdh_fix p-4 d-flex justify-content-center align-items-center"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div
                  className="mid text-center border"
                  onClick={(e) => {
                    toggleLeftContentshow(
                      "window A||window B||window C||bg_color",
                      e,
                      "13||24||18||0"
                    );
                  }}
                >
                  <div className="line_1 cursor" style={applyCss("window A")}>
                    {sliderDummyData.window_a}
                  </div>
                  <div className="line_2 cursor" style={applyCss("window B")}>
                    {sliderDummyData.window_b}
                  </div>
                  <div
                    className="line_3 cursor"
                    style={applyBackGround("backgroundColor", "bg_color")}
                  >
                    <span style={applyCss("window C")}>
                      {" "}
                      {sliderDummyData.window_c}
                    </span>
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_79" && (
              <div
                className="hoverDiv landscaping_vid_79 p-4 wdh_fix text-center flex-column"
                style={{
                  backgroundImage: `url("${sliderDummyData.bg_image}")`,
                }}
              >
                <a
                  href="#0"
                  className="changeImageVideo"
                  onClick={(e) => {
                    toggleRightshow("bg_image", e);
                  }}
                >
                  <img
                    src={`${process.env.PUBLIC_URL}/assets/images/edit_hv.png`}
                    alt="img"
                  />{" "}
                  Change Background Image
                </a>
                <h1
                  className="m-0 text-uppercase cursor border"
                  onClick={(e) => {
                    toggleLeftContentshow("hey", e, "10");
                  }}
                  style={applyCss("hey")}
                >
                  {sliderDummyData.hey}
                </h1>
                <h1 className="dynamic_text">{dynamicText}</h1>
              </div>
            )}

            {active_slide_name === "slide_80" && (
              <div
                className="hoverDiv landscaping_vid_80 wdh_fix p-4 ps-5 pe-5 d-flex justify-content-center align-items-center"
                style={{
                  backgroundImage: `url("${sliderDummyData.bg_image}")`,
                }}
              >
                <a
                  href="#0"
                  className="changeImageVideo"
                  onClick={(e) => {
                    toggleRightshow("bg_image", e);
                  }}
                >
                  <img
                    src={`${process.env.PUBLIC_URL}/assets/images/edit_hv.png`}
                    alt="img"
                  />{" "}
                  Change Background Image
                </a>
                <div className="mid text-center">
                  <div
                    className=" border"
                    onClick={(e) => {
                      toggleLeftContentshow(
                        "demand A||demand B||demand C",
                        e,
                        "18||26||24"
                      );
                    }}
                  >
                    <div className="line_1 cursor" style={applyCss("demand A")}>
                      {sliderDummyData.demand_a}
                    </div>
                    <div className="line_2 cursor" style={applyCss("demand B")}>
                      {sliderDummyData.demand_b}
                    </div>
                    <div className="line_3 cursor" style={applyCss("demand C")}>
                      {sliderDummyData.demand_c}
                    </div>
                  </div>
                  <ul className="m-0 p-0 pt-5 list-unstyled d-flex justify-content-between">
                    <li>
                      <figure className="m-0 p-0">
                        <img
                          src={sliderDummyData.bg_image_1}
                          className="img-fluid"
                          alt="img"
                          onClick={(e) => {
                            toggleRightshow("bg_image_1", e);
                          }}
                        />
                      </figure>
                    </li>
                    <li>
                      <figure className="m-0 p-0">
                        <img
                          src={sliderDummyData.bg_image_2}
                          className="img-fluid"
                          alt="img"
                          onClick={(e) => {
                            toggleRightshow("bg_image_2", e);
                          }}
                        />
                      </figure>
                    </li>
                    <li>
                      <figure className="m-0 p-0">
                        <img
                          src={sliderDummyData.bg_image_3}
                          className="img-fluid"
                          alt="img"
                          onClick={(e) => {
                            toggleRightshow("bg_image_3", e);
                          }}
                        />
                      </figure>
                    </li>
                  </ul>
                </div>
              </div>
            )}

            {active_slide_name === "slide_81" && (
              <div
                className="hoverDiv landscaping_vid_81 wdh_fix p-4 d-flex justify-content-center align-items-center"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div
                  className="border"
                  onClick={(e) => {
                    toggleLeftContentshow(
                      "spring A||spring B||bg_color",
                      e,
                      "26||23||0"
                    );
                  }}
                >
                  <div
                    className="mid"
                    style={applyBackGround(
                      "borderLeft",
                      "bg_color",
                      " 6px solid"
                    )}
                  >
                    <div className="line_1 cursor" style={applyCss("spring A")}>
                      {sliderDummyData.spring_a}
                    </div>
                    <div className="line_2 cursor" style={applyCss("spring B")}>
                      {sliderDummyData.spring_b}
                    </div>
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_82" && (
              <div
                className="hoverDiv landscaping_vid_82 wdh_fix p-4 d-flex justify-content-center "
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div
                  className="mid pt-5 text-center border"
                  onClick={(e) => {
                    toggleLeftContentshow("holiday A||holiday B", e, "19||18");
                  }}
                >
                  <div className="line_1 cursor" style={applyCss("holiday A")}>
                    {sliderDummyData.holiday_a}
                  </div>
                  <div className="line_2 cursor" style={applyCss("holiday B")}>
                    {sliderDummyData.holiday_b}
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_83" && (
              <div
                className="hoverDiv landscaping_vid_83 p-4 d-flex align-items-center justify-content-center  wdh_fix"
                style={{
                  backgroundImage: `url("${sliderDummyData.bg_image}")`,
                }}
              >
                <a
                  href="#0"
                  className="changeImageVideo"
                  onClick={(e) => {
                    toggleRightshow("bg_image", e);
                  }}
                >
                  <img
                    src={`${process.env.PUBLIC_URL}/assets/images/edit_hv.png`}
                    alt="img"
                  />{" "}
                  Change Background Image
                </a>
                <div className="mid ">
                  <div className="landscaper_logo mb-4 pb-2 text-center border">
                    <img
                      src={sliderDummyData.logo}
                      className="img-fluid"
                      alt="img"
                      onClick={(e) => {
                        toggleRightshow("logo", e);
                      }}
                    />
                  </div>
                  <h2
                    className=" cursor border"
                    onClick={(e) => {
                      toggleLeftContentshow("reach A", e, "27");
                    }}
                    style={applyCss("reach A")}
                  >
                    {sliderDummyData.reach_a}
                  </h2>
                  <ul className="m-0 p-0 pt-4 ps-4  list-unstyled">
                    <li
                      className="border"
                      onClick={(e) => {
                        toggleLeftContentshow("number", e, "15");
                      }}
                    >
                      <i>
                        <img
                          src="https://d37q3r06begyqi.cloudfront.net/VidAmaze/app-images/slides_images/phone9.png"
                          alt="img"
                        />
                      </i>{" "}
                      <span className="cursor" style={applyCss("number")}>
                        {sliderDummyData.number}
                      </span>
                    </li>
                    <li
                      className="border"
                      onClick={(e) => {
                        toggleLeftContentshow("website", e, "20");
                      }}
                    >
                      <i>
                        <img
                          src="https://d37q3r06begyqi.cloudfront.net/VidAmaze/app-images/slides_images/web9.png"
                          alt="img"
                        />
                      </i>{" "}
                      <span className="cursor" style={applyCss("website")}>
                        {sliderDummyData.website}
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            )}

            {active_slide_name === "slide_64" && (
              <div
                className="hoverDiv slide_vid_64 wdh_fix p-4 d-flex justify-content-center align-items-center"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div
                  className="mid text-center border"
                  onClick={(e) => {
                    toggleLeftContentshow(
                      "business A||business B||business C||bg_color",
                      e,
                      "22||25||27||0"
                    );
                  }}
                >
                  <div
                    className="dy_line_1 cursor"
                    style={applyCss("business A")}
                  >
                    {sliderDummyData.business_a}
                  </div>
                  <div
                    className="dy_line_2 cursor"
                    style={applyCss("business B")}
                  >
                    {sliderDummyData.business_b}
                  </div>
                  <div
                    className="dy_line_3  cursor"
                    style={applyBackGround("backgroundColor", "bg_color")}
                  >
                    <span style={applyCss("business C")}>
                      {sliderDummyData.business_c}
                    </span>
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_65" && (
              <div
                className="hoverDiv slide_vid_65 p-4 wdh_fix text-center flex-column"
                style={{
                  backgroundImage: `url("${sliderDummyData.bg_image}")`,
                }}
              >
                <a
                  href="#0"
                  className="changeImageVideo"
                  onClick={(e) => {
                    toggleRightshow("bg_image", e);
                  }}
                >
                  <img
                    src={`${process.env.PUBLIC_URL}/assets/images/edit_hv.png`}
                    alt="img"
                  />{" "}
                  Change Background Image
                </a>
                <h1
                  className="m-0 text-uppercase cursor border"
                  onClick={(e) => {
                    toggleLeftContentshow("hello", e, "10");
                  }}
                  style={applyCss("hello")}
                >
                  {sliderDummyData.hello}
                </h1>
                <h1 className="dynamic_text">{dynamicText}</h1>
              </div>
            )}

            {active_slide_name === "slide_66" && (
              <div
                className="hoverDiv slide_vid_66 p-4 wdh_fix "
                style={{
                  backgroundImage: `url("${sliderDummyData.bg_image}")`,
                }}
              >
                <a
                  href="#0"
                  className="changeImageVideo"
                  onClick={(e) => {
                    toggleRightshow("bg_image", e);
                  }}
                >
                  <img
                    src={`${process.env.PUBLIC_URL}/assets/images/edit_hv.png`}
                    alt="img"
                  />{" "}
                  Change Background Image
                </a>
                <div
                  className="small_text cursor border"
                  onClick={(e) => {
                    toggleLeftContentshow("everyday A||bg_color", e, "9||0");
                  }}
                  style={applyBackGround("backgroundColor", "bg_color")}
                >
                  <span style={applyCss("everyday A")}>
                    {sliderDummyData.everyday_a}
                  </span>
                </div>
              </div>
            )}

            {active_slide_name === "slide_67" && (
              <div
                className="hoverDiv slide_vid_67 p-4 wdh_fix d-flex align-items-center justify-content-center"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div
                  className="mid border"
                  onClick={(e) => {
                    toggleLeftContentshow(
                      "serve A||serve B||serve C||serve D",
                      e,
                      "15||17||7||21"
                    );
                  }}
                >
                  <div className="rw_top d-flex align-items-end ">
                    <div className="cl_1 ">
                      <div
                        className="line_1 cursor"
                        style={applyCss("serve A")}
                      >
                        {sliderDummyData.serve_a}
                      </div>
                      <div
                        className="line_2 cursor"
                        style={applyCss("serve B")}
                      >
                        {sliderDummyData.serve_b}
                      </div>
                    </div>

                    <div className="cl_2 ">
                      <div
                        className="line_3 cursor"
                        style={applyCss("serve C")}
                      >
                        {sliderDummyData.serve_c}
                      </div>
                    </div>
                  </div>

                  <div className="line_4 cursor " style={applyCss("serve D")}>
                    {sliderDummyData.serve_d}
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_68" && (
              <div
                className="hoverDiv slide_vid_68 p-4 wdh_fix d-flex align-items-center justify-content-center"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div
                  className="mid border"
                  onClick={(e) => {
                    toggleLeftContentshow(
                      "certified A||certified B||bg_color",
                      e,
                      "26||22||0"
                    );
                  }}
                  style={{
                    "--background":
                      sliderDummyData.bg_color &&
                      sliderDummyData.bg_color.includes("#")
                        ? "#" + sliderDummyData.bg_color.split("#")[1]
                        : "#" + sliderDummyData.bg_color,
                  }}
                >
                  <div className="line1 cursor" style={applyCss("certified A")}>
                    {sliderDummyData.certified_a}
                  </div>
                  <div className="line2 cursor" style={applyCss("certified B")}>
                    {sliderDummyData.certified_b}
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_69" && (
              <div
                className="hoverDiv slide_vid_69 p-4 wdh_fix d-flex align-items-center justify-content-center"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div
                  className="border"
                  onClick={(e) => {
                    toggleLeftContentshow(
                      "guidance A||guidance B||bg_color",
                      e,
                      "14||17||0"
                    );
                  }}
                >
                  <div
                    className="mid"
                    style={{
                      "--background":
                        sliderDummyData.bg_color &&
                        sliderDummyData.bg_color.includes("#")
                          ? "#" + sliderDummyData.bg_color.split("#")[1]
                          : "#" + sliderDummyData.bg_color,
                      "--borderLeft":
                        sliderDummyData.bg_color &&
                        sliderDummyData.bg_color.includes("#")
                          ? "#" +
                            sliderDummyData.bg_color.split("#")[1] +
                            " 5px solid"
                          : "#" + sliderDummyData.bg_color + " 5px solid",
                    }}
                  >
                    <div
                      className="line1 cursor"
                      style={applyCss("guidance A")}
                    >
                      {sliderDummyData.guidance_a}
                    </div>
                    <div
                      className="line2 cursor"
                      style={applyCss("guidance B")}
                    >
                      {sliderDummyData.guidance_b}
                    </div>
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_70" && (
              <div
                className="hoverDiv slide_vid_70 p-4 d-flex align-items-center justify-content-center  wdh_fix"
                style={{
                  backgroundImage: `url("${sliderDummyData.bg_image}")`,
                }}
              >
                <a
                  href="#0"
                  className="changeImageVideo"
                  onClick={(e) => {
                    toggleRightshow("bg_image", e);
                  }}
                >
                  <img
                    src={`${process.env.PUBLIC_URL}/assets/images/edit_hv.png`}
                    alt="img"
                  />{" "}
                  Change Background Image
                </a>
                <div className="mid ">
                  <div className="child_logo mb-4 pb-3 text-center border">
                    <img
                      src={sliderDummyData.logo}
                      className="img-fluid"
                      alt="img"
                      onClick={(e) => {
                        toggleRightshow("logo", e);
                      }}
                    />
                  </div>

                  <a
                    href="#0"
                    className="btn cursor border"
                    onClick={(e) => {
                      toggleLeftContentshow(
                        "spot A||spot B||bg_color||bg_color_1",
                        e,
                        "18||18||0||0"
                      );
                    }}
                    style={applyBackGround("backgroundColor", "bg_color")}
                  >
                    <span style={applyCss("spot A")}>
                      {sliderDummyData.spot_a}
                    </span>
                  </a>

                  <ul className="m-0 p-0 pt-4 list-unstyled">
                    <li
                      className="border"
                      onClick={(e) => {
                        toggleLeftContentshow("number", e, "15");
                      }}
                    >
                      <i>
                        <img
                          src="https://d37q3r06begyqi.cloudfront.net/VidAmaze/app-images/slides_images/phone7.png"
                          alt="img"
                        />
                      </i>{" "}
                      <span className="cursor" style={applyCss("number")}>
                        {sliderDummyData.number}
                      </span>
                    </li>
                    <li
                      className="border"
                      onClick={(e) => {
                        toggleLeftContentshow("website_url", e, "30");
                      }}
                    >
                      <i>
                        <img
                          src="https://d37q3r06begyqi.cloudfront.net/VidAmaze/app-images/slides_images/web7.png"
                          alt="img"
                        />
                      </i>{" "}
                      <span className="cursor" style={applyCss("website_url")}>
                        {sliderDummyData.website}
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            )}

            {active_slide_name === "slide_102" && (
              <div
                className="hoverDiv dogcare_vid_102 p-4 d-flex align-items-center justify-content-center  wdh_fix flex-column"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div className="mid  text-center lh-1">
                  <div
                    className="line_1 cursor border "
                    onClick={(e) => {
                      toggleLeftContentshow("hey", e, "10");
                    }}
                    style={applyCss("hey")}
                  >
                    {sliderDummyData.hey}
                  </div>
                  <div className="line_1 dynamic_text p-3">{dynamicText}</div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_103" && (
              <div
                className="hoverDiv dogcare_vid_103 p-4 d-flex align-items-center justify-content-center  wdh_fix"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div
                  className="mid  text-center border"
                  onClick={(e) => {
                    toggleLeftContentshow(
                      "problem A||problem B||problem C||bg_color||problem D",
                      e,
                      "15||16||15||0||21"
                    );
                  }}
                >
                  <div className="line_1 cursor" style={applyCss("problem A")}>
                    {sliderDummyData.problem_a}
                  </div>
                  <div className="line_2 cursor" style={applyCss("problem B")}>
                    {sliderDummyData.problem_b}
                  </div>
                  <div className="line_3">
                    <span
                      className="cursor"
                      style={applyBackGround("backgroundColor", "bg_color")}
                    >
                      <div style={applyCss("problem C")}>
                        {sliderDummyData.problem_c}
                      </div>
                    </span>
                  </div>
                  <div className="line_4 cursor" style={applyCss("problem D")}>
                    {sliderDummyData.problem_d}
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_104" && (
              <div
                className="hoverDiv dogcare_vid_104 p-4 d-flex align-items-center justify-content-center  wdh_fix"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div
                  className="mid  text-center border"
                  onClick={(e) => {
                    toggleLeftContentshow(
                      "qualified A||qualified B||qualified C",
                      e,
                      "17||12||19"
                    );
                  }}
                >
                  <div
                    className="line_1 cursor"
                    style={applyCss("qualified A")}
                  >
                    {sliderDummyData.qualified_a}
                  </div>
                  <div className="line_2">
                    <span className=" cursor" style={applyCss("qualified B")}>
                      {sliderDummyData.qualified_b}
                    </span>
                  </div>
                  <div
                    className="line_3 cursor"
                    style={applyCss("qualified C")}
                  >
                    {sliderDummyData.qualified_c}
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_105" && (
              <div
                className="hoverDiv dogcare_vid_105 p-4 d-flex align-items-center justify-content-center  wdh_fix"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div
                  className="mid  text-center border"
                  onClick={(e) => {
                    toggleLeftContentshow("improve A||improve B", e, "15||30");
                  }}
                >
                  <div className="line_1 cursor" style={applyCss("improve A")}>
                    {sliderDummyData.improve_a}
                  </div>
                  <div className="line_2 cursor" style={applyCss("improve B")}>
                    {sliderDummyData.improve_b}
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_106" && (
              <div
                className="hoverDiv dogcare_vid_106 p-4 d-flex align-items-center justify-content-center  wdh_fix"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div
                  className="mid  text-center border"
                  onClick={(e) => {
                    toggleLeftContentshow(
                      "consultation A||consultation B",
                      e,
                      "15||17"
                    );
                  }}
                >
                  <div
                    className="line_1 cursor"
                    style={applyCss("consultation A")}
                  >
                    {sliderDummyData.consultation_a}
                  </div>
                  <div
                    className="line_2 cursor"
                    style={applyCss("consultation B")}
                  >
                    {sliderDummyData.consultation_b}
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_107" && (
              <div
                className="hoverDiv dogcare_vid_107 p-4 d-flex align-items-center justify-content-center  wdh_fix"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div
                  className="mid  text-center border"
                  onClick={(e) => {
                    toggleLeftContentshow(
                      "floor A||floor B||floor C",
                      e,
                      "18||20||16"
                    );
                  }}
                >
                  <div className="line_1 cursor" style={applyCss("floor A")}>
                    {sliderDummyData.floor_a}
                  </div>
                  <div className="line_2">
                    <span className=" cursor" style={applyCss("floor B")}>
                      {sliderDummyData.floor_b}
                    </span>
                  </div>
                  <div className="line_3 cursor" style={applyCss("floor C")}>
                    {sliderDummyData.floor_c}
                  </div>
                  {/* <div className="line_4 pt-4">Don't Wait</div> */}
                </div>
              </div>
            )}

            {active_slide_name === "slide_108" && (
              <div
                className="hoverDiv dogcare_vid_108 p-4 d-flex align-items-center justify-content-center  wdh_fix"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div className="mid">
                  <div className="line_1 text-center pb-4 border">
                    <img
                      src={sliderDummyData.logo}
                      className="img-fluid"
                      alt="img"
                      onClick={(e) => {
                        toggleRightshow("logo", e);
                      }}
                    />
                  </div>
                  <div
                    className="line_2 text-center pb-4 cursor border mt-1"
                    onClick={(e) => {
                      toggleLeftContentshow("work A", e, "35");
                    }}
                    style={applyCss("work A")}
                  >
                    {sliderDummyData.work_a}
                  </div>
                  <div className="line_3 mt-1">
                    <ul className="m-0 p-0 list-unstyled">
                      <li
                        className="border"
                        onClick={(e) => {
                          toggleLeftContentshow("number", e, "15");
                        }}
                      >
                        <i>
                          <img
                            src="https://d37q3r06begyqi.cloudfront.net/VidAmaze/app-images/slides_images/phone11.png"
                            alt="img"
                          />
                        </i>{" "}
                        <span className="cursor" style={applyCss("number")}>
                          {sliderDummyData.number}
                        </span>
                      </li>
                      <li
                        className="border"
                        onClick={(e) => {
                          toggleLeftContentshow("website", e, "20");
                        }}
                      >
                        <i>
                          <img
                            src="https://d37q3r06begyqi.cloudfront.net/VidAmaze/app-images/slides_images/web11.png"
                            alt="img"
                          />
                        </i>{" "}
                        <span className="cursor" style={applyCss("website")}>
                          {sliderDummyData.website}
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_109" && (
              <div
                className="hoverDiv fitness_vid_109  d-flex align-items-center justify-content-center  wdh_fix flex-column position-relative"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div className="mid w-100 text-center p-4 lh-1">
                  <div
                    className="line_1 cursor border"
                    onClick={(e) => {
                      toggleLeftContentshow("hey", e, "10");
                    }}
                    style={applyCss("hey")}
                  >
                    {sliderDummyData.hey}
                  </div>
                  <div className="line_2 dynamic_text p-3">{dynamicText}</div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_110" && (
              <div
                className="hoverDiv position-relative fitness_vid_110  d-flex align-items-center justify-content-center  wdh_fix"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div className="mid w-100 text-center p-4 pb-3 ">
                  <div
                    className="border"
                    onClick={(e) => {
                      toggleLeftContentshow(
                        "business A||business B",
                        e,
                        "22||25"
                      );
                    }}
                  >
                    <div
                      className="line_1 cursor"
                      style={applyCss("business A")}
                    >
                      {sliderDummyData.business_a}
                    </div>
                    <div
                      className="line_2 cursor"
                      style={applyCss("business B")}
                    >
                      {sliderDummyData.business_b}
                    </div>
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_111" && (
              <div
                className="hoverDiv position-relative fitness_vid_111  d-flex align-items-center justify-content-center  wdh_fix"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div className="mid w-100 text-center p-4 pb-3">
                  <div className="line_1 cursor lh-1">
                    <div
                      className=" border"
                      onClick={(e) => {
                        toggleLeftContentshow("everyday A", e, "15");
                      }}
                      style={applyCss("everyday A")}
                    >
                      {sliderDummyData.everyday_a}
                    </div>
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_112" && (
              <div
                className="hoverDiv position-relative fitness_vid_112  d-flex align-items-center justify-content-center  wdh_fix"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div className="mid w-100 text-center  ">
                  <div
                    className="line_1 cursor border"
                    onClick={(e) => {
                      toggleLeftContentshow("serve A||bg_color", e, "31||0");
                    }}
                    style={applyBackGround("backgroundColor", "bg_color")}
                  >
                    <div style={applyCss("serve A")}>
                      {sliderDummyData.serve_a}
                    </div>
                  </div>

                  <div
                    className="border mt-1"
                    onClick={(e) => {
                      toggleLeftContentshow("serve B||serve C", e, "28||24");
                    }}
                  >
                    <div
                      className="line_2 pt-3 cursor"
                      style={applyCss("serve B")}
                    >
                      {sliderDummyData.serve_b}
                    </div>
                    <div
                      className="line_3 cursor"
                      onClick={(e) => {
                        toggleLeftContentshow("serve C", e, 24);
                      }}
                      style={applyCss("serve C")}
                    >
                      {sliderDummyData.serve_c}
                    </div>
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_113" && (
              <div
                className="hoverDiv fitness_vid_113  d-flex align-items-center justify-content-center  wdh_fix"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div
                  className="mid text-center border"
                  onClick={(e) => {
                    toggleLeftContentshow(
                      "certified A||certified B",
                      e,
                      "28||29"
                    );
                  }}
                >
                  <div
                    className="line_1 cursor"
                    style={applyCss("certified A")}
                  >
                    {sliderDummyData.certified_a}
                  </div>
                  <div
                    className="line_2 cursor"
                    style={applyCss("certified B")}
                  >
                    {sliderDummyData.certified_b}
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_114" && (
              <div
                className="hoverDiv fitness_vid_114 p-4 d-flex align-items-center justify-content-center  wdh_fix"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div className="mid">
                  <div className="line_1 text-center pb-4 border">
                    <img
                      src={sliderDummyData.logo}
                      className="img-fluid"
                      alt="img"
                      onClick={(e) => {
                        toggleRightshow("logo", e);
                      }}
                    />
                  </div>
                  <div
                    className="line_2 text-center pb-4 cursor mt-1 border"
                    onClick={(e) => {
                      toggleLeftContentshow("guidance A", e, "29");
                    }}
                    style={applyCss("guidance A")}
                  >
                    {sliderDummyData.guidance_a}
                  </div>
                  <div className="line_3 mt-1">
                    <ul className="m-0 p-0 list-unstyled">
                      <li
                        className="border"
                        onClick={(e) => {
                          toggleLeftContentshow("number", e, "15");
                        }}
                      >
                        <i>
                          <img
                            src="https://d37q3r06begyqi.cloudfront.net/VidAmaze/app-images/slides_images/phone12.png"
                            alt="img"
                          />
                        </i>{" "}
                        <span className="cursor" style={applyCss("number")}>
                          {sliderDummyData.number}
                        </span>
                      </li>
                      <li
                        className="border"
                        onClick={(e) => {
                          toggleLeftContentshow("website", e, "20");
                        }}
                      >
                        <i>
                          <img
                            src="https://d37q3r06begyqi.cloudfront.net/VidAmaze/app-images/slides_images/web11.png"
                            alt="img"
                          />
                        </i>{" "}
                        <span className="cursor" style={applyCss("website")}>
                          {sliderDummyData.website}
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_115" && (
              <div
                className="hoverDiv restaurant_vid_115 p-4 d-flex align-items-center justify-content-center  wdh_fix flex-column"
                style={{
                  backgroundImage: `url("${sliderDummyData.bg_image}")`,
                }}
              >
                <a
                  href="#0"
                  className="changeImageVideo"
                  onClick={(e) => {
                    toggleRightshow("bg_image", e);
                  }}
                >
                  <img
                    src={`${process.env.PUBLIC_URL}/assets/images/edit_hv.png`}
                    alt="img"
                  />{" "}
                  Change Background Image
                </a>
                <div className="mid text-center text-white lh-1">
                  <div
                    className="line_1 border"
                    onClick={(e) => {
                      toggleLeftContentshow("hey", e, "10");
                    }}
                    style={applyCss("hey")}
                  >
                    {sliderDummyData.hey}
                  </div>
                  <div className="line_2 dynamic_text p-3">{dynamicText}</div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_116" && (
              <div
                className="hoverDiv restaurant_vid_116  d-flex align-items-end p-0  wdh_fix"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div className="mid w-100 text-center text-white">
                  <div
                    className="line_1 p-3 "
                    style={{
                      backgroundColor: `${
                        sliderDummyData.bg_color &&
                        sliderDummyData.bg_color.includes("#")
                          ? "#" + sliderDummyData.bg_color.split("#")[1]
                          : "#" + sliderDummyData.bg_color
                      }`,
                    }}
                  >
                    <span
                      className="border"
                      onClick={(e) => {
                        toggleLeftContentshow("pamper A||bg_color", e, "49");
                      }}
                      style={applyCss("pamper A")}
                    >
                      {sliderDummyData.pamper_a}
                    </span>
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_116_0" && (
              <div
                className="hoverDiv restaurant_vid_116_0  d-flex align-items-end p-0  wdh_fix"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div className="mid w-100 text-center text-white">
                  <div
                    className="line_1 p-3"
                    style={{
                      backgroundColor: `${
                        sliderDummyData.bg_color &&
                        sliderDummyData.bg_color.includes("#")
                          ? "#" + sliderDummyData.bg_color.split("#")[1]
                          : "#" + sliderDummyData.bg_color
                      }`,
                    }}
                  >
                    <span
                      className="border"
                      onClick={(e) => {
                        toggleLeftContentshow("pamper B||bg_color", e, "52||0");
                      }}
                      style={applyCss("pamper B")}
                    >
                      {sliderDummyData.pamper_b}
                    </span>
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_117" && (
              <div
                className="hoverDiv restaurant_vid_117  d-flex align-items-center   wdh_fix"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div className="mid w-100 text-center text-white">
                  <div
                    className="line_1 p-3 border"
                    onClick={(e) => {
                      toggleLeftContentshow("service A", e, "24");
                    }}
                    style={applyCss("service A")}
                  >
                    {sliderDummyData.service_a}
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_118" && (
              <div
                className="hoverDiv restaurant_vid_118  d-flex align-items-end p-0 wdh_fix"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div className="mid w-100 text-center text-white">
                  <div
                    className="line_1 p-3"
                    style={{
                      backgroundColor: `${
                        sliderDummyData.bg_color &&
                        sliderDummyData.bg_color.includes("#")
                          ? "#" + sliderDummyData.bg_color.split("#")[1]
                          : "#" + sliderDummyData.bg_color
                      }`,
                    }}
                  >
                    <span
                      className="border"
                      onClick={(e) => {
                        toggleLeftContentshow(
                          "customer A||bg_color",
                          e,
                          "57||0"
                        );
                      }}
                      style={applyCss("customer A")}
                    >
                      {sliderDummyData.customer_a}
                    </span>
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_119" && (
              <div
                className="hoverDiv restaurant_vid_119  d-flex align-items-center   wdh_fix"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div
                  className="mid w-100 p-3 text-center text-white"
                  style={{
                    backgroundColor: `${
                      sliderDummyData.bg_color &&
                      sliderDummyData.bg_color.includes("#")
                        ? "#" + sliderDummyData.bg_color.split("#")[1]
                        : "#" + sliderDummyData.bg_color
                    }`,
                  }}
                >
                  <div
                    className="border"
                    onClick={(e) => {
                      toggleLeftContentshow(
                        "spring A||spring B||bg_color",
                        e,
                        "19||19||0"
                      );
                    }}
                  >
                    <div className="line_1" style={applyCss("spring A")}>
                      {sliderDummyData.spring_a}
                    </div>
                    <div className="line_2" style={applyCss("spring B")}>
                      {sliderDummyData.spring_b}
                    </div>
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_120" && (
              <div
                className="hoverDiv restaurant_vid_120  d-flex align-items-center   wdh_fix"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div className="mid w-100 p-3 text-center text-white">
                  <div
                    className="border"
                    onClick={(e) => {
                      toggleLeftContentshow("help A||help B", e, "13||33");
                    }}
                  >
                    <div className="line_1" style={applyCss("help A")}>
                      {sliderDummyData.help_a}
                    </div>
                    <div className="line_2" style={applyCss("help B")}>
                      {sliderDummyData.help_b}
                    </div>
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_121" && (
              <div
                className="hoverDiv restaurant_vid_121  d-flex align-items-center flex-column p-0  wdh_fix"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div className="mid w-100 p-3 text-center text-white mt-auto">
                  <div className="line_1 border">
                    <img
                      src={sliderDummyData.logo}
                      className="img-fluid"
                      alt="img"
                      onClick={(e) => {
                        toggleRightshow("logo", e);
                      }}
                    />
                  </div>
                  <div
                    className="line_2 border mt-1"
                    onClick={(e) => {
                      toggleLeftContentshow("suffer A", e, "27");
                    }}
                    style={applyCss("suffer A")}
                  >
                    {sliderDummyData.suffer_a}
                  </div>
                </div>

                <div
                  className="ftr p-3 w-100 text-center mt-auto"
                  style={{
                    backgroundColor: `${
                      sliderDummyData.bg_color &&
                      sliderDummyData.bg_color.includes("#")
                        ? "#" + sliderDummyData.bg_color.split("#")[1]
                        : "#" + sliderDummyData.bg_color
                    }`,
                  }}
                >
                  <ul
                    className="m-0 p-0 list-unstyled d-flex justify-content-center border"
                    onClick={(e) => {
                      toggleLeftContentshow(
                        "number||website||bg_color",
                        e,
                        "15||35||0"
                      );
                    }}
                  >
                    <li>
                      <i>
                        <img
                          src="https://d37q3r06begyqi.cloudfront.net/VidAmaze/app-images/slides_images/phone13.png"
                          alt="img"
                        />
                      </i>
                      <span style={applyCss("number")}>
                        {sliderDummyData.number}
                      </span>
                    </li>
                    <li>
                      <i>
                        <img
                          src="https://d37q3r06begyqi.cloudfront.net/VidAmaze/app-images/slides_images/web11.png"
                          alt="img"
                        />
                      </i>
                      <span style={applyCss("website")}>
                        {" "}
                        {sliderDummyData.website}
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            )}

            {active_slide_name === "slide_93" && (
              <div
                className="hoverDiv loyalty_vid_93 p-4 d-flex align-items-center justify-content-center  wdh_fix flex-column"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <h1
                  className="m-0 border"
                  onClick={(e) => {
                    toggleLeftContentshow("hey", e, "10");
                  }}
                  style={applyCss("hey")}
                >
                  {sliderDummyData.hey}
                </h1>
                <h1 className="dynamic_text">{dynamicText}</h1>
              </div>
            )}

            {active_slide_name === "slide_94" && (
              <div
                className="hoverDiv loyalty_vid_94 p-4 d-flex align-items-center justify-content-center  wdh_fix"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div className="mid text-center pt-5">
                  <div
                    className="border"
                    onClick={(e) => {
                      toggleLeftContentshow(
                        "professional A||professional B",
                        e,
                        "27||14"
                      );
                    }}
                  >
                    <h2 style={applyCss("professional A")}>
                      {sliderDummyData.professional_a}
                    </h2>
                    <h3 style={applyCss("professional B")}>
                      {sliderDummyData.professional_b}
                    </h3>
                  </div>
                  <h4
                    className="border mt-1"
                    onClick={(e) => {
                      toggleLeftContentshow(
                        "professional C||bg_color",
                        e,
                        "27||0"
                      );
                    }}
                    style={applyBackGround("backgroundColor", "bg_color")}
                  >
                    <span style={applyCss("professional C")}>
                      {sliderDummyData.professional_c}
                    </span>
                  </h4>
                </div>
              </div>
            )}

            {active_slide_name === "slide_95" && (
              <div
                className="hoverDiv loyalty_vid_95 p-4 d-flex align-items-center justify-content-center  wdh_fix"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div
                  className="mid text-center border lh-1"
                  onClick={(e) => {
                    toggleLeftContentshow(
                      "moments A||moments B||moments C||moments D",
                      e,
                      "15||3||37||25"
                    );
                  }}
                >
                  <div className="line_1" style={applyCss("moments A")}>
                    {sliderDummyData.moments_a}
                  </div>
                  <div className="line_2 mt-1" style={applyCss("moments B")}>
                    {sliderDummyData.moments_b}
                  </div>
                  <div className="line_3 mt-1" style={applyCss("moments C")}>
                    {sliderDummyData.moments_c}
                  </div>
                  <div className="line_4 mt-1" style={applyCss("moments D")}>
                    {sliderDummyData.moments_d}
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_96" && (
              <div
                className="hoverDiv loyalty_vid_96 p-4 d-flex align-items-center justify-content-center  wdh_fix"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div className="mid text-center">
                  <div
                    className="line_1 border"
                    onClick={(e) => {
                      toggleLeftContentshow("trained A", e, "32");
                    }}
                    style={applyCss("trained A")}
                  >
                    {sliderDummyData.trained_a}
                  </div>
                  <div className="line_2 pt-1 pb-1 m-3">
                    <div
                      className="percent border"
                      onClick={(e) => {
                        toggleLeftContentshow("trained B||bg_color", e, "3||0");
                      }}
                      id="burst-12"
                      style={{
                        "--background":
                          sliderDummyData.bg_color &&
                          sliderDummyData.bg_color.includes("#")
                            ? "#" + sliderDummyData.bg_color.split("#")[1]
                            : "#" + sliderDummyData.bg_color,
                      }}
                    >
                      <span style={applyCss("trained B")}>
                        {" "}
                        {sliderDummyData.trained_b}
                      </span>
                    </div>
                  </div>
                  <div
                    className="border lh-1"
                    onClick={(e) => {
                      toggleLeftContentshow(
                        "trained C||trained D",
                        e,
                        "35||36"
                      );
                    }}
                  >
                    <div className="line_3" style={applyCss("trained C")}>
                      {sliderDummyData.trained_c}
                    </div>
                    <div className="line_4 mt-1" style={applyCss("trained D")}>
                      {sliderDummyData.trained_d}
                    </div>
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_97" && (
              <div
                className="hoverDiv loyalty_vid_97 pt-4 pb-4 d-flex align-items-center justify-content-center  wdh_fix"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div
                  className="mid w-100 text-center border lh-1"
                  onClick={(e) => {
                    toggleLeftContentshow(
                      "master A||master B||master C",
                      e,
                      "29||26||16"
                    );
                  }}
                >
                  <div className="line_1 lh-1 p-3" style={applyCss("master A")}>
                    {sliderDummyData.master_a}
                  </div>
                  <div className="line_2 mt-1" style={applyCss("master B")}>
                    {sliderDummyData.master_b}
                  </div>
                  <div className="line_3 mt-1" style={applyCss("master C")}>
                    {sliderDummyData.master_c}
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_98" && (
              <div
                className="hoverDiv loyalty_vid_98 pt-4 pb-4 d-flex align-items-center justify-content-center  wdh_fix"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div className="mid w-100 text-center">
                  <div
                    className="border"
                    onClick={(e) => {
                      toggleLeftContentshow("need A||need B", e, "24||22");
                    }}
                  >
                    <div className="line_1" style={applyCss("need A")}>
                      {sliderDummyData.need_a}
                    </div>
                    <div className="line_2" style={applyCss("need B")}>
                      {sliderDummyData.need_b}
                    </div>
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_99" && (
              <div
                className="hoverDiv loyalty_vid_99 p-4 d-flex align-items-center justify-content-center  wdh_fix"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div
                  className="mid  text-center border lh-1"
                  onClick={(e) => {
                    toggleLeftContentshow("work A||work B", e, "42||14");
                  }}
                >
                  <div className="line_1" style={applyCss("work A")}>
                    {sliderDummyData.work_a}
                  </div>
                  <div className="line_2 mt-1" style={applyCss("work B")}>
                    {sliderDummyData.work_b}
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_100" && (
              <div
                className="hoverDiv loyalty_vid_100 p-4 d-flex align-items-center justify-content-center  wdh_fix"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div className="mid  text-center">
                  <div
                    className="border lh-1"
                    onClick={(e) => {
                      toggleLeftContentshow(
                        "problem A||problem B",
                        e,
                        "30||24"
                      );
                    }}
                  >
                    <div className="line_1" style={applyCss("problem A")}>
                      {sliderDummyData.problem_a}
                    </div>
                    <div className="line_2" style={applyCss("problem B")}>
                      {sliderDummyData.problem_b}
                    </div>
                  </div>
                  <div
                    className="line_3 pt-2 border mt-1"
                    onClick={(e) => {
                      toggleLeftContentshow("problem C||bg_color", e, "24||0");
                    }}
                  >
                    <a
                      href="#0"
                      className="btn"
                      style={applyBackGround("backgroundColor", "bg_color")}
                    >
                      <span style={applyCss("problem C")}>
                        {sliderDummyData.problem_c}
                      </span>
                    </a>
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_101" && (
              <div
                className="hoverDiv loyalty_vid_101 p-4 d-flex align-items-center justify-content-center  wdh_fix"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div className="mid  text-center">
                  <div className="shop_logo pb-4 border">
                    <img
                      src={sliderDummyData.logo}
                      className="img-fluid"
                      alt="img"
                      onClick={(e) => {
                        toggleRightshow("logo", e);
                      }}
                    />
                  </div>
                  <div
                    className="border lh-1 mt-1"
                    onClick={(e) => {
                      toggleLeftContentshow("suffer A||suffer B", e, "32||32");
                    }}
                  >
                    <div className="line_1 pt-2" style={applyCss("suffer A")}>
                      {sliderDummyData.suffer_a}
                    </div>
                    <div className="line_2 pb-4" style={applyCss("suffer B")}>
                      {sliderDummyData.suffer_b}
                    </div>
                  </div>
                  <div className="line_3">
                    <div
                      className="call d-inline-block m-3 border"
                      onClick={(e) => {
                        toggleLeftContentshow("number", e, "15");
                      }}
                    >
                      <i className="me-2">
                        <img
                          src="https://d37q3r06begyqi.cloudfront.net/VidAmaze/app-images/slides_images/phone10.png"
                          alt="img"
                        />
                      </i>
                      <span style={applyCss("number")}>
                        {" "}
                        {sliderDummyData.number}
                      </span>
                    </div>
                    <div
                      className="web d-inline-block m-3 border"
                      onClick={(e) => {
                        toggleLeftContentshow("website", e, "35");
                      }}
                    >
                      <i className="me-2">
                        <img
                          src="https://d37q3r06begyqi.cloudfront.net/VidAmaze/app-images/slides_images/web10.png"
                          alt="img"
                        />
                      </i>
                      <span style={applyCss("website")}>
                        {" "}
                        {sliderDummyData.website}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_122" && (
              <div className="welcome_vid_122 p-4 d-flex  justify-content-center   wdh_fix">
                <div className="mid text-white mt-5 pt-5">
                  <div
                    className="line_1 border"
                    onClick={(e) => {
                      toggleLeftContentshow("hey", e, "10");
                    }}
                    style={applyCss("hey")}
                  >
                    {sliderDummyData.hey}
                  </div>
                  <div className="line_2 dynamic_text">{dynamicText}</div>
                </div>
              </div>
            )}
            {active_slide_name === "slide_123" && (
              <div className="welcome_vid_123 p-4 d-flex align-items-center  justify-content-center   wdh_fix">
                <div
                  className="mid text-center border"
                  onClick={(e) => {
                    toggleLeftContentshow(
                      "business A||business B",
                      e,
                      "19||17"
                    );
                  }}
                >
                  <div className="line_1" style={applyCss("business A")}>
                    {sliderDummyData.business_a}
                  </div>
                  <div className="line_2" style={applyCss("business B")}>
                    {sliderDummyData.business_b}
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_124" && (
              <div className="welcome_vid_124 p-4 d-flex align-items-center  justify-content-center   wdh_fix">
                <div
                  className="mid text-center border"
                  onClick={(e) => {
                    toggleLeftContentshow(
                      "serve A||serve B||serve C",
                      e,
                      "20||30||17"
                    );
                  }}
                >
                  <div className="line_1 cursor" style={applyCss("serve A")}>
                    {sliderDummyData.serve_a}
                  </div>
                  <div className="line_2 cursor" style={applyCss("serve B")}>
                    {sliderDummyData.serve_b}
                  </div>
                  <div className="line_3 cursor" style={applyCss("serve C")}>
                    {sliderDummyData.serve_c}
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_125" && (
              <div className="welcome_vid_125 p-4 d-flex align-items-center  justify-content-center   wdh_fix">
                <div
                  className="mid mt-5 pt-5 border lh-1"
                  onClick={(e) => {
                    toggleLeftContentshow(
                      "demand A||demand B||demand C",
                      e,
                      "23||19||16"
                    );
                  }}
                >
                  <div className="line_1" style={applyCss("demand A")}>
                    {sliderDummyData.demand_a}
                  </div>
                  <div className="line_2" style={applyCss("demand B")}>
                    {sliderDummyData.demand_b}
                  </div>
                  <div className="line_3 pt-5" style={applyCss("demand C")}>
                    {sliderDummyData.demand_c}
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_126" && (
              <div className="welcome_vid_126 p-4  d-flex    wdh_fix">
                <div
                  className="mid pt-5 mt-5 ms-5 ps-5  border"
                  onClick={(e) => {
                    toggleLeftContentshow(
                      "floor A||floor B||floor C",
                      e,
                      "18||20||9"
                    );
                  }}
                >
                  <div className="line_1" style={applyCss("floor A")}>
                    {sliderDummyData.floor_a}
                  </div>
                  <div className="line_2 pt-4" style={applyCss("floor B")}>
                    {sliderDummyData.floor_b}
                  </div>
                  <div className="line_3 pt-2" style={applyCss("floor C")}>
                    {sliderDummyData.floor_c}
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_127" && (
              <div className="welcome_vid_127 p-4  d-flex align-items-center justify-content-center    wdh_fix">
                <div
                  className="mid text-center border "
                  onClick={(e) => {
                    toggleLeftContentshow("further A", e, "15");
                  }}
                >
                  <div className="line_1 lh-1" style={applyCss("further A")}>
                    {sliderDummyData.further_a}
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_128" && (
              <div
                className="hoverDiv welcome_vid_128 p-4  d-flex align-items-center justify-content-center    wdh_fix"
                style={{
                  backgroundImage: `url("${sliderDummyData.bg_image}")`,
                }}
              >
                <a
                  href="#0"
                  className="changeImageVideo"
                  onClick={(e) => {
                    toggleRightshow("bg_image", e);
                  }}
                >
                  <img
                    src={`${process.env.PUBLIC_URL}/assets/images/edit_hv.png`}
                    alt="img"
                  />{" "}
                  Change Background Image
                </a>
                <div className="mid">
                  <div className="line_1 mb-4 pb-3 border">
                    <img
                      src={sliderDummyData.logo}
                      className="img-fluid"
                      alt="img"
                      onClick={(e) => {
                        toggleRightshow("logo", e);
                      }}
                    />
                  </div>
                  <div
                    className="line_2 mb-4 border"
                    onClick={(e) => {
                      toggleLeftContentshow("number", e, "15");
                    }}
                  >
                    <i className="me-3">
                      <img
                        src="https://d37q3r06begyqi.cloudfront.net/VidAmaze/app-images/slides_images/phone14.png"
                        alt="img"
                      />
                    </i>
                    <span style={applyCss("number")}>
                      {sliderDummyData.number}
                    </span>
                  </div>
                  <div
                    className="line_3 border"
                    onClick={(e) => {
                      toggleLeftContentshow("website", e, "35");
                    }}
                  >
                    <i className="me-3">
                      <img
                        src="https://d37q3r06begyqi.cloudfront.net/VidAmaze/app-images/slides_images/web12.png"
                        alt="img"
                      />
                    </i>
                    <span style={applyCss("website")}>
                      {sliderDummyData.website}
                    </span>
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_129" && (
              <div
                className="hoverDiv visitusagain_vid_129 p-4 d-flex align-items-center justify-content-center  wdh_fix"
                style={applyBackGround("backgroundColor", "bg_color")}
              >
                <a
                  href="#0"
                  className="changeImageVideo"
                  onClick={(e) => {
                    toggleLeftContentshow("bg_color", e, "0");
                  }}
                >
                  <img
                    src={`${process.env.PUBLIC_URL}/assets/images/edit_hv.png`}
                    alt="img"
                  />{" "}
                  Change Background Color
                </a>
                <div className="mid text-center text-white">
                  <div
                    className="line_1 border"
                    onClick={(e) => {
                      toggleLeftContentshow("hey", e, "10");
                    }}
                    style={applyCss("hey")}
                  >
                    {sliderDummyData.hey}
                  </div>
                  <div className="line_2">{dynamicText}</div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_130" && (
              <div
                className="hoverDiv visitusagain_vid_130 p-4 d-flex align-items-center justify-content-center  wdh_fix"
                style={applyBackGround("backgroundColor", "bg_color")}
              >
                <a
                  href="#0"
                  className="changeImageVideo"
                  onClick={(e) => {
                    toggleLeftContentshow("bg_color", e, "0");
                  }}
                >
                  <img
                    src={`${process.env.PUBLIC_URL}/assets/images/edit_hv.png`}
                    alt="img"
                  />{" "}
                  Change Background Color
                </a>
                <div
                  className="mid text-center text-white border"
                  onClick={(e) => {
                    toggleLeftContentshow(
                      "floor A||floor B||floor C",
                      e,
                      "7||6||12"
                    );
                  }}
                >
                  <div className="line_1 d-flex align-items-end">
                    <div className="txt_a" style={applyCss("floor A")}>
                      {sliderDummyData.floor_a}
                    </div>
                    <div className="txt_b" style={applyCss("floor B")}>
                      {sliderDummyData.floor_b}
                    </div>
                  </div>
                  <div className="line_2" style={applyCss("floor C")}>
                    {sliderDummyData.floor_c}
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_131" && (
              <div
                className="hoverDiv visitusagain_vid_131 p-4 d-flex align-items-center justify-content-center  wdh_fix"
                style={applyBackGround("backgroundColor", "bg_color")}
              >
                <a
                  href="#0"
                  className="changeImageVideo"
                  onClick={(e) => {
                    toggleLeftContentshow("bg_color", e, "0");
                  }}
                >
                  <img
                    src={`${process.env.PUBLIC_URL}/assets/images/edit_hv.png`}
                    alt="img"
                  />{" "}
                  Change Background Color
                </a>
                <div
                  className="mid text-center text-white border"
                  onClick={(e) => {
                    toggleLeftContentshow(
                      "business A||business B",
                      e,
                      "16||11"
                    );
                  }}
                >
                  <div className="line_1" style={applyCss("business A")}>
                    {sliderDummyData.business_a}
                  </div>
                  <div className="line_2" style={applyCss("business B")}>
                    {sliderDummyData.business_b}
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_132" && (
              <div
                className="hoverDiv visitusagain_vid_133 p-4 d-flex align-items-center justify-content-center  wdh_fix"
                style={applyBackGround("backgroundColor", "bg_color")}
              >
                <a
                  href="#0"
                  className="changeImageVideo"
                  onClick={(e) => {
                    toggleLeftContentshow("bg_color", e, "0");
                  }}
                >
                  <img
                    src={`${process.env.PUBLIC_URL}/assets/images/edit_hv.png`}
                    alt="img"
                  />{" "}
                  Change Background Color
                </a>
                <div
                  className="mid text-center text-white border"
                  onClick={(e) => {
                    toggleLeftContentshow(
                      "demand A||demand B||demand C",
                      e,
                      "18||16||14"
                    );
                  }}
                >
                  <div className="line_1" style={applyCss("demand A")}>
                    {sliderDummyData.demand_a}
                  </div>
                  <div className="line_2" style={applyCss("demand B")}>
                    {sliderDummyData.demand_b}
                  </div>
                  <div className="line_3" style={applyCss("demand C")}>
                    {sliderDummyData.demand_c}
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_133" && (
              <div
                className="hoverDiv visitusagain_vid_133 p-4 d-flex align-items-center justify-content-center  wdh_fix"
                style={applyBackGround("backgroundColor", "bg_color")}
              >
                <a
                  href="#0"
                  className="changeImageVideo"
                  onClick={(e) => {
                    toggleLeftContentshow("bg_color", e, "0");
                  }}
                >
                  <img
                    src={`${process.env.PUBLIC_URL}/assets/images/edit_hv.png`}
                    alt="img"
                  />{" "}
                  Change Background Color
                </a>
                <div
                  className="mid text-center text-white border"
                  onClick={(e) => {
                    toggleLeftContentshow(
                      "serve A||serve B||serve C",
                      e,
                      "8||12||12"
                    );
                  }}
                >
                  <div className="line_1" style={applyCss("serve A")}>
                    {sliderDummyData.serve_a}
                  </div>
                  <div className="line_2" style={applyCss("serve B")}>
                    {sliderDummyData.serve_b}
                  </div>
                  <div className="line_3" style={applyCss("serve C")}>
                    {sliderDummyData.serve_c}
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_134" && (
              <div
                className="hoverDiv visitusagain_vid_134 p-4 d-flex align-items-center justify-content-center  wdh_fix"
                style={applyBackGround("backgroundColor", "bg_color")}
              >
                <a
                  href="#0"
                  className="changeImageVideo"
                  onClick={(e) => {
                    toggleLeftContentshow("bg_color", e, "0");
                  }}
                >
                  <img
                    src={`${process.env.PUBLIC_URL}/assets/images/edit_hv.png`}
                    alt="img"
                  />{" "}
                  Change Background Color
                </a>
                <div
                  className="mid text-center text-white border pt-3"
                  onClick={(e) => {
                    toggleLeftContentshow("spring A||spring B", e, "19||18");
                  }}
                >
                  <div className="line_1 " style={applyCss("spring A")}>
                    {sliderDummyData.spring_a}
                  </div>
                  <div className="line_2" style={applyCss("spring B")}>
                    {sliderDummyData.spring_b}
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_135" && (
              <div
                className="hoverDiv visitusagain_vid_135 p-4 d-flex align-items-center justify-content-center  wdh_fix"
                style={applyBackGround("backgroundColor", "bg_color")}
              >
                <a
                  href="#0"
                  className="changeImageVideo"
                  onClick={(e) => {
                    toggleLeftContentshow("bg_color", e, "0");
                  }}
                >
                  <img
                    src={`${process.env.PUBLIC_URL}/assets/images/edit_hv.png`}
                    alt="img"
                  />{" "}
                  Change Background Color
                </a>
                <div className="mid  text-white ">
                  <div
                    className="top ms-4 border p-1"
                    onClick={(e) => {
                      toggleLeftContentshow(
                        "window A||window B||bg_color_stroke",
                        e,
                        "13||16||0"
                      );
                    }}
                  >
                    <div className="moreinfo d-flex justify-content-between align-items-center">
                      <div
                        className="bdr_left"
                        style={{
                          borderBottom: `${
                            sliderDummyData.bg_color_stroke &&
                            sliderDummyData.bg_color_stroke.includes("#")
                              ? "#" +
                                sliderDummyData.bg_color_stroke.split("#")[1]
                              : "#" + sliderDummyData.bg_color_stroke
                          } 5px solid`,
                        }}
                      >
                        &nbsp;
                      </div>
                      <div className="minfo_text" style={applyCss("window A")}>
                        {sliderDummyData.window_a}
                      </div>
                    </div>
                    <div
                      className="line_1 mb-4"
                      style={{
                        borderBottom: `${
                          sliderDummyData.bg_color_stroke &&
                          sliderDummyData.bg_color_stroke.includes("#")
                            ? "#" +
                              sliderDummyData.bg_color_stroke.split("#")[1]
                            : "#" + sliderDummyData.bg_color_stroke
                        } 5px solid`,
                      }}
                    >
                      <span style={applyCss("window B")}>
                        {sliderDummyData.window_b}
                      </span>
                    </div>
                  </div>

                  <div className="line_2 pb-4 mb-2 pt-2 border mt-1">
                    <img
                      src={sliderDummyData.logo}
                      width={"240px"}
                      className="img-fluid"
                      alt="img"
                      onClick={(e) => {
                        toggleRightshow("logo", e);
                      }}
                    />
                  </div>
                  <div
                    className="line_3 border"
                    onClick={(e) => {
                      toggleLeftContentshow("number", e, "15");
                    }}
                  >
                    <i>
                      <img
                        src="https://d37q3r06begyqi.cloudfront.net/VidAmaze/app-images/slides_images/phone12.png"
                        alt="img"
                      />
                    </i>
                    <span style={applyCss("number")}>
                      {sliderDummyData.number}
                    </span>
                  </div>
                  <div
                    className="line_4 border mt-1"
                    onClick={(e) => {
                      toggleLeftContentshow("website", e, "35");
                    }}
                  >
                    <i>
                      <img
                        src="https://d37q3r06begyqi.cloudfront.net/VidAmaze/app-images/slides_images/web11.png"
                        alt="img"
                      />
                    </i>
                    <span style={applyCss("website")}>
                      {" "}
                      {sliderDummyData.website}
                    </span>
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_136" && (
              <div
                className="hoverDiv thankyou_vid_136 p-4 d-flex align-items-center justify-content-center  wdh_fix"
                style={applyBackGround("backgroundColor", "bg_color")}
              >
                <a
                  href="#0"
                  className="changeImageVideo"
                  onClick={(e) => {
                    toggleLeftContentshow("bg_color", e, "0");
                  }}
                >
                  <img
                    src={`${process.env.PUBLIC_URL}/assets/images/edit_hv.png`}
                    alt="img"
                  />{" "}
                  Change Background Color
                </a>
                <div className="mid text-center text-white">
                  <div
                    className="line_1 border"
                    onClick={(e) => {
                      toggleLeftContentshow("hey", e, "10");
                    }}
                    style={applyCss("hey")}
                  >
                    {sliderDummyData.hey}
                  </div>
                  <div className="line_2">{dynamicText}</div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_137" && (
              <div
                className="hoverDiv thankyou_vid_137 p-4 d-flex align-items-center justify-content-center  wdh_fix"
                style={applyBackGround("backgroundColor", "bg_color")}
              >
                <a
                  href="#0"
                  className="changeImageVideo"
                  onClick={(e) => {
                    toggleLeftContentshow("bg_color", e, "0");
                  }}
                >
                  <img
                    src={`${process.env.PUBLIC_URL}/assets/images/edit_hv.png`}
                    alt="img"
                  />{" "}
                  Change Background Color
                </a>
                <div
                  className="mid text-center text-white  border"
                  onClick={(e) => {
                    toggleLeftContentshow(
                      "professional A||professional B||professional C",
                      e,
                      "7||6||12"
                    );
                  }}
                >
                  <div className="line_1 d-flex align-items-end">
                    <div className="txt_a" style={applyCss("professional A")}>
                      {sliderDummyData.professional_a}
                    </div>
                    <div className="txt_b" style={applyCss("professional B")}>
                      {sliderDummyData.professional_b}
                    </div>
                  </div>
                  <div className="line_2" style={applyCss("professional C")}>
                    {sliderDummyData.professional_c}
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_138" && (
              <div
                className="hoverDiv thankyou_vid_138 p-4 d-flex align-items-center justify-content-center  wdh_fix"
                style={applyBackGround("backgroundColor", "bg_color")}
              >
                <a
                  href="#0"
                  className="changeImageVideo"
                  onClick={(e) => {
                    toggleLeftContentshow("bg_color", e, "0");
                  }}
                >
                  <img
                    src={`${process.env.PUBLIC_URL}/assets/images/edit_hv.png`}
                    alt="img"
                  />{" "}
                  Change Background Color
                </a>
                <div
                  className="mid text-center text-white border"
                  onClick={(e) => {
                    toggleLeftContentshow("need A||need B", e, "16||11");
                  }}
                >
                  <div className="line_1" style={applyCss("need A")}>
                    {sliderDummyData.need_a}
                  </div>
                  <div className="line_2" style={applyCss("need B")}>
                    {sliderDummyData.need_b}
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_139" && (
              <div
                className="hoverDiv thankyou_vid_139 p-4 d-flex align-items-center justify-content-center  wdh_fix"
                style={applyBackGround("backgroundColor", "bg_color")}
              >
                <a
                  href="#0"
                  className="changeImageVideo"
                  onClick={(e) => {
                    toggleLeftContentshow("bg_color", e, "0");
                  }}
                >
                  <img
                    src={`${process.env.PUBLIC_URL}/assets/images/edit_hv.png`}
                    alt="img"
                  />{" "}
                  Change Background Color
                </a>
                <div
                  className="mid text-center text-white border"
                  onClick={(e) => {
                    toggleLeftContentshow(
                      "serve A||serve B||serve C",
                      e,
                      "6||9||12"
                    );
                  }}
                >
                  <div className="line_1" style={applyCss("serve A")}>
                    {sliderDummyData.serve_a}
                  </div>
                  <div className="line_2" style={applyCss("serve B")}>
                    {sliderDummyData.serve_b}
                  </div>
                  <div className="line_3" style={applyCss("serve C")}>
                    {sliderDummyData.serve_c}
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_140" && (
              <div
                className="hoverDiv thankyou_vid_140 p-4 d-flex align-items-center justify-content-center  wdh_fix"
                style={applyBackGround("backgroundColor", "bg_color")}
              >
                <a
                  href="#0"
                  className="changeImageVideo"
                  onClick={(e) => {
                    toggleLeftContentshow("bg_color", e, "0");
                  }}
                >
                  <img
                    src={`${process.env.PUBLIC_URL}/assets/images/edit_hv.png`}
                    alt="img"
                  />{" "}
                  Change Background Color
                </a>
                <div
                  className="mid text-center text-white border"
                  onClick={(e) => {
                    toggleLeftContentshow(
                      "demand A||demand B||demand C",
                      e,
                      "18||19||22"
                    );
                  }}
                >
                  <div className="line_1" style={applyCss("demand A")}>
                    {sliderDummyData.demand_a}
                  </div>
                  <div className="line_2" style={applyCss("demand B")}>
                    {sliderDummyData.demand_b}
                  </div>
                  <div className="line_3" style={applyCss("demand C")}>
                    {sliderDummyData.demand_c}
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_141" && (
              <div
                className="hoverDiv thankyou_vid_141 p-4 d-flex align-items-center justify-content-center  wdh_fix"
                style={applyBackGround("backgroundColor", "bg_color")}
              >
                <a
                  href="#0"
                  className="changeImageVideo"
                  onClick={(e) => {
                    toggleLeftContentshow("bg_color", e, "0");
                  }}
                >
                  <img
                    src={`${process.env.PUBLIC_URL}/assets/images/edit_hv.png`}
                    alt="img"
                  />{" "}
                  Change Background Color
                </a>
                <div className="mid  text-white">
                  <div
                    className="top ms-4 p border p-1"
                    onClick={(e) => {
                      toggleLeftContentshow(
                        "floor A||floor B||bg_color_stroke",
                        e,
                        "13||16||0"
                      );
                    }}
                  >
                    <div className="moreinfo d-flex justify-content-between align-items-center">
                      <div
                        className="bdr_left"
                        style={{
                          borderBottom: `${
                            sliderDummyData.bg_color_stroke &&
                            sliderDummyData.bg_color_stroke.includes("#")
                              ? "#" +
                                sliderDummyData.bg_color_stroke.split("#")[1]
                              : "#" + sliderDummyData.bg_color_stroke
                          } 5px solid`,
                        }}
                      >
                        &nbsp;
                      </div>
                      <div className="minfo_text" style={applyCss("floor A")}>
                        {sliderDummyData.floor_a}
                      </div>
                    </div>
                    <div
                      className="line_1 mb-4"
                      style={{
                        borderBottom: `${
                          sliderDummyData.bg_color_stroke &&
                          sliderDummyData.bg_color_stroke.includes("#")
                            ? "#" +
                              sliderDummyData.bg_color_stroke.split("#")[1]
                            : "#" + sliderDummyData.bg_color_stroke
                        } 5px solid`,
                      }}
                    >
                      <span style={applyCss("floor B")}>
                        {sliderDummyData.floor_b}
                      </span>
                    </div>
                  </div>

                  <div className="line_2 pb-4 mb-2 pt-2 border mt-1">
                    <img
                      src={sliderDummyData.logo}
                      className="img-fluid"
                      alt="img"
                      onClick={(e) => {
                        toggleRightshow("logo", e);
                      }}
                      width={"240"}
                    />
                  </div>
                  <div
                    className="line_3 border mt-1"
                    onClick={(e) => {
                      toggleLeftContentshow("number", e, "15");
                    }}
                  >
                    <i>
                      <img
                        src="https://d37q3r06begyqi.cloudfront.net/VidAmaze/app-images/slides_images/phone12.png"
                        alt="img"
                      />
                    </i>
                    <span style={applyCss("number")}>
                      {sliderDummyData.number}
                    </span>
                  </div>
                  <div
                    className="line_4 border mt-1"
                    onClick={(e) => {
                      toggleLeftContentshow("website", e, "35");
                    }}
                  >
                    <i>
                      <img
                        src="https://d37q3r06begyqi.cloudfront.net/VidAmaze/app-images/slides_images/web11.png"
                        alt="img"
                      />
                    </i>
                    <span style={applyCss("website")}>
                      {sliderDummyData.website}
                    </span>
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_71" && (
              <div
                className="hoverDiv slide_vid_71 p-4 d-flex align-items-center justify-content-center  wdh_fix"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div className="mid pt-5 flex-column">
                  <h1
                    className="m-0 text-center border"
                    onClick={(e) => {
                      toggleLeftContentshow("hey", e, "10");
                    }}
                    style={applyCss("hey")}
                  >
                    {sliderDummyData.hey}{" "}
                  </h1>
                  <h1 className="m-0 text-center dynamicText">{dynamicText}</h1>
                </div>
              </div>
            )}

            {active_slide_name === "slide_72" && (
              <div
                className="hoverDiv slide_vid_72 p-4 d-flex align-items-center justify-content-center  wdh_fix"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />

                <div className="mid">
                  <div className="row align-items-center">
                    <div className="col-sm-5">
                      <div
                        className="s72_left  border"
                        onClick={(e) => {
                          toggleLeftContentshow(
                            "pamper A||pamper B||pamper C||pamper D",
                            e,
                            "6||8||10||10"
                          );
                        }}
                      >
                        <div className="line1" style={applyCss("pamper A")}>
                          {sliderDummyData.pamper_a}
                        </div>
                        <div className="line2" style={applyCss("pamper B")}>
                          {sliderDummyData.pamper_b}
                        </div>
                        <div className="line3" style={applyCss("pamper C")}>
                          {sliderDummyData.pamper_c}
                        </div>
                        <div className="line4" style={applyCss("pamper D")}>
                          {sliderDummyData.pamper_d}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_72_0" && (
              <div
                className="hoverDiv slide_vid_72 p-4 d-flex align-items-center justify-content-center  wdh_fix"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div className="mid">
                  <div className="row align-items-center">
                    <div className="col-sm-7">
                      <div
                        className="s72_right border"
                        onClick={(e) => {
                          toggleLeftContentshow(
                            "pamper A||pamper B||pamper C",
                            e,
                            "6||16||6"
                          );
                        }}
                      >
                        <div className="line1" style={applyCss("pamper A")}>
                          {sliderDummyData.pamper_a}
                        </div>
                        <div className="line2" style={applyCss("pamper B")}>
                          {sliderDummyData.pamper_b}
                        </div>
                        <div className="line3" style={applyCss("pamper C")}>
                          {sliderDummyData.pamper_c}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_73" && (
              <div
                className="hoverDiv slide_vid_73 p-4 d-flex  justify-content-center  wdh_fix"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div className="mid text-center pt-5">
                  <div
                    className="rw_1  pt-3 border"
                    onClick={(e) => {
                      toggleLeftContentshow(
                        "service A||service B",
                        e,
                        "13||19"
                      );
                    }}
                  >
                    <div className="line_1" style={applyCss("service A")}>
                      {sliderDummyData.service_a}
                    </div>
                    <div className="line_2" style={applyCss("service B")}>
                      {sliderDummyData.service_b}
                    </div>
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_73_0" && (
              <div
                className="hoverDiv slide_vid_73 p-4 d-flex  justify-content-center  wdh_fix"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div className="mid text-center pt-5">
                  <div
                    className="rw_1  pt-3 border"
                    onClick={(e) => {
                      toggleLeftContentshow(
                        "service A||service B",
                        e,
                        "16||21"
                      );
                    }}
                  >
                    <div className="line_3" style={applyCss("service A")}>
                      {sliderDummyData.service_a}
                    </div>
                    <div className="line_4" style={applyCss("service B")}>
                      {sliderDummyData.service_b}
                    </div>
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_74" && (
              <div
                className="hoverDiv slide_vid_74 p-4 d-flex align-items-center  justify-content-center  wdh_fix"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div
                  className="mid text-center border"
                  onClick={(e) => {
                    toggleLeftContentshow(
                      "customer A||customer B||customer C",
                      e,
                      "18||9||18"
                    );
                  }}
                >
                  <div className="line_1" style={applyCss("customer A")}>
                    {sliderDummyData.customer_a}
                  </div>
                  <div className="line_2" style={applyCss("customer B")}>
                    {sliderDummyData.customer_b}
                  </div>
                  <div className="line_3" style={applyCss("customer C")}>
                    {sliderDummyData.customer_c}
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_74_0" && (
              <div className="hoverDiv slide_vid_74 p-4 d-flex align-items-center  justify-content-center  wdh_fix">
                <HoveDiv />
                <div
                  className="mid text-center border"
                  onClick={(e) => {
                    toggleLeftContentshow(
                      "customer A||customer B",
                      e,
                      "15||16"
                    );
                  }}
                >
                  <div className="line_4" style={applyCss("customer A")}>
                    {sliderDummyData.customer_a}
                  </div>
                  <div className="line_5" style={applyCss("customer B")}>
                    {sliderDummyData.customer_b}
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_75" && (
              <div
                className="hoverDiv slide_vid_75 d-flex align-items-end  justify-content-center  wdh_fix"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div className="center w-100">
                  <div className="bdy  p-3 ps-5 pe-5 mb-4 border">
                    <div
                      className="rw_first "
                      onClick={(e) => {
                        toggleLeftContentshow(
                          "spring A||spring B||bg_color",
                          e,
                          "19||22||0"
                        );
                      }}
                      style={applyBackGround(
                        "borderLeft",
                        "bg_color",
                        " 5px solid"
                      )}
                    >
                      <div className="line_1" style={applyCss("spring A")}>
                        {sliderDummyData.spring_a}
                      </div>
                      <div className="line_2" style={applyCss("spring B")}>
                        {" "}
                        {sliderDummyData.spring_b}{" "}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_75_0" && (
              <div
                className="hoverDiv slide_vid_75 d-flex align-items-end  justify-content-center  wdh_fix"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div className="center w-100">
                  <div className="bdy  p-3 ps-5 pe-5">
                    <div
                      className="rw_second text-end pt-4 border"
                      onClick={(e) => {
                        toggleLeftContentshow("spring D", e, "39");
                      }}
                      style={applyCss("spring D")}
                    >
                      {sliderDummyData.spring_d}
                    </div>
                  </div>

                  <div
                    className="ftr border"
                    onClick={(e) => {
                      toggleLeftContentshow("spring C||bg_color", e, "28||0");
                    }}
                    style={{
                      backgroundColor: `${
                        sliderDummyData.bg_color &&
                        sliderDummyData.bg_color.includes("#")
                          ? "#" + sliderDummyData.bg_color.split("#")[1]
                          : "#" + sliderDummyData.bg_color
                      }`,
                    }}
                  >
                    <i className="me-4">
                      <img
                        src="https://d37q3r06begyqi.cloudfront.net/VidAmaze/app-images/slides_images/watch.png"
                        className="img-fluid"
                        alt="img"
                      />
                    </i>{" "}
                    <span style={applyCss("spring C")}>
                      {sliderDummyData.spring_c}
                    </span>
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_76" && (
              <div
                className="hoverDiv slide_vid_76 p-4 d-flex align-items-center  justify-content-center  wdh_fix"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div className="mid text-center">
                  <div
                    className="rw_1 border"
                    onClick={(e) => {
                      toggleLeftContentshow("help A||help B", e, "14||31");
                    }}
                  >
                    <div className="line_1" style={applyCss("help A")}>
                      {sliderDummyData.help_a}
                    </div>
                    <div className="line_2" style={applyCss("help B")}>
                      {sliderDummyData.help_b}
                    </div>
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_76_0" && (
              <div
                className="hoverDiv slide_vid_76 p-4 d-flex align-items-center  justify-content-center  wdh_fix"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div className="mid text-center">
                  <div
                    className="rw_2 border"
                    onClick={(e) => {
                      toggleLeftContentshow("help A||help B", e, "24||23");
                    }}
                  >
                    <div className="line_3" style={applyCss("help A")}>
                      {sliderDummyData.help_a}
                    </div>
                    <div className="line_4" style={applyCss("help B")}>
                      {sliderDummyData.help_b}
                    </div>
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_77" && (
              <div
                className="hoverDiv slide_vid_77 p-4 d-flex align-items-center justify-content-center  wdh_fix"
                style={{
                  backgroundImage: `url("${sliderDummyData.bg_image}")`,
                }}
              >
                <a
                  href="#0"
                  className="changeImageVideo"
                  onClick={(e) => {
                    toggleRightshow("bg_image", e);
                  }}
                >
                  <img
                    src={`${process.env.PUBLIC_URL}/assets/images/edit_hv.png`}
                    alt="img"
                  />{" "}
                  Change Background Image
                </a>
                <div className="mid ">
                  <div className="child_logo mb-4 text-center">
                    <img
                      src={sliderDummyData.logo}
                      className="img-fluid border"
                      alt="img"
                      onClick={(e) => {
                        toggleRightshow("logo", e);
                      }}
                    />
                  </div>

                  <ul className="m-0 p-0 pt-4 list-unstyled">
                    <li
                      className="mt-1 border"
                      onClick={(e) => {
                        toggleLeftContentshow("number", e, "15");
                      }}
                    >
                      <i>
                        <img
                          src="https://d37q3r06begyqi.cloudfront.net/VidAmaze/app-images/slides_images/phone8.png"
                          alt="img"
                        />
                      </i>{" "}
                      <span className="" style={applyCss("number")}>
                        {sliderDummyData.number}
                      </span>
                    </li>
                    <li className="mt-1 border">
                      <i>
                        <img
                          src="https://d37q3r06begyqi.cloudfront.net/VidAmaze/app-images/slides_images/web8.png"
                          alt="img"
                        />
                      </i>{" "}
                      <span
                        onClick={(e) => {
                          toggleLeftContentshow("website", e, "35");
                        }}
                        style={applyCss("website")}
                      >
                        {sliderDummyData.website}
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            )}

            {active_slide_name === "slide_84" && (
              <div className="university_vid_84 wdh_fix p-4 d-flex justify-content-center align-items-center">
                <div
                  className="mid text-center border"
                  onClick={(e) => {
                    toggleLeftContentshow(
                      "window A||window B||window C",
                      e,
                      "20||30||30"
                    );
                  }}
                >
                  <div className="line_1 pb-1">{sliderDummyData.window_a}</div>
                  <div className="line_2">{sliderDummyData.window_b}</div>
                  <div className="line_3">{sliderDummyData.window_c}</div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_85" && (
              <div className="university_vid_85 wdh_fix p-4 d-flex justify-content-center align-items-center">
                <div
                  className="mid text-center border"
                  onClick={(e) => {
                    toggleLeftContentshow("demand B||demand A", e, "15||30");
                  }}
                >
                  <div className="line_1">{sliderDummyData.demand_b}</div>
                  <div className="line_2">{sliderDummyData.demand_a}</div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_85_0" && (
              <div className="university_vid_85_0 wdh_fix p-4 d-flex justify-content-center align-items-center">
                <div
                  className="mid text-center border"
                  onClick={(e) => {
                    toggleLeftContentshow("demand C||demand D", e, "25||30");
                  }}
                >
                  <div className="line_1">{sliderDummyData.demand_c}</div>
                  <div className="line_2">{sliderDummyData.demand_d}</div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_86" && (
              <div className="university_vid_86 wdh_fix p-4 d-flex justify-content-center align-items-center">
                <div
                  className="mid text-center border"
                  onClick={(e) => {
                    toggleLeftContentshow("demand E||demand F", e, "25||30");
                  }}
                >
                  <div className="line_1">{sliderDummyData.demand_e}</div>
                  <div className="line_2">{sliderDummyData.demand_f}</div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_87" && (
              <div className="university_vid_87 wdh_fix p-4 d-flex justify-content-center align-items-center">
                <div className="mid text-center">
                  <div
                    className="line_1 border p-3"
                    onClick={(e) => {
                      toggleLeftContentshow("hey", e, "20");
                    }}
                  >
                    {sliderDummyData.hey}
                  </div>
                  <div className="line_2 mt-4">{dynamicText}</div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_87_0" && (
              <div className="university_vid_87_0 wdh_fix p-4 d-flex justify-content-center align-items-center">
                <div className="mid text-center">
                  <div
                    className="line_1 border"
                    onClick={(e) => {
                      toggleLeftContentshow("meet A", e, "25");
                    }}
                  >
                    {sliderDummyData.meet_a}
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_88" && (
              <div className="university_vid_88 wdh_fix  d-flex justify-content-center align-items-center">
                <div className="mid text-center p-4 w-100">
                  <div
                    className="border"
                    onClick={(e) => {
                      toggleLeftContentshow("spring A||spring B", e, "35||35");
                    }}
                  >
                    <div className="line_1">{sliderDummyData.spring_a}</div>
                    <div className="line_2">{sliderDummyData.spring_b}</div>
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_88_0" && (
              <div className="university_vid_88_0 wdh_fix  d-flex justify-content-center align-items-center">
                <div className="mid text-center p-4 w-100">
                  <div
                    className="border"
                    onClick={(e) => {
                      toggleLeftContentshow("spring C||spring D", e, "35||35");
                    }}
                  >
                    <div className="line_1">{sliderDummyData.spring_c}</div>
                    <div className="line_2">{sliderDummyData.spring_d}</div>
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_89" && (
              <div className="university_vid_89 wdh_fix  d-flex justify-content-center align-items-center">
                <div className="mid text-center p-4 w-100">
                  <div
                    className="border"
                    onClick={(e) => {
                      toggleLeftContentshow("spring E||spring F", e, "35||35");
                    }}
                  >
                    <div className="line_1">{sliderDummyData.spring_e}</div>
                    <div className="line_2">{sliderDummyData.spring_f}</div>
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_89_0" && (
              <div className="university_vid_89_0 wdh_fix  d-flex justify-content-center align-items-center">
                <div className="mid text-center p-4 w-100">
                  <div
                    className="border"
                    onClick={(e) => {
                      toggleLeftContentshow("spring G||spring H", e, "35||35");
                    }}
                  >
                    <div className="line_1">{sliderDummyData.spring_g}</div>
                    <div className="line_2">{sliderDummyData.spring_h}</div>
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_90" && (
              <div className="university_vid_90 wdh_fix  d-flex justify-content-center align-items-center">
                <div
                  className="mid text-center p-4 w-100 border"
                  onClick={(e) => {
                    toggleLeftContentshow("holiday A||holiday B", e, "20||20");
                  }}
                >
                  <div className="line_1">{sliderDummyData.holiday_a}</div>
                  <div className="line_2">{sliderDummyData.holiday_b}</div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_91" && (
              <div className="university_vid_91 wdh_fix  d-flex justify-content-center align-items-center">
                <div className="mid text-center p-2 w-100">
                  <div className="elearn_logo text-center pb-4  pb-2">
                    <img
                      src={sliderDummyData.logo}
                      className="img-fluid border"
                      alt="img"
                      onClick={(e) => {
                        toggleRightshow("logo", e);
                      }}
                    />
                  </div>
                  <div
                    className="border mt-1"
                    onClick={(e) => {
                      toggleLeftContentshow("expert A||expert B", e, "20||30");
                    }}
                  >
                    <div className="line_1 text-center pt-3">
                      {sliderDummyData.expert_a}
                    </div>
                    <div className="line_2 text-center">
                      {sliderDummyData.expert_b}
                    </div>
                  </div>
                  <div className="line_3 pt-5 d-flex justify-content-center align-items-center mt-1">
                    <div
                      className="call me-3 border"
                      onClick={(e) => {
                        toggleLeftContentshow("number", e, "15");
                      }}
                    >
                      <i className="me-2">
                        <img
                          src="https://d37q3r06begyqi.cloudfront.net/VidAmaze/app-images/slides_images/phone15.png"
                          className="img-fluid"
                          alt="img"
                        />
                      </i>{" "}
                      {sliderDummyData.number}
                    </div>
                    <div
                      className="phone ms-3 border mt-1"
                      onClick={(e) => {
                        toggleLeftContentshow("website", e, "35");
                      }}
                    >
                      <i className="me-2">
                        <img
                          src="https://d37q3r06begyqi.cloudfront.net/VidAmaze/app-images/slides_images/web13.png"
                          className="img-fluid"
                          alt="img"
                        />
                      </i>{" "}
                      {sliderDummyData.website}
                    </div>
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_142" && (
              <div
                className="hoverDiv happybirthday_vid_142 p-4 d-flex align-items-end justify-content-center  wdh_fix"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div className="mid text-center text-white mb-5">
                  <div
                    className="line_1 border"
                    onClick={(e) => {
                      toggleLeftContentshow("hey", e, "10");
                    }}
                    style={applyCss("hey")}
                  >
                    {sliderDummyData.hey}
                  </div>
                  <div className="line_2">{dynamicText}</div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_143" && (
              <div
                className="hoverDiv happybirthday_vid_143 p-4 d-flex align-items-end justify-content-center  wdh_fix"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div className="mid text-center text-white mb-2">
                  <div className="happy_birthday_pic">
                    <ul className="m-0 p-0 pe-5 mb-4 list-unstyled d-flex">
                      <li>
                        <img
                          src={sliderDummyData.bg_image_1}
                          className="img-fluid"
                          alt="img"
                          onClick={(e) => {
                            toggleRightshow("bg_image_1", e);
                          }}
                        />
                      </li>
                      <li>
                        <img
                          src={sliderDummyData.bg_image_2}
                          className="img-fluid"
                          alt="img"
                          onClick={(e) => {
                            toggleRightshow("bg_image_2", e);
                          }}
                        />
                      </li>
                      <li>
                        <img
                          src={sliderDummyData.bg_image_3}
                          className="img-fluid"
                          alt="img"
                          onClick={(e) => {
                            toggleRightshow("bg_image_3", e);
                          }}
                        />
                      </li>
                    </ul>
                  </div>
                  <div
                    className="border"
                    onClick={(e) => {
                      toggleLeftContentshow("pamper A||pamper B", e, "28||31");
                    }}
                  >
                    <div className="line_1" style={applyCss("pamper A")}>
                      {sliderDummyData.pamper_a}
                    </div>
                    <div className="line_2" style={applyCss("pamper B")}>
                      {sliderDummyData.pamper_b}
                    </div>
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_144" && (
              <div
                className="hoverDiv happybirthday_vid_144 p-4 d-flex align-items-end justify-content-center  wdh_fix"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div
                  className="mid text-center text-white mb-4 border"
                  onClick={(e) => {
                    toggleLeftContentshow("spring A||spring B", e, "20||36");
                  }}
                >
                  <div className="line_1" style={applyCss("spring A")}>
                    {sliderDummyData.spring_a}
                  </div>
                  <div className="line_2" style={applyCss("spring B")}>
                    {sliderDummyData.spring_b}
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_145" && (
              <div
                className="hoverDiv happybirthday_vid_145 p-4 d-flex align-items-end justify-content-center  wdh_fix"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div className="mid text-center text-white mb-4">
                  <div className="b_thmnl">
                    <figure>
                      <img
                        src={sliderDummyData.bg_image}
                        className="img-fluid"
                        alt="img"
                        onClick={(e) => {
                          toggleRightshow("bg_image", e);
                        }}
                        style={{
                          width: `${
                            sliderDummyData.bg_image ===
                            "https://engageleads-gallery.s3.us-west-2.amazonaws.com/VidAmaze/templates/Happybirthday/slides/BdayCake.jpg"
                              ? "41%"
                              : "auto"
                          }`,
                        }}
                      />
                    </figure>
                  </div>
                  <div
                    className="line_1  border"
                    onClick={(e) => {
                      toggleLeftContentshow("customer A", e, "31");
                    }}
                    style={applyCss("customer A")}
                  >
                    {sliderDummyData.customer_a}
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_146" && (
              <div
                className="hoverDiv happybirthday_vid_146 p-4 d-flex align-items-end justify-content-center  wdh_fix"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div className="mid text-center text-white mb-4">
                  <div className="line_1 pb-4 mb-3 ">
                    <img
                      src={sliderDummyData.logo}
                      className="img-fluid border"
                      alt="img"
                      onClick={(e) => {
                        toggleRightshow("logo", e);
                      }}
                    />
                  </div>
                  <div className="line_2 d-flex justify-content-center">
                    <div
                      className="cl me-3 ms-3 border"
                      onClick={(e) => {
                        toggleLeftContentshow("number", e, "15");
                      }}
                    >
                      <i className="me-1">
                        <img
                          src="https://d37q3r06begyqi.cloudfront.net/VidAmaze/app-images/slides_images/phone13.png"
                          alt="img"
                        />
                      </i>
                      <span style={applyCss("number")}>
                        {sliderDummyData.number}
                      </span>
                    </div>
                    <div
                      className="cl me-3 ms-3 border"
                      onClick={(e) => {
                        toggleLeftContentshow("website", e, "35");
                      }}
                    >
                      <i className="me-1">
                        <img
                          src="https://d37q3r06begyqi.cloudfront.net/VidAmaze/app-images/slides_images/web11.png"
                          alt="img"
                        />
                      </i>
                      <span style={applyCss("website")}>
                        {sliderDummyData.website}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_147" && (
              <div
                className="hoverDiv position-relative customerappreciation_vid_147 p-4 d-flex align-items-center justify-content-center  wdh_fix"
                style={{
                  backgroundImage: `url("${sliderDummyData.bg_image}")`,
                }}
              >
                <a
                  href="#0"
                  className="changeImageVideo"
                  onClick={(e) => {
                    toggleRightshow("bg_image", e);
                  }}
                >
                  <img
                    src={`${process.env.PUBLIC_URL}/assets/images/edit_hv.png`}
                    alt="img"
                  />{" "}
                  Change Background Image
                </a>
                <div className="mid text-center text-white mb-5">
                  <div
                    className="line_1 border"
                    onClick={(e) => {
                      toggleLeftContentshow("hey", e, "10");
                    }}
                    style={applyCss("hey")}
                  >
                    {sliderDummyData.hey}
                  </div>
                  <div className="line_2">{dynamicText}</div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_148" && (
              <div
                className="hoverDiv customerappreciation_vid_148 p-4 d-flex align-items-center justify-content-center  wdh_fix"
                style={{
                  backgroundImage: `url("${sliderDummyData.bg_image}")`,
                }}
              >
                <a
                  href="#0"
                  className="changeImageVideo"
                  onClick={(e) => {
                    toggleRightshow("bg_image", e);
                  }}
                >
                  <img
                    src={`${process.env.PUBLIC_URL}/assets/images/edit_hv.png`}
                    alt="img"
                  />{" "}
                  Change Background Image
                </a>
                <div
                  className="mid text-center text-white mb-5 border"
                  onClick={(e) => {
                    toggleLeftContentshow("work A||work B", e, "21||20");
                  }}
                >
                  <div className="line_1" style={applyCss("work A")}>
                    {sliderDummyData.work_a}
                  </div>
                  <div className="line_2" style={applyCss("work B")}>
                    {sliderDummyData.work_b}
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_149" && (
              <div
                className="hoverDiv customerappreciation_vid_149 p-4 d-flex align-items-center justify-content-center  wdh_fix"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div
                  className="mid text-center text-white mb-5 border"
                  onClick={(e) => {
                    toggleLeftContentshow("demand A||demand B", e, "24||28");
                  }}
                >
                  <div className="line_1" style={applyCss("demand A")}>
                    {sliderDummyData.demand_a}
                  </div>
                  <div className="line_2" style={applyCss("demand B")}>
                    {sliderDummyData.demand_b}
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_150" && (
              <div
                className="hoverDiv customerappreciation_vid_150 p-4 d-flex align-items-center justify-content-center  wdh_fix"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div className="mid text-center text-white mb-5">
                  <div
                    className="line_1"
                    style={{
                      border: `${
                        sliderDummyData.bg_color &&
                        sliderDummyData.bg_color.includes("#")
                          ? "#" + sliderDummyData.bg_color.split("#")[1]
                          : "#" + sliderDummyData.bg_color
                      } 4px solid`,
                    }}
                  >
                    <p
                      className="border"
                      onClick={(e) => {
                        toggleLeftContentshow("serve A||bg_color", e, "25||0");
                      }}
                      style={applyCss("serve A")}
                    >
                      {sliderDummyData.serve_a}
                    </p>
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_151" && (
              <div
                className="hoverDiv customerappreciation_vid_151 p-4 d-flex align-items-center justify-content-center  wdh_fix"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div className="mid text-center text-white mb-5">
                  <div
                    className="border"
                    onClick={(e) => {
                      toggleLeftContentshow(
                        "certified A||certified B",
                        e,
                        "25||30"
                      );
                    }}
                  >
                    <div className="line_1" style={applyCss("certified A")}>
                      {sliderDummyData.certified_a}
                    </div>
                    <div className="line_2" style={applyCss("certified B")}>
                      {sliderDummyData.certified_b}
                    </div>
                  </div>
                  <div className="grd_m d-flex justify-content-center">
                    <div className="bx2 text-start">
                      <div className="line_3">
                        <img
                          src={sliderDummyData.logo}
                          className="img-fluid border"
                          alt="img"
                          onClick={(e) => {
                            toggleRightshow("logo", e);
                          }}
                        />
                      </div>
                      <div
                        className="line_4 pb-4 border"
                        onClick={(e) => {
                          toggleLeftContentshow("number", e, "15");
                        }}
                      >
                        <i className="me-2">
                          <img
                            src="https://d37q3r06begyqi.cloudfront.net/VidAmaze/app-images/slides_images/phone12.png"
                            alt="img"
                          />
                        </i>
                        <span style={applyCss("number")}>
                          {sliderDummyData.number}
                        </span>
                      </div>
                      <div
                        className="line_5 border mt-1"
                        onClick={(e) => {
                          toggleLeftContentshow("website", e, "35");
                        }}
                      >
                        <i className="me-2">
                          <img
                            src="https://d37q3r06begyqi.cloudfront.net/VidAmaze/app-images/slides_images/web2.png"
                            alt="img"
                          />
                        </i>
                        <span style={applyCss("website")}>
                          {sliderDummyData.website}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_152" && (
              <div
                className="hoverDiv coupon_vid_152 p-4 d-flex align-items-center justify-content-center  wdh_fix"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div className="mid text-center text-white">
                  <div
                    className="line_1 border"
                    onClick={(e) => {
                      toggleLeftContentshow("hey", e, "10");
                    }}
                    style={applyCss("hey")}
                  >
                    {sliderDummyData.hey}
                  </div>
                  <div className="line_2">{dynamicText}</div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_153" && (
              <div
                className="hoverDiv coupon_vid_153 p-4 d-flex align-items-center justify-content-center  wdh_fix"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div
                  className="mid text-center text-white border"
                  onClick={(e) => {
                    toggleLeftContentshow(
                      "guidance A||guidance B",
                      e,
                      "19||16"
                    );
                  }}
                >
                  <div className="line_1" style={applyCss("guidance A")}>
                    {sliderDummyData.guidance_a}
                  </div>
                  <div className="line_2" style={applyCss("guidance B")}>
                    {sliderDummyData.guidance_b}
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_154" && (
              <div
                className="hoverDiv coupon_vid_154 p-4 d-flex align-items-center justify-content-center  wdh_fix"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div
                  className="mid text-center text-white  border"
                  onClick={(e) => {
                    toggleLeftContentshow(
                      "certified A||certified B",
                      e,
                      "22||14"
                    );
                  }}
                >
                  <div className="line_1" style={applyCss("certified A")}>
                    {sliderDummyData.certified_a}
                  </div>
                  <div className="line_2" style={applyCss("certified B")}>
                    {sliderDummyData.certified_b}
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_155" && (
              <div
                className="hoverDiv coupon_vid_155 p-4 d-flex align-items-center justify-content-center  wdh_fix"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div className="mid text-center text-white">
                  <div
                    className="line_1  border"
                    onClick={(e) => {
                      toggleLeftContentshow("everyday A", e, "41");
                    }}
                    style={applyCss("everyday A")}
                  >
                    {sliderDummyData.everyday_a}
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_156" && (
              <div
                className="hoverDiv coupon_vid_156 p-4 d-flex align-items-center justify-content-center  wdh_fix"
                style={{
                  backgroundImage: `url("${sliderDummyData.bg_image}")`,
                }}
              >
                <a
                  href="#0"
                  className="changeImageVideo"
                  onClick={(e) => {
                    toggleRightshow("bg_image", e);
                  }}
                >
                  <img
                    src={`${process.env.PUBLIC_URL}/assets/images/edit_hv.png`}
                    alt="img"
                  />{" "}
                  Change Background Image
                </a>
                <div className="mid text-center ">
                  <div
                    className="line_1 pb-4 border"
                    onClick={(e) => {
                      toggleLeftContentshow("need A", e, "38");
                    }}
                    style={applyCss("need A")}
                  >
                    {sliderDummyData.need_a}
                  </div>
                  <div className="line_2 text-center">
                    <div className="coupon d-inline-flex align-items-center justify-content-end">
                      <span
                        className="border"
                        onClick={(e) => {
                          toggleLeftContentshow("need B", e, "8");
                        }}
                        style={applyCss("need B")}
                      >
                        {sliderDummyData.need_b}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_157" && (
              <div
                className="hoverDiv coupon_vid_157 p-4 d-flex align-items-center justify-content-center  wdh_fix"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div
                  className="mid text-center text-white border"
                  onClick={(e) => {
                    toggleLeftContentshow("work A||work B", e, "26||21");
                  }}
                >
                  <div className="line_1" style={applyCss("work A")}>
                    {sliderDummyData.work_a}
                  </div>
                  <div className="line_2" style={applyCss("work B")}>
                    {sliderDummyData.work_b}
                  </div>
                </div>
              </div>
            )}
            {active_slide_name === "slide_158" && (
              <div
                className="hoverDiv coupon_vid_158 p-4 d-flex align-items-center justify-content-center  wdh_fix"
                style={{
                  backgroundImage: `url("${sliderDummyData.bg_image}")`,
                }}
              >
                <a
                  href="#0"
                  className="changeImageVideo"
                  onClick={(e) => {
                    toggleRightshow("bg_image", e);
                  }}
                >
                  <img
                    src={`${process.env.PUBLIC_URL}/assets/images/edit_hv.png`}
                    alt="img"
                  />{" "}
                  Change Background Image
                </a>
                <div className="mid text-center text-white mb-5">
                  <div
                    className="line_1 border"
                    onClick={(e) => {
                      toggleLeftContentshow("serve A", e, "41");
                    }}
                    style={applyCss("serve A")}
                  >
                    {sliderDummyData.serve_a}
                  </div>
                  <div className="line_2 pt-4 pb-5">
                    <img
                      src={sliderDummyData.logo}
                      className="img-fluid border"
                      alt="img"
                      onClick={(e) => {
                        toggleRightshow("logo", e);
                      }}
                    />
                  </div>
                  <div className="grd_m d-flex justify-content-center">
                    <div
                      className="line_3 me-4 border"
                      onClick={(e) => {
                        toggleLeftContentshow("number", e, "15");
                      }}
                    >
                      <i className="me-2">
                        <img
                          src="https://d37q3r06begyqi.cloudfront.net/VidAmaze/app-images/slides_images/phone16.png"
                          alt="img"
                        />
                      </i>
                      <span style={applyCss("number")}>
                        {" "}
                        {sliderDummyData.number}
                      </span>
                    </div>
                    <div
                      className="line_4 ms-4 border"
                      onClick={(e) => {
                        toggleLeftContentshow("website", e, "35");
                      }}
                    >
                      <i className="me-2">
                        <img
                          src="https://d37q3r06begyqi.cloudfront.net/VidAmaze/app-images/slides_images/web14.png"
                          alt="img"
                        />
                      </i>{" "}
                      <span style={applyCss("website")}>
                        {sliderDummyData.website}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_159" && (
              <div
                className="hoverDiv estateagent_vid_159 p-4 d-flex align-items-center justify-content-center  wdh_fix"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div className="mid text-center text-white">
                  <div
                    className="line_1 border"
                    onClick={(e) => {
                      toggleLeftContentshow("hey", e, "10");
                    }}
                    style={applyCss("hey")}
                  >
                    {sliderDummyData.hey}
                  </div>
                  <div className="line_2">{dynamicText}</div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_160" && (
              <div
                className="hoverDiv estateagent_vid_160 p-4 d-flex align-items-center justify-content-center  wdh_fix"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />

                <div
                  className="mid text-center text-white border"
                  onClick={(e) => {
                    toggleLeftContentshow(
                      "guidance A||guidance B",
                      e,
                      "26||30"
                    );
                  }}
                >
                  <div className="line_1" style={applyCss("guidance A")}>
                    {sliderDummyData.guidance_a}
                  </div>
                  <div className="line_2" style={applyCss("guidance B")}>
                    {sliderDummyData.guidance_b}
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_161" && (
              <div
                className="hoverDiv estateagent_vid_161 p-4 d-flex align-items-center justify-content-center  wdh_fix"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />

                <div
                  className="mid text-center text-white border"
                  onClick={(e) => {
                    toggleLeftContentshow(
                      "professional A||professional B||professional C||bg_color",
                      e,
                      "27||25||25||0"
                    );
                  }}
                >
                  <div className="line_1" style={applyCss("professional A")}>
                    {sliderDummyData.professional_a}
                  </div>
                  <div
                    className="line_2 pb-1"
                    style={applyCss("professional B")}
                  >
                    {sliderDummyData.professional_b}
                  </div>
                  <div
                    className="line_3"
                    style={applyBackGround("backgroundColor", "bg_color")}
                  >
                    <span style={applyCss("professional C")}>
                      {sliderDummyData.professional_c}
                    </span>
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_162" && (
              <div
                className="hoverDiv estateagent_vid_162 p-4 d-flex align-items-center justify-content-center  wdh_fix"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />

                <div
                  className="mid text-center text-white border"
                  onClick={(e) => {
                    toggleLeftContentshow(
                      "trained A||trained B||trained C||trained D",
                      e,
                      "16||6||25||13"
                    );
                  }}
                >
                  <div className="line_1" style={applyCss("trained A")}>
                    {sliderDummyData.trained_a}
                  </div>
                  <div className="line_2 " style={applyCss("trained B")}>
                    {sliderDummyData.trained_b}
                  </div>
                  <div className="line_3" style={applyCss("trained C")}>
                    {sliderDummyData.trained_c}
                  </div>
                  <div className="line_4" style={applyCss("trained D")}>
                    {sliderDummyData.trained_d}
                  </div>
                </div>
              </div>
            )}
            {active_slide_name === "slide_163" && (
              <div
                className="hoverDiv estateagent_vid_163 p-4 d-flex align-items-center justify-content-center  wdh_fix"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />

                <div
                  className="mid text-center text-white border"
                  onClick={(e) => {
                    toggleLeftContentshow("need A||need B", e, "26||27");
                  }}
                >
                  <div className="line_1" style={applyCss("need A")}>
                    {sliderDummyData.need_a}
                  </div>
                  <div className="line_2" style={applyCss("need B")}>
                    {sliderDummyData.need_b}
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_164" && (
              <div
                className="hoverDiv estateagent_vid_164 p-4 d-flex align-items-center justify-content-center  wdh_fix"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />

                <div className="mid text-center text-white mb-5">
                  <div
                    className="line_1 border"
                    onClick={(e) => {
                      toggleLeftContentshow("floor A", e, "33");
                    }}
                    style={applyCss("floor A")}
                  >
                    {sliderDummyData.floor_a}
                  </div>
                  <div className="line_2 pt-5 pb-5">
                    <img
                      src={sliderDummyData.logo}
                      className="img-fluid border"
                      alt="img"
                      onClick={(e) => {
                        toggleRightshow("logo", e);
                      }}
                    />
                  </div>
                  <div className="grd_m d-flex justify-content-center">
                    <div
                      className="line_3 me-4 border"
                      onClick={(e) => {
                        toggleLeftContentshow("number", e, "15");
                      }}
                    >
                      <i className="me-2">
                        <img
                          src="https://d37q3r06begyqi.cloudfront.net/VidAmaze/app-images/slides_images/phone13.png"
                          alt="img"
                        />
                      </i>
                      <span style={applyCss("number")}>
                        {sliderDummyData.number}
                      </span>
                    </div>
                    <div
                      className="line_4 ms-4 border"
                      onClick={(e) => {
                        toggleLeftContentshow("website", e, "35");
                      }}
                    >
                      <i className="me-2">
                        <img
                          src="https://d37q3r06begyqi.cloudfront.net/VidAmaze/app-images/slides_images/web11.png"
                          alt="img"
                        />
                      </i>
                      <span style={applyCss("website")}>
                        {sliderDummyData.website}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_165" && (
              <div
                className="hoverDiv salon_vid_165 p-4 d-flex align-items-center justify-content-center  wdh_fix"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div className="mid text-center text-white">
                  <div
                    className="line_1  border"
                    onClick={(e) => {
                      toggleLeftContentshow("hey", e, "10");
                    }}
                    style={applyCss("hey")}
                  >
                    {sliderDummyData.hey}
                  </div>
                  <div className="line_2">{dynamicText}</div>
                </div>
              </div>
            )}
            {active_slide_name === "slide_166" && (
              <div
                className="hoverDiv salon_vid_166 p-4  d-flex  justify-content-center  wdh_fix"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div className="mid text-center w-100">
                  <div
                    className="line_1"
                    style={applyBackGround("backgroundColor", "bg_color")}
                  >
                    <div
                      className=" border"
                      onClick={(e) => {
                        toggleLeftContentshow(
                          "customer A||bg_color",
                          e,
                          "27||0"
                        );
                      }}
                    >
                      <span style={applyCss("customer A")}>
                        {" "}
                        {sliderDummyData.customer_a}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_167" && (
              <div
                className="hoverDiv salon_vid_167 p-4   wdh_fix"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div
                  className="mid text-center w-100 "
                  style={applyBackGround("backgroundColor", "bg_color")}
                >
                  <div
                    className="border"
                    onClick={(e) => {
                      toggleLeftContentshow(
                        "guidance A||guidance B||bg_color",
                        e,
                        "24||21||0"
                      );
                    }}
                  >
                    <div className="line_1" style={applyCss("guidance A")}>
                      {sliderDummyData.guidance_a}
                    </div>
                    <div className="line_2" style={applyCss("guidance B")}>
                      {sliderDummyData.guidance_b}
                    </div>
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_168" && (
              <div
                className="hoverDiv salon_vid_168 p-4 d-flex align-items-end   wdh_fix"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div
                  className="mid text-center w-100 "
                  style={applyBackGround("backgroundColor", "bg_color")}
                >
                  <div
                    className="border"
                    onClick={(e) => {
                      toggleLeftContentshow(
                        "need A||need B||bg_color",
                        e,
                        "35||35||0"
                      );
                    }}
                  >
                    <div className="line_1" style={applyCss("need A")}>
                      {sliderDummyData.need_a}
                    </div>
                    <div className="line_1" style={applyCss("need B")}>
                      {sliderDummyData.need_b}
                    </div>
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_169" && (
              <div
                className="hoverDiv salon_vid_169 p-4 d-flex align-items-end   wdh_fix"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div
                  className="mid text-center w-100"
                  style={applyBackGround("backgroundColor", "bg_color")}
                >
                  <div
                    className="border"
                    onClick={(e) => {
                      toggleLeftContentshow(
                        "demand A||demand B||bg_color",
                        e,
                        "21||25||0"
                      );
                    }}
                  >
                    <div className="line_1" style={applyCss("demand A")}>
                      {sliderDummyData.demand_a}
                    </div>
                    <div className="line_1" style={applyCss("demand B")}>
                      {sliderDummyData.demand_b}
                    </div>
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_170" && (
              <div
                className="hoverDiv salon_vid_170 p-4 d-flex align-items-center   wdh_fix"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div
                  className="mid d-flex justify-content-center  w-100 text-center "
                  // onClick={(e) => {
                  //   toggleLeftContentshow("bg_color", e, "0");
                  // }}
                  style={applyBackGround("backgroundColor", "bg_color")}
                >
                  <div className="center">
                    <div className="line_1">
                      <img
                        src={sliderDummyData.logo}
                        className="img-fluid border"
                        alt="img"
                        onClick={(e) => {
                          toggleRightshow("logo", e);
                        }}
                      />
                    </div>
                    <div
                      className="line_2 pt-4 pb-3 mt-1 border"
                      onClick={(e) => {
                        toggleLeftContentshow("floor A||bg_color", e, "13||0");
                      }}
                      style={applyCss("floor A")}
                    >
                      {sliderDummyData.floor_a}
                    </div>
                    <div
                      className="line_3 pb-1 border mt-1"
                      onClick={(e) => {
                        toggleLeftContentshow("number", e, "15");
                      }}
                    >
                      <i>
                        <img
                          src="https://d37q3r06begyqi.cloudfront.net/VidAmaze/app-images/slides_images/phone12.png"
                          alt="img"
                        />
                      </i>
                      <span style={applyCss("number")}>
                        {" "}
                        {sliderDummyData.number}
                      </span>
                    </div>
                    <div
                      className="line_4 border mt-1"
                      onClick={(e) => {
                        toggleLeftContentshow("website", e, "35");
                      }}
                    >
                      <i>
                        <img
                          src="https://d37q3r06begyqi.cloudfront.net/VidAmaze/app-images/slides_images/web2.png"
                          alt="img"
                        />
                      </i>
                      <span style={applyCss("website")}>
                        {" "}
                        {sliderDummyData.website}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_177" && (
              <div
                className="hoverDiv christmas_vid_177 p-4 d-flex align-items-center justify-content-center  wdh_fix"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div className="mid text-center text-white">
                  <div
                    className="line_1 border"
                    onClick={(e) => {
                      toggleLeftContentshow("hey", e, "10");
                    }}
                    style={applyCss("hey")}
                  >
                    {sliderDummyData.hey}
                  </div>
                  <div className="line_2 dynamic_text">{dynamicText}</div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_178" && (
              <div
                className="hoverDiv christmas_vid_178 p-4 d-flex align-items-center justify-content-center  wdh_fix"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div
                  className="mid text-center text-white border"
                  onClick={(e) => {
                    toggleLeftContentshow(
                      "serve A||serve B||serve C",
                      e,
                      "22||42||37"
                    );
                  }}
                >
                  <div className="line_1" style={applyCss("serve A")}>
                    {sliderDummyData.serve_a}
                  </div>
                  <div className="line_2" style={applyCss("serve B")}>
                    {sliderDummyData.serve_b}
                  </div>
                  <div className="line_3" style={applyCss("serve C")}>
                    {sliderDummyData.serve_c}
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_179" && (
              <div
                className=" hoverDiv christmas_vid_179 p-4 d-flex align-items-center justify-content-center  wdh_fix"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div
                  className="mid text-center text-white border"
                  onClick={(e) => {
                    toggleLeftContentshow(
                      "trained A||trained B||trained C",
                      e,
                      "31||28||29"
                    );
                  }}
                >
                  <div className="line_1" style={applyCss("trained A")}>
                    {sliderDummyData.trained_a}
                  </div>
                  <div className="line_2" style={applyCss("trained B")}>
                    {sliderDummyData.trained_b}
                  </div>
                  <div className="line_3" style={applyCss("trained C")}>
                    {sliderDummyData.trained_c}
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_180" && (
              <div
                className="hoverDiv christmas_vid_180 p-4 d-flex align-items-center justify-content-center  wdh_fix"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div
                  className="mid text-center text-white border"
                  onClick={(e) => {
                    toggleLeftContentshow("floor A||floor B", e, "21||25");
                  }}
                >
                  <div className="line_1" style={applyCss("floor A")}>
                    {sliderDummyData.floor_a}
                  </div>
                  <div className="line_2" style={applyCss("floor B")}>
                    {sliderDummyData.floor_b}
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_181" && (
              <div
                className="hoverDiv christmas_vid_181 p-4 d-flex align-items-center justify-content-center  wdh_fix"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div className="mid text-center text-white">
                  <div className="logo pb-4 border">
                    <img
                      src={sliderDummyData.logo}
                      className="img-fluid"
                      alt="img"
                      onClick={(e) => {
                        toggleRightshow("logo", e);
                      }}
                    />
                  </div>
                  <div
                    className="border m-1"
                    onClick={(e) => {
                      toggleLeftContentshow("need A||need B", e, "15||19");
                    }}
                  >
                    <div className="line_1" style={applyCss("need A")}>
                      {sliderDummyData.need_a}
                    </div>
                    <div className="line_2 pb-3" style={applyCss("need B")}>
                      {sliderDummyData.need_b}
                    </div>
                  </div>

                  <div
                    className="line_3 pb-3 border"
                    onClick={(e) => {
                      toggleLeftContentshow("number", e, "15");
                    }}
                  >
                    <i>
                      <img
                        src="https://d37q3r06begyqi.cloudfront.net/VidAmaze/app-images/slides_images/phone12.png"
                        alt="img"
                      />
                    </i>{" "}
                    <span style={applyCss("number")}>
                      {sliderDummyData.number}
                    </span>
                  </div>
                  <div
                    className="line_4 border mt-1"
                    onClick={(e) => {
                      toggleLeftContentshow("website", e, "35");
                    }}
                  >
                    <i>
                      <img
                        src="https://d37q3r06begyqi.cloudfront.net/VidAmaze/app-images/slides_images/web2.png"
                        alt="img"
                      />
                    </i>{" "}
                    <span style={applyCss("website")}>
                      {sliderDummyData.website}
                    </span>
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_188" && (
              <div
                className="hoverDiv blogintro_vid_188 p-4 d-flex align-items-center justify-content-center  wdh_fix"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div className="mid text-center text-white">
                  <div
                    className="line_1 border"
                    onClick={(e) => {
                      toggleLeftContentshow("hey", e, "10");
                    }}
                    style={applyCss("hey")}
                  >
                    Hello
                  </div>
                  <div className="line_2 dynamic_text">{dynamicText}</div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_189" && (
              <div
                className="hoverDiv blogintro_vid_189 p-4 d-flex align-items-center justify-content-center  wdh_fix"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div
                  className="mid text-center text-white border"
                  onClick={(e) => {
                    toggleLeftContentshow("help A||help B", e, "29||42");
                  }}
                >
                  <div className="line_1" style={applyCss("help A")}>
                    {sliderDummyData.help_a}
                  </div>
                  <div className="line_2" style={applyCss("help B")}>
                    {sliderDummyData.help_b}
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_190" && (
              <div
                className="hoverDiv blogintro_vid_190 p-4 d-flex align-items-center justify-content-center  wdh_fix"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />

                <div className="mid text-center text-white">
                  <div
                    className="line_1 border"
                    onClick={(e) => {
                      toggleLeftContentshow("customer A", e, "43");
                    }}
                    style={applyCss("customer A")}
                  >
                    {sliderDummyData.customer_a}
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_191" && (
              <div
                className="hoverDiv blogintro_vid_191 p-4 d-flex align-items-center justify-content-center  wdh_fix"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />

                <div
                  className="mid text-center text-white border"
                  onClick={(e) => {
                    toggleLeftContentshow(
                      "customer A||customer B",
                      e,
                      "31||29"
                    );
                  }}
                >
                  <div className="line_1" style={applyCss("customer A")}>
                    {sliderDummyData.customer_a}
                  </div>
                  <div className="line_2" style={applyCss("customer B")}>
                    {sliderDummyData.customer_b}
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_192" && (
              <div
                className="hoverDiv blogintro_vid_192 p-4 d-flex align-items-center justify-content-center  wdh_fix"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />

                <div
                  className="mid text-center text-white border"
                  onClick={(e) => {
                    toggleLeftContentshow(
                      "customer A||customer B",
                      e,
                      "32||36"
                    );
                  }}
                >
                  <div className="line_1" style={applyCss("customer A")}>
                    {sliderDummyData.customer_a}
                  </div>
                  <div className="line_2" style={applyCss("customer B")}>
                    {sliderDummyData.customer_b}
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_193" && (
              <div className="hoverDiv blogintro_vid_193 p-4 d-flex align-items-center justify-content-center  wdh_fix">
                <HoveDiv />
                <div className="mid text-center text-white ">
                  <div
                    className="line_1 border"
                    onClick={(e) => {
                      toggleLeftContentshow("help A", e, "43");
                    }}
                    style={applyCss("help A")}
                  >
                    {sliderDummyData.help_a}
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_194" && (
              <div
                className="hoverDiv blogintro_vid_194 p-4 d-flex align-items-center justify-content-center  wdh_fix"
                style={{
                  backgroundImage: `url("${sliderDummyData.bg_image}")`,
                }}
              >
                <a
                  href="#0"
                  className="changeImageVideo"
                  onClick={(e) => {
                    toggleRightshow("bg_image", e);
                  }}
                >
                  <img
                    src={`${process.env.PUBLIC_URL}/assets/images/edit_hv.png`}
                    alt="img"
                  />{" "}
                  Change Background Image
                </a>
                <div
                  className="mid text-center text-white  border"
                  onClick={(e) => {
                    toggleLeftContentshow(
                      "serve A||serve B||serve C",
                      e,
                      "34||36||31"
                    );
                  }}
                >
                  <div className="line_1 cursor" style={applyCss("serve A")}>
                    {sliderDummyData.serve_a}
                  </div>
                  <div className="line_2 cursor" style={applyCss("serve B")}>
                    {sliderDummyData.serve_b}
                  </div>
                  <div className="line_3 cursor" style={applyCss("serve C")}>
                    {sliderDummyData.serve_c}
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_195" && (
              <div
                className="hoverDiv blogintro_vid_195 p-4 d-flex align-items-center justify-content-center  wdh_fix"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div className="mid text-center text-white">
                  <div className="logo mb-4 pb-3 border">
                    <img
                      src={sliderDummyData.logo}
                      className="img-fluid"
                      alt="img"
                      onClick={(e) => {
                        toggleRightshow("logo", e);
                      }}
                    />
                  </div>
                  <div
                    className="line_1 mb-4 border"
                    style={applyCss("need A")}
                    onClick={(e) => {
                      toggleLeftContentshow("need A", e, "37");
                    }}
                  >
                    {sliderDummyData.need_a}
                  </div>
                  <div
                    className="line_2 mb-2 border"
                    onClick={(e) => {
                      toggleLeftContentshow("number", e, "15");
                    }}
                  >
                    <i>
                      <img
                        src="https://d37q3r06begyqi.cloudfront.net/VidAmaze/app-images/slides_images/phone12.png"
                        alt="img"
                      />
                    </i>{" "}
                    <span style={applyCss("number")}>
                      {sliderDummyData.number}
                    </span>
                  </div>
                  <div
                    className="line_3 border"
                    onClick={(e) => {
                      toggleLeftContentshow("website", e, "35");
                    }}
                  >
                    <i>
                      <img
                        src="https://d37q3r06begyqi.cloudfront.net/VidAmaze/app-images/slides_images/web11.png"
                        alt="img"
                      />
                    </i>{" "}
                    <span style={applyCss("website")}>
                      {sliderDummyData.website}
                    </span>
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_182" && (
              <div
                className="hoverDiv leadmagnet_vid_182 p-4 d-flex align-items-center justify-content-center  wdh_fix"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div className="mid text-center text-white">
                  <div
                    className="line_1 border"
                    style={applyCss("hey")}
                    onClick={(e) => {
                      toggleLeftContentshow("hey", e, "10");
                    }}
                  >
                    {sliderDummyData.hey}
                  </div>
                  <div className="line_2 dynamic_text">{dynamicText}</div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_183" && (
              <div
                className="hoverDiv leadmagnet_vid_183 p-4 d-flex align-items-center justify-content-center  wdh_fix"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div
                  className="mid  text-white border"
                  onClick={(e) => {
                    toggleLeftContentshow("help A||help B", e, "13||17");
                  }}
                >
                  <div className="line_1" style={applyCss("help A")}>
                    {sliderDummyData.help_a}
                  </div>
                  <div className="line_2" style={applyCss("help B")}>
                    {sliderDummyData.help_b}
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_184" && (
              <div
                className="hoverDiv leadmagnet_vid_184 p-4    wdh_fix"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div
                  className="mid  text-white pt-5 ps-3 border"
                  onClick={(e) => {
                    toggleLeftContentshow(
                      "customer A||customer B",
                      e,
                      "22||24"
                    );
                  }}
                >
                  <div className="line_1" style={applyCss("customer A")}>
                    {sliderDummyData.customer_a}
                  </div>
                  <div className="line_2" style={applyCss("customer B")}>
                    {sliderDummyData.customer_b}
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_185" && (
              <div
                className="hoverDiv leadmagnet_vid_185 p-4 d-flex align-items-center justify-content-center  wdh_fix"
                style={{
                  backgroundImage: `url("${sliderDummyData.bg_image}")`,
                }}
              >
                <a
                  href="#0"
                  className="changeImageVideo"
                  onClick={(e) => {
                    toggleRightshow("bg_image", e);
                  }}
                >
                  <img
                    src={`${process.env.PUBLIC_URL}/assets/images/edit_hv.png`}
                    alt="img"
                  />{" "}
                  Change Background Image
                </a>
                <div
                  className="mid text-center  text-white border"
                  onClick={(e) => {
                    toggleLeftContentshow("help A||help B", e, "33||30");
                  }}
                >
                  <div className="line_1" style={applyCss("help A")}>
                    {sliderDummyData.help_a}
                  </div>
                  <div className="line_2" style={applyCss("help B")}>
                    {sliderDummyData.help_b}
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_186" && (
              <div
                className="hoverDiv leadmagnet_vid_186 p-4 d-flex align-items-center justify-content-center  wdh_fix"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div
                  className="mid text-center  text-white border"
                  onClick={(e) => {
                    toggleLeftContentshow("need A||need B", e, "29||38");
                  }}
                >
                  <div className="line_1" style={applyCss("need A")}>
                    {sliderDummyData.need_a}
                  </div>
                  <div className="line_2" style={applyCss("need B")}>
                    {sliderDummyData.need_b}
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_187" && (
              <div
                className="hoverDiv leadmagnet_vid_187   wdh_fix"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div className="row align-items-center">
                  <div className="col-md-6 order-md-2">
                    <div className="thmnl d-none">
                      <img
                        src="https://d37q3r06begyqi.cloudfront.net/VidAmaze/app-images/slides_images/girl_with_gift.jpg"
                        className="w-100"
                        alt="img"
                      />
                    </div>
                  </div>

                  <div className="col-md-6 order-md-1">
                    <div className="aside d-flex justify-content-center text-center p-4 text-white">
                      <div className="rw">
                        <div className="logo mb-4 border">
                          <img
                            src={sliderDummyData.logo}
                            className="img-fluid"
                            alt="img"
                            onClick={(e) => {
                              toggleRightshow("logo", e);
                            }}
                          />
                        </div>
                        <div
                          className="heading_bx mb-4 border"
                          onClick={(e) => {
                            toggleLeftContentshow(
                              "serve A||serve B||serve C",
                              e,
                              "23||14||15"
                            );
                          }}
                        >
                          <div
                            className="line1 cursor"
                            style={applyCss("serve A")}
                          >
                            {sliderDummyData.serve_a}
                          </div>
                          <div
                            className="line2 cursor"
                            style={applyCss("serve B")}
                          >
                            {sliderDummyData.serve_b}
                          </div>
                          <div
                            className="line3 cursor"
                            style={applyCss("serve C")}
                          >
                            {sliderDummyData.serve_c}
                          </div>
                        </div>

                        <div
                          className="call mb-4 border"
                          onClick={(e) => {
                            toggleLeftContentshow("number", e, "15");
                          }}
                        >
                          <i>
                            <img
                              src="https://d37q3r06begyqi.cloudfront.net/VidAmaze/app-images/slides_images/phone12.png"
                              alt="img"
                            />
                          </i>
                          <span style={applyCss("number")}>
                            {sliderDummyData.number}
                          </span>
                        </div>

                        <div
                          className="web border"
                          onClick={(e) => {
                            toggleLeftContentshow("website", e, "30");
                          }}
                        >
                          <i>
                            <img
                              src="https://d37q3r06begyqi.cloudfront.net/VidAmaze/app-images/slides_images/web9.png"
                              alt="img"
                            />
                          </i>{" "}
                          <span style={applyCss("website")}>
                            {sliderDummyData.website}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_205" && (
              <div
                className="hoverDiv thanksgiving_vid_205 p-4 d-flex align-items-center justify-content-center  wdh_fix"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div className="mid text-center text-white">
                  <div
                    className="line_1 border"
                    onClick={(e) => {
                      toggleLeftContentshow("hey", e, "10");
                    }}
                    style={applyCss("hey")}
                  >
                    {sliderDummyData.hey}
                  </div>
                  <div className="line_2 dynamic_text">{dynamicText}</div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_206" && (
              <div
                className="hoverDiv thanksgiving_vid_206 p-4 d-flex align-items-end justify-content-center  wdh_fix"
                style={{
                  backgroundImage: `url("${sliderDummyData.bg_image}")`,
                }}
              >
                <a
                  href="#0"
                  className="changeImageVideo"
                  onClick={(e) => {
                    toggleRightshow("bg_image", e);
                  }}
                >
                  <img
                    src={`${process.env.PUBLIC_URL}/assets/images/edit_hv.png`}
                    alt="img"
                  />{" "}
                  Change Background Image
                </a>
                <div
                  className="mid text-center text-white pb-4  border"
                  onClick={(e) => {
                    toggleLeftContentshow(
                      "serve A||serve B||serve C",
                      e,
                      "18||26||18"
                    );
                  }}
                >
                  <div className="line_1" style={applyCss("serve A")}>
                    {sliderDummyData.serve_a}
                  </div>
                  <div className="line_2" style={applyCss("serve B")}>
                    {sliderDummyData.serve_b}
                  </div>
                  <div className="line_3" style={applyCss("serve C")}>
                    {sliderDummyData.serve_c}
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_207" && (
              <div
                className="hoverDiv thanksgiving_vid_207 p-4 d-flex align-items-center justify-content-center  wdh_fix"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div
                  className="mid text-center text-white pb-4  border"
                  onClick={(e) => {
                    toggleLeftContentshow("help A||help B", e, "12||34");
                  }}
                >
                  <div className="line_1 cursor" style={applyCss("help A")}>
                    {sliderDummyData.help_a}
                  </div>
                  <div className="line_2 cursor" style={applyCss("help B")}>
                    {sliderDummyData.help_b}
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_208" && (
              <div
                className="hoverDiv thanksgiving_vid_208 p-4 d-flex align-items-center justify-content-center  wdh_fix"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div
                  className="mid text-center text-white pb-4   border"
                  onClick={(e) => {
                    toggleLeftContentshow("help A||help B", e, "26||36");
                  }}
                >
                  <div className="line_1 cursor" style={applyCss("help A")}>
                    {sliderDummyData.help_a}
                  </div>
                  <div className="line_2 cursor" style={applyCss("help B")}>
                    {sliderDummyData.help_b}
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_209" && (
              <div
                className="hoverDiv thanksgiving_vid_209 p-4 d-flex align-items-center justify-content-center  wdh_fix"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div
                  className="mid text-center text-white pb-4    border"
                  onClick={(e) => {
                    toggleLeftContentshow("need A||need B", e, "19||29");
                  }}
                >
                  <div className="line_1 cursor" style={applyCss("need A")}>
                    {sliderDummyData.need_a}
                  </div>
                  <div className="line_2 cursor" style={applyCss("need B")}>
                    {sliderDummyData.need_b}
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_210" && (
              <div
                className="hoverDiv thanksgiving_vid_210 p-4 d-flex align-items-center justify-content-center  wdh_fix"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div
                  className="mid text-center text-white pb-4  border"
                  onClick={(e) => {
                    toggleLeftContentshow("help A||help B", e, "16||33");
                  }}
                >
                  <div className="line_1 cursor" style={applyCss("help A")}>
                    {sliderDummyData.help_a}
                  </div>
                  <div className="line_2 cursor" style={applyCss("help B")}>
                    {sliderDummyData.help_b}
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_211" && (
              <div
                className="hoverDiv thanksgiving_vid_211 p-4 d-flex align-items-center justify-content-center  wdh_fix"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div
                  className="mid text-center text-white pb-4 border"
                  onClick={(e) => {
                    toggleLeftContentshow("help A", e, "36");
                  }}
                >
                  <div className="line_1 cursor" style={applyCss("help A")}>
                    {sliderDummyData.help_a}
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_212" && (
              <div
                className="hoverDiv thanksgiving_vid_212 p-4 d-flex align-items-center justify-content-center  wdh_fix"
                style={{
                  backgroundImage: `url("${sliderDummyData.bg_image}")`,
                }}
              >
                <a
                  href="#0"
                  className="changeImageVideo"
                  onClick={(e) => {
                    toggleRightshow("bg_image", e);
                  }}
                >
                  <img
                    src={`${process.env.PUBLIC_URL}/assets/images/edit_hv.png`}
                    alt="img"
                  />{" "}
                  Change Background Image
                </a>
                <div className="mid">
                  <div className="logo mb-4 border">
                    <img
                      src={sliderDummyData.logo}
                      className="img-fluid"
                      alt="img"
                      onClick={(e) => {
                        toggleRightshow("logo", e);
                      }}
                    />
                  </div>
                  <div
                    className="line_1 mb-2 border"
                    onClick={(e) => {
                      toggleLeftContentshow("number", e, "15");
                    }}
                  >
                    <i>
                      <img
                        src="https://d37q3r06begyqi.cloudfront.net/VidAmaze/app-images/slides_images/phone16.png"
                        alt="img"
                      />
                    </i>{" "}
                    <span style={applyCss("number")}>
                      {sliderDummyData.number}
                    </span>
                  </div>
                  <div
                    className="line_2  border"
                    onClick={(e) => {
                      toggleLeftContentshow("website", e, "35");
                    }}
                  >
                    <i>
                      <img
                        src="https://d37q3r06begyqi.cloudfront.net/VidAmaze/app-images/slides_images/web14.png"
                        alt="img"
                      />
                    </i>{" "}
                    <span style={applyCss("website")}>
                      {sliderDummyData.website}
                    </span>
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_171" && (
              <div
                className="hoverDiv newyear_vid_171 p-4 d-flex align-items-center justify-content-center  wdh_fix"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div className="mid text-center text-white">
                  <div
                    className="line_1 cursor"
                    onClick={(e) => {
                      toggleLeftContentshow("hey", e, "10");
                    }}
                    style={applyCss("hey")}
                  >
                    {sliderDummyData.hey}
                  </div>
                  <div className="line_2 dynamic_text">{dynamicText}</div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_172" && (
              <div
                className="hoverDiv newyear_vid_172 p-4 d-flex align-items-center justify-content-center  wdh_fix"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div
                  className="mid text-center text-white  border"
                  onClick={(e) => {
                    toggleLeftContentshow(
                      "serve A||serve B||serve C",
                      e,
                      "25||32||33"
                    );
                  }}
                >
                  <div className="line_1 cursor" style={applyCss("serve A")}>
                    {sliderDummyData.serve_a}
                  </div>
                  <div className="line_2 cursor" style={applyCss("serve B")}>
                    {sliderDummyData.serve_b}
                  </div>
                  <div className="line_3 cursor" style={applyCss("serve C")}>
                    {sliderDummyData.serve_c}
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_173" && (
              <div
                className="hoverDiv newyear_vid_173 p-4 d-flex align-items-center justify-content-center  wdh_fix"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div
                  className="mid text-center text-white border"
                  onClick={(e) => {
                    toggleLeftContentshow(
                      "business A||business B",
                      e,
                      "31||29"
                    );
                  }}
                >
                  <div className="line_1 cursor" style={applyCss("business A")}>
                    {sliderDummyData.business_a}
                  </div>
                  <div className="line_2 cursor" style={applyCss("business B")}>
                    {sliderDummyData.business_b}
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_174" && (
              <div
                className="hoverDiv newyear_vid_174 p-4 d-flex align-items-center justify-content-center  wdh_fix"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div
                  className="mid text-center text-white  border"
                  onClick={(e) => {
                    toggleLeftContentshow("floor A||floor B", e, "28||26");
                  }}
                >
                  <div className="line_1" style={applyCss("floor A")}>
                    {sliderDummyData.floor_a}
                  </div>
                  <div className="line_2" style={applyCss("floor B")}>
                    {sliderDummyData.floor_b}
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_175" && (
              <div
                className="hoverDiv newyear_vid_175 p-4 d-flex align-items-center justify-content-center  wdh_fix"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div
                  className="mid text-center text-white border"
                  onClick={(e) => {
                    toggleLeftContentshow("need A||need B", e, "11||14");
                  }}
                >
                  <div className="line_1" style={applyCss("need A")}>
                    {sliderDummyData.need_a}
                  </div>
                  <div className="line_2" style={applyCss("need B")}>
                    {sliderDummyData.need_b}
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_176" && (
              <div
                className="hoverDiv newyear_vid_176 p-4 d-flex align-items-center justify-content-center  wdh_fix"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div className="mid text-white">
                  <div className="newyear_logo border">
                    <img
                      src={sliderDummyData.logo}
                      className="img-fluid"
                      alt="img"
                      onClick={(e) => {
                        toggleRightshow("logo", e);
                      }}
                    />
                  </div>
                  <div
                    className="line_1 mt-3 mb-2 border"
                    onClick={(e) => {
                      toggleLeftContentshow("number", e, "15");
                    }}
                  >
                    <i>
                      <img
                        src="https://d37q3r06begyqi.cloudfront.net/VidAmaze/app-images/slides_images/phone12.png"
                        alt="img"
                      />
                    </i>{" "}
                    <span style={applyCss("number")}>
                      {sliderDummyData.number}
                    </span>
                  </div>
                  <div
                    className="line_2  border"
                    onClick={(e) => {
                      toggleLeftContentshow("website", e, "35");
                    }}
                  >
                    <i>
                      <img
                        src="https://d37q3r06begyqi.cloudfront.net/VidAmaze/app-images/slides_images/web2.png"
                        alt="img"
                      />
                    </i>{" "}
                    <span style={applyCss("website")}>
                      {sliderDummyData.website}
                    </span>
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_196" && (
              <div
                className="hoverDiv dental_vid_196 p-4 d-flex align-items-center justify-content-center  wdh_fix"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div className="mid text-center text-white">
                  <div
                    className="line_1 cursor border"
                    onClick={(e) => {
                      toggleLeftContentshow("hey", e, "10");
                    }}
                    style={applyCss("hey")}
                  >
                    {sliderDummyData.hey}
                  </div>
                  <div className="line_2 dynamic_text">{dynamicText}</div>
                </div>
              </div>
            )}
            {active_slide_name === "slide_197" && (
              <div
                className="hoverDiv dental_vid_197 p-4 d-flex align-items-center justify-content-center  wdh_fix"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div
                  className="mid text-center text-white border"
                  onClick={(e) => {
                    toggleLeftContentshow("help A||help B", e, "33||32");
                  }}
                >
                  <div className="line_1" style={applyCss("help A")}>
                    {sliderDummyData.help_a}
                  </div>
                  <div className="line_2" style={applyCss("help B")}>
                    {sliderDummyData.help_b}
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_198" && (
              <div
                className="hoverDiv dental_vid_198 p-4 d-flex align-items-center justify-content-center  wdh_fix"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div className="mid text-center text-white">
                  <div
                    className="line_1 border"
                    onClick={(e) => {
                      toggleLeftContentshow("customer A", e, "29");
                    }}
                    style={applyCss("customer A")}
                  >
                    {sliderDummyData.customer_a}
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_199" && (
              <div
                className="hoverDiv dental_vid_199 p-4 d-flex align-items-center justify-content-center  wdh_fix"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div
                  className="mid text-center text-white border"
                  onClick={(e) => {
                    toggleLeftContentshow("help A||help B", e, "29||34");
                  }}
                >
                  <div className="line_1" style={applyCss("help A")}>
                    {sliderDummyData.help_a}
                  </div>
                  <div className="line_2" style={applyCss("help B")}>
                    {sliderDummyData.help_b}
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_200" && (
              <div
                className="hoverDiv dental_vid_200 p-4 d-flex align-items-center   wdh_fix"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div
                  className="mid  text-white p-3 border"
                  onClick={(e) => {
                    toggleLeftContentshow(
                      "serve A||serve B||serve C",
                      e,
                      "19||19||20"
                    );
                  }}
                >
                  <div className="line_1 cursor" style={applyCss("serve A")}>
                    {sliderDummyData.serve_a}
                  </div>
                  <div className="line_2 cursor" style={applyCss("serve B")}>
                    {sliderDummyData.serve_b}
                  </div>
                  <div className="line_3 cursor" style={applyCss("serve C")}>
                    {sliderDummyData.serve_c}
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_201" && (
              <div
                className="hoverDiv dental_vid_201 p-4 d-flex align-items-center   wdh_fix"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div
                  className="mid  text-white p-3 border"
                  onClick={(e) => {
                    toggleLeftContentshow("need A||need B", e, "22||24");
                  }}
                >
                  <div className="line_1" style={applyCss("need A")}>
                    {sliderDummyData.need_a}
                  </div>
                  <div className="line_2" style={applyCss("need B")}>
                    {sliderDummyData.need_b}
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_202" && (
              <div
                className="hoverDiv dental_vid_202 p-4 d-flex align-items-center   wdh_fix"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div
                  className="mid  text-white border"
                  onClick={(e) => {
                    toggleLeftContentshow("help A", e, "31");
                  }}
                >
                  <div className="line_1" style={applyCss("help A")}>
                    {sliderDummyData.help_a}
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_203" && (
              <div
                className="hoverDiv dental_vid_203 p-4 d-flex align-items-center justify-content-center   wdh_fix"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div
                  className="mid text-center  text-white  border"
                  onClick={(e) => {
                    toggleLeftContentshow("need A", e, "31");
                  }}
                >
                  <div className="line_1" style={applyCss("need A")}>
                    {sliderDummyData.need_a}
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_204" && (
              <div
                className="hoverDiv dental_vid_204 p-4 d-flex align-items-center justify-content-center  wdh_fix "
                style={{
                  backgroundImage: `url("${sliderDummyData.bg_image}")`,
                }}
              >
                <a
                  href="#0"
                  className="changeImageVideo"
                  onClick={(e) => {
                    toggleRightshow("bg_image", e);
                  }}
                >
                  <img
                    src={`${process.env.PUBLIC_URL}/assets/images/edit_hv.png`}
                    alt="img"
                  />{" "}
                  Change Background Image
                </a>
                <div className="mid text-center text-white">
                  <div className="logo mb-4 pb-3 border">
                    <img
                      src={sliderDummyData.logo}
                      className="img-fluid"
                      alt="img"
                      onClick={(e) => {
                        toggleRightshow("logo", e);
                      }}
                    />
                  </div>
                  <div
                    className="line_1 mb-4 border"
                    onClick={(e) => {
                      toggleLeftContentshow("help A", e, "41");
                    }}
                    style={applyCss("help A")}
                  >
                    {sliderDummyData.help_a}
                  </div>
                  <div
                    className="line_2 mb-2 border"
                    onClick={(e) => {
                      toggleLeftContentshow("number", e, "15");
                    }}
                  >
                    <i>
                      <img
                        src="https://d37q3r06begyqi.cloudfront.net/VidAmaze/app-images/slides_images/phone12.png"
                        alt="img"
                      />
                    </i>{" "}
                    <span style={applyCss("number")}>
                      {sliderDummyData.number}
                    </span>
                  </div>
                  <div
                    className="border line_3"
                    onClick={(e) => {
                      toggleLeftContentshow("website", e, "35");
                    }}
                  >
                    <i>
                      <img
                        src="https://d37q3r06begyqi.cloudfront.net/VidAmaze/app-images/slides_images/web11.png"
                        width="20"
                        alt="img"
                      />
                    </i>{" "}
                    <span style={applyCss("website")}>
                      {sliderDummyData.website}
                    </span>
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_213" && (
              <div
                className="hoverDiv electrician_vid_213 p-4 d-flex align-items-center justify-content-center  wdh_fix"
                style={{
                  backgroundImage: `url("${sliderDummyData.bg_image}")`,
                }}
              >
                <a
                  href="#0"
                  className="changeImageVideo"
                  onClick={(e) => {
                    toggleRightshow("bg_image", e);
                  }}
                >
                  <img
                    src={`${process.env.PUBLIC_URL}/assets/images/edit_hv.png`}
                    alt="img"
                  />{" "}
                  Change Background Image
                </a>
                <div className="mid text-center text-white">
                  <div
                    className="line_1 cursor"
                    onClick={(e) => {
                      toggleLeftContentshow("hey", e, "10");
                    }}
                    style={applyCss("hey")}
                  >
                    {sliderDummyData.hey}
                  </div>
                  <div className=" line_2 dynamic_text">{dynamicText}</div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_214" && (
              <div
                className="hoverDiv electrician_vid_214 p-4 d-flex align-items-center justify-content-center  wdh_fix"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div
                  className="mid text-center text-white border"
                  onClick={(e) => {
                    toggleLeftContentshow(
                      "serve A||serve B||serve C",
                      e,
                      "23||35||18"
                    );
                  }}
                >
                  <div className="line_1 cursor" style={applyCss("serve A")}>
                    {sliderDummyData.serve_a}
                  </div>
                  <div className="line_2 cursor" style={applyCss("serve B")}>
                    {sliderDummyData.serve_b}
                  </div>
                  <div className="line_3 cursor" style={applyCss("serve C")}>
                    {sliderDummyData.serve_c}
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_215" && (
              <div
                className="hoverDiv electrician_vid_215 p-4 d-flex align-items-center justify-content-center  wdh_fix"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div
                  className="mid text-center text-white  border"
                  onClick={(e) => {
                    toggleLeftContentshow("help A||help B", e, "22||43");
                  }}
                >
                  <div className="line_1 cursor" style={applyCss("help A")}>
                    {sliderDummyData.help_a}
                  </div>
                  <div className="line_2 cursor" style={applyCss("help B")}>
                    {sliderDummyData.help_b}
                  </div>{" "}
                </div>
              </div>
            )}

            {active_slide_name === "slide_216" && (
              <div
                className="hoverDiv electrician_vid_216 p-4 d-flex align-items-center justify-content-center  wdh_fix"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div
                  className="mid text-center text-white border"
                  onClick={(e) => {
                    toggleLeftContentshow("need A||need B", e, "29||39");
                  }}
                >
                  <div className="line_1 cursor" style={applyCss("need A")}>
                    {sliderDummyData.need_a}
                  </div>
                  <div className="line_2 cursor" style={applyCss("need B")}>
                    {sliderDummyData.need_b}
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_217" && (
              <div
                className="hoverDiv electrician_vid_217 p-4 d-flex align-items-center justify-content-center  wdh_fix"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div
                  className="mid text-center text-white border"
                  onClick={(e) => {
                    toggleLeftContentshow(
                      "serve A||serve B||serve C",
                      e,
                      "30||28||28"
                    );
                  }}
                >
                  <div className="line_1 cursor" style={applyCss("serve A")}>
                    {sliderDummyData.serve_a}
                  </div>
                  <div className="line_2 cursor" style={applyCss("serve B")}>
                    {sliderDummyData.serve_b}
                  </div>
                  <div className="line_3 cursor" style={applyCss("serve C")}>
                    {sliderDummyData.serve_c}
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_218" && (
              <div
                className="hoverDiv electrician_vid_218 p-4 d-flex align-items-center justify-content-center  wdh_fix"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div
                  className="mid text-center text-white border"
                  onClick={(e) => {
                    toggleLeftContentshow("help A||help B", e, "28||28");
                  }}
                >
                  <div className="line_1 cursor" style={applyCss("help A")}>
                    {sliderDummyData.help_a}
                  </div>
                  <div className="line_2 cursor" style={applyCss("help B")}>
                    {sliderDummyData.help_b}
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_219" && (
              <div
                className="hoverDiv electrician_vid_219 p-4 d-flex align-items-center justify-content-center  wdh_fix"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div
                  className="mid text-center text-white border"
                  onClick={(e) => {
                    toggleLeftContentshow("help A", e, "35");
                  }}
                >
                  <div className="line_1 cursor" style={applyCss("help A")}>
                    {sliderDummyData.help_a}
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_220" && (
              <div
                className="hoverDiv electrician_vid_220 p-4 d-flex align-items-center justify-content-center  wdh_fix"
                style={{
                  backgroundImage: `url("${sliderDummyData.bg_image}")`,
                }}
              >
                <a
                  href="#0"
                  className="changeImageVideo"
                  onClick={(e) => {
                    toggleRightshow("bg_image", e);
                  }}
                >
                  <img
                    src={`${process.env.PUBLIC_URL}/assets/images/edit_hv.png`}
                    alt="img"
                  />{" "}
                  Change Background Image
                </a>
                <div className="mid text-white">
                  <div className="logo mb-4 pb-1 text-center">
                    <img
                      src={sliderDummyData.logo}
                      className="img-fluid"
                      alt="img"
                      onClick={(e) => {
                        toggleRightshow("logo", e);
                      }}
                    />
                  </div>
                  <div
                    className="line_1 mb-4 text-center border"
                    onClick={(e) => {
                      toggleLeftContentshow("help A", e, "35");
                    }}
                    style={applyCss("help A")}
                  >
                    {sliderDummyData.help_a}
                  </div>
                  <div className="d-flex justify-content-center">
                    <div className="rw">
                      <div
                        className="line_2 mb-2 border"
                        onClick={(e) => {
                          toggleLeftContentshow("number", e, "15");
                        }}
                      >
                        <i>
                          <img
                            src="https://d37q3r06begyqi.cloudfront.net/VidAmaze/app-images/slides_images/phone12.png"
                            alt="img"
                          />
                        </i>{" "}
                        <span style={applyCss("number")}>
                          {sliderDummyData.number}
                        </span>
                      </div>
                      <div
                        className="line_3 border"
                        onClick={(e) => {
                          toggleLeftContentshow("website", e, "35");
                        }}
                      >
                        <i>
                          <img
                            src="https://d37q3r06begyqi.cloudfront.net/VidAmaze/app-images/slides_images/web11.png"
                            alt="img"
                          />
                        </i>{" "}
                        <span style={applyCss("website")}>
                          {sliderDummyData.website}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_221" && (
              <div
                className="hoverDiv pestcontrol_vid_221 p-4 d-flex align-items-center justify-content-center  wdh_fix"
                style={{
                  backgroundImage: `url("${sliderDummyData.bg_image}")`,
                }}
              >
                <a
                  href="#0"
                  className="changeImageVideo"
                  onClick={(e) => {
                    toggleRightshow("bg_image", e);
                  }}
                >
                  <img
                    src={`${process.env.PUBLIC_URL}/assets/images/edit_hv.png`}
                    alt="img"
                  />{" "}
                  Change Background Image
                </a>
                <div className="mid text-center text-white">
                  <div
                    className="line_1 border  cursor"
                    onClick={(e) => {
                      toggleLeftContentshow("hey", e, "10");
                    }}
                    style={applyCss("hey")}
                  >
                    {sliderDummyData.hey}
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_222" && (
              <div
                className="hoverDiv pestcontrol_vid_222 p-4 d-flex align-items-center justify-content-center  wdh_fix"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div
                  className="mid text-center text-white border"
                  onClick={(e) => {
                    toggleLeftContentshow(
                      "serve A||serve B||serve C",
                      e,
                      "22||29||25"
                    );
                  }}
                >
                  <div className="line_1 cursor" style={applyCss("serve A")}>
                    {sliderDummyData.serve_a}
                  </div>
                  <div className="line_2 cursor" style={applyCss("serve B")}>
                    {sliderDummyData.serve_b}
                  </div>
                  <div className="line_3 cursor" style={applyCss("serve C")}>
                    {sliderDummyData.serve_c}
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_223" && (
              <div
                className="hoverDiv pestcontrol_vid_223 p-4 d-flex  justify-content-center  wdh_fix"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div className="mid text-center">
                  <div
                    className="line_1 pt-4  border"
                    onClick={(e) => {
                      toggleLeftContentshow("help A", e, "34");
                    }}
                    style={applyCss("help A")}
                  >
                    {sliderDummyData.help_a}
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_224" && (
              <div
                className="hoverDiv pestcontrol_vid_224 p-4 d-flex  justify-content-center  wdh_fix"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div className="mid text-center">
                  <div
                    className="line_1 pt-4  border"
                    onClick={(e) => {
                      toggleLeftContentshow("help A", e, "47");
                    }}
                    style={applyCss("help A")}
                  >
                    {sliderDummyData.help_a}
                  </div>
                </div>
              </div>
            )}
            {active_slide_name === "slide_225" && (
              <div
                className="hoverDiv pestcontrol_vid_225 p-4 d-flex align-items-center justify-content-center  wdh_fix"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div
                  className="mid text-center text-white  border"
                  onClick={(e) => {
                    toggleLeftContentshow("help A||help B", e, "36||37");
                  }}
                >
                  <div className="line_1 cursor" style={applyCss("help A")}>
                    {sliderDummyData.help_a}
                  </div>
                  <div className="line_2 cursor" style={applyCss("help B")}>
                    {sliderDummyData.help_b}
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_226" && (
              <div
                className="hoverDiv pestcontrol_vid_226 p-4 d-flex align-items-center justify-content-center  wdh_fix"
                style={previewvideo("bg_video")}
              >
                <HoveDiv />
                <div
                  className="mid text-center text-white border"
                  onClick={(e) => {
                    toggleLeftContentshow("help A||help B", e, "32||45");
                  }}
                >
                  <div className="line_1 cursor" style={applyCss("help A")}>
                    {sliderDummyData.help_a}
                  </div>
                  <div className="line_2 cursor" style={applyCss("help B")}>
                    {sliderDummyData.help_b}
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_227" && (
              <div
                className="hoverDiv pestcontrol_vid_227 p-4 d-flex align-items-center justify-content-center  wdh_fix"
                style={{
                  backgroundImage: `url("${sliderDummyData.bg_image}")`,
                }}
              >
                <a
                  href="#0"
                  className="changeImageVideo"
                  onClick={(e) => {
                    toggleRightshow("bg_image", e);
                  }}
                >
                  <img
                    src={`${process.env.PUBLIC_URL}/assets/images/edit_hv.png`}
                    alt="img"
                  />{" "}
                  Change Background Image
                </a>
                <div className="mid text-white">
                  <div className="logo mb-4 pb-1 text-center border">
                    <img
                      src={sliderDummyData.logo}
                      className="img-fluid"
                      alt="img"
                      onClick={(e) => {
                        toggleRightshow("logo", e);
                      }}
                    />
                  </div>
                  <div
                    className="line_1 mb-4 text-center  border"
                    onClick={(e) => {
                      toggleLeftContentshow("help A", e, "36");
                    }}
                    style={applyCss("help A")}
                  >
                    {sliderDummyData.help_a}
                  </div>
                  <div className="d-flex justify-content-center">
                    <div className="rw">
                      <div
                        className="line_2 mb-2 border"
                        onClick={(e) => {
                          toggleLeftContentshow("number", e, "15");
                        }}
                      >
                        <i>
                          <img
                            src="https://d37q3r06begyqi.cloudfront.net/VidAmaze/app-images/slides_images/phone12.png"
                            alt="img"
                          />
                        </i>{" "}
                        <span style={applyCss("number")}>
                          {sliderDummyData.number}
                        </span>
                      </div>
                      <div
                        className="line_3 border"
                        onClick={(e) => {
                          toggleLeftContentshow("website", e, "35");
                        }}
                      >
                        <i>
                          <img
                            src="https://d37q3r06begyqi.cloudfront.net/VidAmaze/app-images/slides_images/web11.png"
                            alt="img"
                          />
                        </i>{" "}
                        <span style={applyCss("website")}>
                          {sliderDummyData.website}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_233" && (
              <div
                className="hoverDiv slide_vid_233 p-4 d-flex align-items-center justify-content-center wdh_fix"
                // style={{
                //   backgroundImage: `url("https://engageleads-gallery.s3.us-west-2.amazonaws.com/VidAmaze/templates/Selling+Directory/slide_bg_233.jpg")`,
                // }}
              >
                <div className="mid text-center text-white">
                  <h1 
                    className="line_1 border text-uppercase" 
                    onClick={(e) => {
                      toggleLeftContentshow("hey", e, "10");
                    }}
                    style={applyCss("hey")}>{sliderDummyData.hey}</h1>
                  <div className="line_2">{dynamicText}</div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_234" && (
              <div
                className="hoverDiv slide_vid_234 p-4 d-flex align-items-center justify-content-center wdh_fix"
                // style={{
                //   backgroundImage: `url("https://engageleads-gallery.s3.us-west-2.amazonaws.com/VidAmaze/templates/Selling+Directory/slide_bg_233.jpg")`,
                // }}
              >
                <div 
                  className="mid text-center text-white border" 
                  onClick={(e) => {
                    toggleLeftContentshow("business A||business B", e, "32||45");
                  }}>
                  <div className="c">
                    <div className="line1">{sliderDummyData.business_a}</div> 
                    <div className="line2">{sliderDummyData.business_b}</div>
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_235" && (
              <div
                className="hoverDiv slide_vid_235 p-4 d-flex align-items-center justify-content-center wdh_fix"
                // style={{
                //   backgroundImage: `url("https://engageleads-gallery.s3.us-west-2.amazonaws.com/VidAmaze/templates/Selling+Directory/slide_bg_233.jpg")`,
                // }}
              >
                <div 
                  className="mid text-center text-white border" 
                  onClick={(e) => {
                    toggleLeftContentshow("demand A||demand B||demand C", e, "32||45||55");
                  }}>
                  <div className="c">
                    <div className="line1">{sliderDummyData.demand_a}</div> 
                    <div className="line2">{sliderDummyData.demand_b}</div>
                    <div className="line3">{sliderDummyData.demand_c}</div>
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_236" && (
              <div
                className="hoverDiv slide_vid_236 p-4 d-flex align-items-center justify-content-center wdh_fix"
                // style={{
                //   backgroundImage: `url("https://engageleads-gallery.s3.us-west-2.amazonaws.com/VidAmaze/templates/Selling+Directory/slide_bg_233.jpg")`,
                // }}
              >
                <div 
                  className="mid text-center text-white border" 
                  onClick={(e) => {
                    toggleLeftContentshow("further A", e, "55");
                  }}>
                  <div className="c">
                    <div className="line1">{sliderDummyData.further_a}</div> 
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_237" && (
              <div
                className="hoverDiv slide_vid_237 p-4 d-flex align-items-center justify-content-center wdh_fix"
                // style={{
                //   backgroundImage: `url("https://engageleads-gallery.s3.us-west-2.amazonaws.com/VidAmaze/templates/Selling+Directory/slide_bg_233.jpg")`,
                // }}
              >
                <div 
                  className="mid text-center text-white border" 
                  onClick={(e) => {
                    toggleLeftContentshow("serve A||serve B", e, "25||35");
                  }}>
                  <div className="c">
                    <div className="line1">{sliderDummyData.serve_a}</div> 
                    <div className="line2">{sliderDummyData.serve_b}</div> 
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_238" && (
              <div
                className="hoverDiv slide_vid_238 p-4 d-flex align-items-center justify-content-center wdh_fix"
                // style={{
                //   backgroundImage: `url("https://engageleads-gallery.s3.us-west-2.amazonaws.com/VidAmaze/templates/Selling+Directory/slide_bg_233.jpg")`,
                // }}
              >
                <div 
                  className="mid text-center text-white border" 
                  onClick={(e) => {
                    toggleLeftContentshow("need A", e, "25");
                  }}>
                  <div className="c">
                    <div className="line1">{sliderDummyData.need_a}</div> 
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_239" && (
              <div
                className="hoverDiv slide_vid_239 p-4 d-flex align-items-center justify-content-center wdh_fix"
                // style={{
                //   backgroundImage: `url("https://engageleads-gallery.s3.us-west-2.amazonaws.com/VidAmaze/templates/Selling+Directory/slide_bg_233.jpg")`,
                // }}
              >
                <div 
                  className="mid text-center text-white border" 
                  onClick={(e) => {
                    toggleLeftContentshow("work A||work B||work C", e, "25||35||45");
                  }}>
                  <div className="c">
                    <div className="line1">{sliderDummyData.work_a}</div> 
                    <div className="line2">{sliderDummyData.work_b}</div> 
                    <div className="line3">{sliderDummyData.work_c}</div> 
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_240" && (
              <div
                className="hoverDiv slide_vid_240 p-4 d-flex align-items-center justify-content-center wdh_fix"
              >
                
                <div className="mid text-white">
                  
                  <div className="c border"  onClick={(e) => {
                    toggleLeftContentshow("serve A||serve B||serve C", e, "25||35||45");
                  }}>
                    <div className="line1">{sliderDummyData.serve_a}</div> 
                    <div className="line2">{sliderDummyData.serve_b}</div> 
                    <div className="line3">{sliderDummyData.serve_c}</div> 
                  </div>
                  
                  <div className="offer_gallery">
                    <div className="cl border">
                      <img 
                         src={sliderDummyData.bg_image1}
                         className="img-fluid"
                         alt="img"
                         onClick={(e) => {
                           toggleRightshow("bg_image1", e);
                         }}
                      />
                    </div>
                    <div className="cl border">
                      <img 
                        src={sliderDummyData.bg_image2}
                        className="img-fluid"
                        alt="img"
                        onClick={(e) => {
                          toggleRightshow("bg_image2", e);
                        }} 
                      />
                    </div>
                    <div className="cl">
                      <img 
                        src={sliderDummyData.bg_image3}
                        className="img-fluid"
                        alt="img"
                        onClick={(e) => {
                          toggleRightshow("bg_image3", e);
                        }} 
                      />
                    </div>
                  </div> 
                </div>
              </div>
            )}

            {active_slide_name === "slide_241" && (
              <div
                className="hoverDiv slide_vid_241 p-4 d-flex align-items-center justify-content-center wdh_fix"
                // style={{
                //   backgroundImage: `url("https://engageleads-gallery.s3.us-west-2.amazonaws.com/VidAmaze/templates/Selling+Directory/slide_bg_233.jpg")`,
                // }}
              >
                <div 
                  className="mid text-center text-white border" 
                  onClick={(e) => {
                    toggleLeftContentshow("work A", e, "25");
                  }}>
                  <div className="c">
                    <div className="line1">{sliderDummyData.work_a}</div>
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_242" && (
              <div
                className="hoverDiv slide_vid_242 p-4 d-flex align-items-center justify-content-center wdh_fix"
                // style={{
                //   backgroundImage: `url("https://engageleads-gallery.s3.us-west-2.amazonaws.com/VidAmaze/templates/Selling+Directory/slide_bg_233.jpg")`,
                // }}
              >
                <div 
                  className="mid text-center text-white border" 
                  onClick={(e) => {
                    toggleLeftContentshow("work A||work B", e, "25||35");
                  }}>
                  <div className="c">
                    <div className="line1">{sliderDummyData.work_a}</div> 
                    <div className="line2">{sliderDummyData.work_b}</div> 
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_243" && (
              <div
                className="hoverDiv slide_vid_243 p-4 d-flex align-items-center justify-content-center wdh_fix"
                // style={{
                //   backgroundImage: `url("https://engageleads-gallery.s3.us-west-2.amazonaws.com/VidAmaze/templates/Selling+Directory/slide_bg_233.jpg")`,
                // }}
              >
                <div 
                  className="mid text-center text-white border" 
                  onClick={(e) => {
                    toggleLeftContentshow("work A", e, "25");
                  }}>
                  <div className="c">
                    <div className="line1">{sliderDummyData.work_a}</div>
                  </div>
                </div>
              </div>
            )}

            {active_slide_name === "slide_244" && (
              <div
                className="hoverDiv slide_vid_244 p-4 d-flex align-items-center justify-content-center  wdh_fix"
                style={{
                  backgroundImage: `url("${sliderDummyData.bg_image}")`,
                }}
              >
                <a
                  href="#0"
                  className="changeImageVideo"
                  onClick={(e) => {
                    toggleRightshow("bg_image", e);
                  }}
                >
                  <img
                    src={`${process.env.PUBLIC_URL}/assets/images/edit_hv.png`}
                    alt="img"
                  />{" "}
                  Change Background Image
                </a>
                <div className="mid text-white">
                  
                  <div className="c">
                    <div className="logo border">
                      <img
                        src={sliderDummyData.logo}
                        className="img-fluid"
                        alt="img"
                        onClick={(e) => {
                          toggleRightshow("logo", e);
                        }}
                      />
                    </div>  
                    <div className="line2 border">
                      <i>
                        <img 
                          src="https://engageleads-gallery.s3.us-west-2.amazonaws.com/VidAmaze/templates/Selling+Directory/call.png" 
                          className="img-fluid"  
                          alt="img" />
                      </i> <span onClick={(e) => {
                          toggleLeftContentshow("number", e, "15");
                        }}>{sliderDummyData.number}</span>
                    </div> 
                    <div className="line2 border">
                      <i>
                        <img 
                          src="https://engageleads-gallery.s3.us-west-2.amazonaws.com/VidAmaze/templates/Selling+Directory/web.png" 
                          className="img-fluid"  
                          alt="img" />
                      </i> <span  onClick={(e) => {
                          toggleLeftContentshow("website", e, "15");
                        }}>{sliderDummyData.website}</span>
                    </div> 
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
        <div className="es_mid_1">
          <div>
            {sliderDummyData.bg_video && active_slide_name && (
              <>
                <p>Background Video Preview</p>
                <video
                  src={sliderDummyData.bg_video}
                  loop
                  height="100"
                  width="100%"
                  onMouseOver={playMovie}
                  onMouseOut={stopMovie}
                />
              </>
            )}
          </div>
        </div>

        {!active_slide_name && (
          <h1 className="p-3 text-center">Please Select Slide</h1>
        )}
      </div>
    </>
  );
};

export default EditorDiv;
